// Generated by Avo VERSION 184.27.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true;
        } catch (e) {
          return false;
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self,
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj);
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]',
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name');
    }
    return name.toLowerCase();
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value;
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value };
      },
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator;
      };
    }

    return iterator;
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name));
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items);
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items);
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items);
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    });
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise;
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('');
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0);
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer;
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode);
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse);
    };

    // @ts-ignore
    return this;
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read');
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests');
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit });
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form;
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers;
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url,
    });
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response;
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code');
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } });
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'));
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || ''),
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = 'prod',
  Dev = 'dev',
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (groupType: string, groupId: string, groupProperties: Record<string, any>) => void;
  addCurrentUserToGroup?: (groupType: string, groupId: string, groupProperties: Record<string, any>) => void;
  logEventWithGroups?: (eventName: string, eventProperties: any, groupTypesToGroupIds: Record<string, string>) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[];
  shape?: any;
  shapeUserProps?: any;
  actualType?: string;
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = 'Ilyfmx65IfseJIx0bvUJ';
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;

// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign(target: any, _varArgs: any) {
      // .length of function is 2
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true,
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = 'BottomRight',
  BottomLeft = 'BottomLeft',
  TopRight = 'TopRight',
  TopLeft = 'TopLeft',
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
};

let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message =
      'Event Sent:' +
      eventName +
      'Event Props:' +
      JSON.stringify(eventProperties) +
      'User Props:' +
      JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return;
    }
    typeof console !== 'undefined' &&
      console.log('[avo] Event Sent:', eventName, 'Event Props:', eventProperties, 'User Props:', userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return;
    }
    typeof console !== 'undefined' && console.log('[avo] ' + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return;
    }
    typeof console !== 'undefined' && console.warn('[avo] ' + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return;
    }
    typeof console !== 'undefined' && console.error('[avo] ' + message, error);
  },
};

function convertPropertiesArrayToMap(propertiesArray: [{ id: string; name: string; value: string }]): {
  string: string | null | undefined;
} {
  let result: { string: string } = {};

  propertiesArray.forEach((value) => {
    result[value.name] = value.value;
  });

  return result;
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
};

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message =
        propName +
        ' should be of type object but you provided type ' +
        typeof obj +
        ' with value ' +
        JSON.stringify(obj);
      return [{ tag: 'expectedObjectType', propertyId, message, actualType: typeof obj }];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message =
        propName +
        ' should be of type string but you provided type ' +
        typeof str +
        ' with value ' +
        JSON.stringify(str);
      return [{ tag: 'expectedStringType', propertyId, message, actualType: typeof str }];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName + ' should be of type int but you provided type float with value ' + JSON.stringify(int);
      return [{ tag: 'expectedIntType', propertyId, message, actualType: 'float' }];
    } else if (typeof int !== 'number') {
      let message =
        propName + ' should be of type int but you provided type ' + typeof int + ' with value ' + JSON.stringify(int);
      return [{ tag: 'expectedIntType', propertyId, message, actualType: typeof int }];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName + ' should be of type long but you provided type float with value ' + JSON.stringify(long);
      return [{ tag: 'expectedLongType', propertyId, message, actualType: 'float' }];
    } else if (typeof long !== 'number') {
      let message =
        propName +
        ' should be of type long but you provided type ' +
        typeof long +
        ' with value ' +
        JSON.stringify(long);
      return [{ tag: 'expectedLongType', propertyId, message, actualType: typeof long }];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message =
        propName +
        ' should be of type float but you provided type ' +
        typeof float +
        ' with value ' +
        JSON.stringify(float);
      return [{ tag: 'expectedFloatType', propertyId, message, actualType: typeof float }];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message =
        propName +
        ' should be of type boolean but you provided type ' +
        typeof bool +
        ' with value ' +
        JSON.stringify(bool);
      return [{ tag: 'expectedBoolType', propertyId, message, actualType: typeof bool }];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(propertyId: string, propName: string, max: number, value: number) {
    if (value > max) {
      let message =
        propName + ' has a maximum value of ' + max + ' but you provided the value ' + JSON.stringify(value);
      return [{ tag: 'expectedMax', propertyId, message }];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(propertyId: string, propName: string, min: number, value: number) {
    if (value < min) {
      let message =
        propName + ' has a minimum value of ' + min + ' but you provided the value ' + JSON.stringify(value);
      return [{ tag: 'expectedMin', propertyId, message }];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{ tag: 'expectedList', propertyId, message }];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(
    eventName: string,
    input: string[],
    spec: string[],
  ) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = 'Additional properties when sending event ' + eventName + ': ' + JSON.stringify(additionalKeys);
      return [{ tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message }];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(
    eventName: string,
    input: string[],
    spec: string[],
  ) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message =
        'Additional user properties when sending event ' + eventName + ': ' + JSON.stringify(additionalKeys);
      return [{ tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message }];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(
  env: AvoEnv,
  eventId: string,
  hash: string,
  messages: { tag: string; propertyId: string }[],
  origin: string,
) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') {
    return;
  }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch('https://api.avo.app/i', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ac: 'EOrHYD1YlHdDoLck9Knn',
          br: '9Qo95R7tg',
          en: env,
          ev: eventId,
          ha: hash,
          sc: '6POyHovCvydDkrmCrKkd',
          se: new Date().toISOString(),
          so: '4Q0BGZhckM',
          va: messages.length === 0,
          me: messages,
          or: origin,
        }),
      })
        .then(function (res: any) {
          return res.json();
        })
        .then(function (data: any) {
          _avo_sampling_rate = data.sa;
        })
        .catch(function () {});
    }
  }
};

_avo_invoke_meta = function _avo_invoke_meta(
  env: AvoEnv,
  type: string,
  messages: { tag: string; propertyId: string }[],
  origin: string,
) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') {
    return;
  }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch('https://api.avo.app/i', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ac: 'EOrHYD1YlHdDoLck9Knn',
          br: '9Qo95R7tg',
          en: env,
          ty: type,
          sc: '6POyHovCvydDkrmCrKkd',
          se: new Date().toISOString(),
          so: '4Q0BGZhckM',
          va: messages.length === 0,
          me: messages,
          or: origin,
        }),
      })
        .then(function (res: any) {
          return res.json();
        })
        .then(function (data: any) {
          _avo_sampling_rate = data.sa;
        })
        .catch(function () {});
    }
  }
};

let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://www.avo.app') {
      return;
    }
    let iframe: any = document.getElementById('avo-debugger');
    if (iframe && event && event.data && event.data.type_ === 'avo-debugger-update-style') {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === 'avo-debugger-ready') {
      let message = {
        type_: 'avo-debugger-boot-events',
        schemaId: '6POyHovCvydDkrmCrKkd',
        href: window.location.href,
        events: _avo_debugger_events_during_boot,
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, 'https://www.avo.app/_debugger');
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(
  eventId: string,
  eventName: string,
  messages: any[],
  eventProperties: any[],
  userProperties: any[],
  groupProperties: any[],
) {
  if (typeof (window as any) === 'undefined') {
    return;
  }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties,
  };

  if (_avo_debugger_ready) {
    let message = { type_: 'avo-debugger-events', events: [event] };
    (document.getElementById('avo-debugger') as any).contentWindow.postMessage(
      message,
      'https://www.avo.app/_debugger',
    );
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
};

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') {
    return;
  }
  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://www.avo.app') {
      return;
    }
    if (event.data.type_ === 'avo-debugger-ready' && position !== null) {
      var message = { type_: 'avo-debugger-position', position: position };
      document.getElementById('avo-debugger').contentWindow.postMessage(message, 'https://www.avo.app/_debugger');
    }
  });
}

export interface FromAssets {
  assetId: number;
  assetCode: string;
}

export interface TradeFromAssets {
  amount: number | null | undefined;
  assetId: number;
  assetCode: string;
  portion: number;
}

export interface FromAssetsBefore {
  assetId: number;
  assetCode: string;
}

export interface TradeToAssets {
  assetId: number;
  assetCode: string;
  amount: number | null | undefined;
  portion: number;
}

export interface Orders {
  fromAssetCodes: string[];
  fromAssetIds: number[];
  percentages: number[] | null | undefined;
  toAssetCodes: string[];
  toAssetIds: number[];
  fromQtys: number[] | null | undefined;
  toQtys: number[] | null | undefined;
  triggerPrices: number[] | null | undefined;
  feePerUnits: number[] | null | undefined;
}

export interface ToAssetsAfter {
  assetId: number;
  assetCode: string;
}

export interface ToAssets {
  assetId: number;
  assetCode: string;
}

export interface FromAssetsAfter {
  assetCode: string;
  assetId: number;
}

export interface ToAssetsBefore {
  assetId: number;
  assetCode: string;
}

export interface Price {}

export const PurposeOfLoan = {
  PURCHASING_A_GIFT: 'Purchasing a gift',
  INVESTMENT: 'Investment',
  HOME_IMPROVEMENTS: 'Home improvements',
  PURCHASE_REAL_ESTATE: 'Purchase real estate',
  HOLIDAY: 'Holiday',
  DEBT_CONSILIDATION: 'Debt consilidation',
  CAR_PURCHASE: 'Car purchase',
  OTHER: 'Other',
} as const;
export type PurposeOfLoanType = typeof PurposeOfLoan;
export type PurposeOfLoanValueType = PurposeOfLoanType[keyof PurposeOfLoanType];

export const ErrorLinkType = {
  BALANCE_TOO_LOW: 'balanceTooLow',
  INSUFFICIENT_FUNDS: 'insufficientFunds',
  LESS_THAN_MIN: 'lessThanMin',
  MORE_THAN_MAX: 'moreThanMax',
} as const;
export type ErrorLinkTypeType = typeof ErrorLinkType;
export type ErrorLinkTypeValueType = ErrorLinkTypeType[keyof ErrorLinkTypeType];

export const NavigationComponent = {
  APP_QUICK_ACTIONS: 'App Quick Actions',
  APP_TAB_BAR: 'App Tab Bar',
  APP_TOP_NAV: 'App Top Nav',
  WEB_HEADER: 'Web Header',
  WEB_SIDE_MENU: 'Web Side Menu',
} as const;
export type NavigationComponentType = typeof NavigationComponent;
export type NavigationComponentValueType = NavigationComponentType[keyof NavigationComponentType];

export const MarketTickerSort = {
  GAINERS: 'Gainers',
  LOSERS: 'Losers',
  MARKET_CAP: 'Market cap',
  NEW_LISTINGS: 'New listings',
  FAVOURITES: 'Favourites',
  OWNED: 'Owned',
} as const;
export type MarketTickerSortType = typeof MarketTickerSort;
export type MarketTickerSortValueType = MarketTickerSortType[keyof MarketTickerSortType];

export const LoanType = {
  FIXED_TERM: 'Fixed Term',
  LINE_OF_CREDIT: 'Line of Credit',
} as const;
export type LoanTypeType = typeof LoanType;
export type LoanTypeValueType = LoanTypeType[keyof LoanTypeType];

export const RegistrationAccountTypeSelected = {
  PERSONAL: 'personal',
  ENTITY: 'entity',
} as const;
export type RegistrationAccountTypeSelectedType = typeof RegistrationAccountTypeSelected;
export type RegistrationAccountTypeSelectedValueType =
  RegistrationAccountTypeSelectedType[keyof RegistrationAccountTypeSelectedType];

export const CallToActionName = {
  CREATE_ENTITY_ACCOUNT: 'Create entity account',
  RESUME_ENTITY_SETUP: 'Resume entity setup',
  CREATE_ENTITY_HEADERNAV_CALL_TO_ACTION: 'Create Entity HeaderNav call to action',
  CREATE_ENTITY_APP_HEADER_BUTTON: 'Create Entity App Header Button',
} as const;
export type CallToActionNameType = typeof CallToActionName;
export type CallToActionNameValueType = CallToActionNameType[keyof CallToActionNameType];

export const CallToActionLocation = {
  APP_HEADER: 'app_header',
  APPLICATION_STEPPER: 'application_stepper',
  SELECT_ENTITY_TYPE_PAGE: 'select_entity_type_page',
} as const;
export type CallToActionLocationType = typeof CallToActionLocation;
export type CallToActionLocationValueType = CallToActionLocationType[keyof CallToActionLocationType];

export const TileName = {
  CREATE_ENTITY_ACCOUNT: 'Create entity account',
  SWYFTX_LEARN: 'Swyftx Learn',
  SECURE_YOUR_ACCOUNT: 'Secure your account',
  REFER_A_FRIEND: 'Refer a friend',
  SETUP_2FA: 'Setup 2FA',
  AUTO_INVEST: 'Auto Invest',
} as const;
export type TileNameType = typeof TileName;
export type TileNameValueType = TileNameType[keyof TileNameType];

export const EntityType = {
  PERSONAL: 'PERSONAL',
  COMPANY: 'COMPANY',
  TRUST: 'TRUST',
  SMSF: 'SMSF',
  JOINT: 'JOINT',
  SOLETRADER: 'SOLETRADER',
  OTHER: 'OTHER',
} as const;
export type EntityTypeType = typeof EntityType;
export type EntityTypeValueType = EntityTypeType[keyof EntityTypeType];

export const TableName = {
  ASSET_PICKER: 'Asset Picker',
  WALLETS: 'Wallets',
  OPEN_ORDERS: 'Open Orders',
  ORDER_HISTORY: 'Order History',
} as const;
export type TableNameType = typeof TableName;
export type TableNameValueType = TableNameType[keyof TableNameType];

export const TemplateSource = {
  DEPOSIT: 'DEPOSIT',
  ACCOUNT: 'ACCOUNT',
} as const;
export type TemplateSourceType = typeof TemplateSource;
export type TemplateSourceValueType = TemplateSourceType[keyof TemplateSourceType];

export const ModalName = {
  DEPOSIT_WITHDRAWAL_MODAL: 'Deposit/Withdrawal Modal',
  WITHDRAWAL_ADDRESS_ACKNOWLEDGEMENT: 'Withdrawal Address Acknowledgement',
  WITHDRAWAL_ADDRESS_BLOCKED_POPUP: 'Withdrawal Address Blocked Popup',
  LOAN_POST_APPLICATION_POPUP: 'Loan Post-Application Popup',
  ABOUT_CATEGORY: 'About Category',
  AFFILIATE_SIGN_UP: 'Affiliate Sign Up',
  ASSET_DISCOVERY_CATEGORY_PORTFOLIO_MODAL: 'Asset Discovery Category Portfolio Modal',
  ASSET_DISCOVERY_CATEGORY_TRENDING_MODAL: 'Asset Discovery Category Trending Modal',
  CHANGE_PASSWORD: 'Change Password',
  DASHBOARD_LAYOUT_SELECTOR: 'Dashboard Layout Selector',
  DEMO_MODE_LEARN_MORE: 'Demo Mode Learn More',
  DEPOSIT_ADDRESS_CHANGES: 'Deposit Address Changes',
  DEPOSIT_MODAL: 'Deposit Modal',
  DISABLE_TWO_FACTOR_AUTHENTICATION: 'Disable Two-Factor Authentication',
  DUSTING: 'Dusting',
  EDIT_TRIGGER_ORDER_ANNOUNCEMENT: 'Edit Trigger Order Announcement',
  EDIT_TRIGGER_ORDERS: 'Edit Trigger Orders',
  ENABLE_TWO_FACTOR_AUTHENTICATION: 'Enable Two-Factor Authentication',
  GLOBAL_SEARCH: 'Global Search',
  HIGH_SLIPPAGE_REVIEW: 'High Slippage Review',
  MULTI_TRADE_LIMITATION: 'Multi Trade Limitation',
  NEXT_DUST_TIME: 'Next Dust Time',
  OTC_TRADES_PERMISSION: 'OTC Trades Permission',
  ORDER_DETAILS: 'Order Details',
  PRICE_ALERTS: 'Price Alerts',
  PROFIT_STOP_LOSS: 'Profit Stop Loss',
  PROFIT_STOP_LOSS_SUCCESS: 'Profit Stop Loss Success',
  REDEEM_SWYFTX_ENTRY: 'Redeem Swyftx Entry',
  REDEEM_SWYFTX_REWARD: 'Redeem Swyftx Reward',
  RESTRICTED_ACCESS: 'Restricted Access',
  SMS_RECOVERY: 'SMS Recovery',
  STRIPE_CARD_DEPOSIT: 'Stripe Card Deposit',
  SWITCH_ACCOUNT: 'Switch Account',
  TRANSACTION_DETAILS: 'Transaction Details',
  UPDATE_EMAIL_ADDRESS: 'Update Email Address',
  UPDATE_PHONE_NUMBER: 'Update Phone Number',
  VERIFY_PHONE_NUMBER: 'Verify Phone Number',
  WHATS_NEW: "What's New",
  WITHDRAWAL_MODAL: 'Withdrawal Modal',
  DERIVATIVES_BALANCE_ADJUSTMENT_DETAILS: 'Derivatives Balance Adjustment Details',
  DERIVATIVES_HISTORY_DETAILS: 'Derivatives History Details',
  DERIVATIVES_POSITION_DETAILS: 'Derivatives Position Details',
  DERIVATIVES_POSITION_DETAILS_DELETE_PENDING_ORDER: 'Derivatives Position Details Delete Pending Order',
  DERIVATIVES_TRANSACTION_DETAILS: 'Derivatives Transaction Details',
} as const;
export type ModalNameType = typeof ModalName;
export type ModalNameValueType = ModalNameType[keyof ModalNameType];

export const VerificationStep = {
  MOBILE_VERIFICATION: 'Mobile verification',
  EMAIL_VERIFICATION: 'Email verification',
  GREENID_VERIFICATION: 'GreenID Verification',
  JUMIO_VERIFICATION: 'Jumio Verification',
} as const;
export type VerificationStepType = typeof VerificationStep;
export type VerificationStepValueType = VerificationStepType[keyof VerificationStepType];

export const GlobalSearchOpenMethod = {
  MANUAL_CLICK: 'Manual click',
  __SHORTCUT: "' / ' shortcut",
} as const;
export type GlobalSearchOpenMethodType = typeof GlobalSearchOpenMethod;
export type GlobalSearchOpenMethodValueType = GlobalSearchOpenMethodType[keyof GlobalSearchOpenMethodType];

export const Error = {
  TRADE_NOT_ENABLED: 'TradeNotEnabled',
  INSUFFICIENT_BALANCE: 'InsufficientBalance',
  TOO_MANY_ASSETS: 'TooManyAssets',
  INVALID_TRADE_STATE: 'InvalidTradeState',
} as const;
export type ErrorType = typeof Error;
export type ErrorValueType = ErrorType[keyof ErrorType];

export const MarketTickerVisibleAssets = {
  FAVOURITES: 'Favourites',
  OWNED: 'Owned',
} as const;
export type MarketTickerVisibleAssetsType = typeof MarketTickerVisibleAssets;
export type MarketTickerVisibleAssetsValueType = MarketTickerVisibleAssetsType[keyof MarketTickerVisibleAssetsType];

export const TableSortDirection = {
  ASCENDING: 'Ascending',
  DESCENDING: 'Descending',
} as const;
export type TableSortDirectionType = typeof TableSortDirection;
export type TableSortDirectionValueType = TableSortDirectionType[keyof TableSortDirectionType];

export const MarketTickerVariant = {
  STATIC: 'Static',
  SCROLLING: 'Scrolling',
} as const;
export type MarketTickerVariantType = typeof MarketTickerVariant;
export type MarketTickerVariantValueType = MarketTickerVariantType[keyof MarketTickerVariantType];

export const ReveriDvsStatus = {
  FAILED: 'FAILED',
  FAILED_DUPLICATE: 'FAILED_DUPLICATE',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_STARTED: 'NOT_STARTED',
  VERIFIED: 'VERIFIED',
  VERIFIED_UNDERAGE: 'VERIFIED_UNDERAGE',
  PENDING_REVIEW: 'PENDING_REVIEW',
} as const;
export type ReveriDvsStatusType = typeof ReveriDvsStatus;
export type ReveriDvsStatusValueType = ReveriDvsStatusType[keyof ReveriDvsStatusType];

export const LoanTypeFe = {
  CREDIT_LINE: 'Credit Line',
  FIXED_TERM: 'Fixed Term',
} as const;
export type LoanTypeFeType = typeof LoanTypeFe;
export type LoanTypeFeValueType = LoanTypeFeType[keyof LoanTypeFeType];

export const QuickFilterUsed = {
  OWNED: 'Owned',
  FAVOURITES: 'Favourites',
  NEW: 'New',
  ALL_ASSETS: 'All assets',
  GAINERS: 'Gainers',
  LOSERS: 'Losers',
  BUNDLES: 'Bundles',
} as const;
export type QuickFilterUsedType = typeof QuickFilterUsed;
export type QuickFilterUsedValueType = QuickFilterUsedType[keyof QuickFilterUsedType];

export const MemberType = {
  SHAREHOLDER: 'Shareholder',
  INDIVIDUAL_TRUSTEE: 'Individual Trustee',
  CORPORATE_TRUSTEE: 'Corporate Trustee',
  MEMBER: 'Member',
  DIRECTOR: 'Director',
  BENEFICIARY: 'Beneficiary',
} as const;
export type MemberTypeType = typeof MemberType;
export type MemberTypeValueType = MemberTypeType[keyof MemberTypeType];

export const AssetType = {
  FIAT: 'FIAT',
  CRYPTO: 'CRYPTO',
} as const;
export type AssetTypeType = typeof AssetType;
export type AssetTypeValueType = AssetTypeType[keyof AssetTypeType];

export const ChartType = {
  TRADING_VIEW: 'TradingView',
  SIMPLE_CHARTS: 'Simple Charts',
} as const;
export type ChartTypeType = typeof ChartType;
export type ChartTypeValueType = ChartTypeType[keyof ChartTypeType];

export const TradeType = {
  INSTANTLY: 'Instantly',
  RECURRING: 'Recurring',
  ON_TRIGGER: 'On trigger',
  MARKET: 'Market',
  TRIGGER: 'Trigger',
  OCO: 'OCO',
} as const;
export type TradeTypeType = typeof TradeType;
export type TradeTypeValueType = TradeTypeType[keyof TradeTypeType];

export const QuickBuyPresetAmount = {
  _10: '$10',
  _25: '$25',
  _100: '$100',
  _250: '$250',
  MAX: 'Max',
  '15': '15%',
  '25': '25%',
  '50': '50%',
  '75': '75%',
  '100': '100%',
} as const;
export type QuickBuyPresetAmountType = typeof QuickBuyPresetAmount;
export type QuickBuyPresetAmountValueType = QuickBuyPresetAmountType[keyof QuickBuyPresetAmountType];

export const TooltipType = {
  TEXT: 'Text',
  IMAGE: 'Image',
} as const;
export type TooltipTypeType = typeof TooltipType;
export type TooltipTypeValueType = TooltipTypeType[keyof TooltipTypeType];

export const MenuLabel = {
  ASSETS: 'Assets',
  AUTO_INVEST: 'Auto Invest',
  BUNDLES: 'Bundles',
  DASHBOARD: 'Dashboard',
  DEPOSIT_WITHDRAW: 'Deposit & Withdraw',
  LOANS: 'Loans',
  QUICK_BUY: 'Quick Buy',
  REWARDS: 'Rewards',
  TRADE: 'Trade',
  TRANSACTIONS: 'Transactions',
  WALLETS: 'Wallets',
} as const;
export type MenuLabelType = typeof MenuLabel;
export type MenuLabelValueType = MenuLabelType[keyof MenuLabelType];

let sysServiceName: any;

export function setSystemProperties(properties: { serviceName: string }) {
  if (properties.serviceName !== null && properties.serviceName !== undefined) {
    sysServiceName = properties.serviceName;
  }
}

let RudderStack: any;

export function initAvo(
  options: {
    env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger;
  },
  systemProperties: { serviceName: string },
  destinationOptions: any,
  RudderStackDestination: CustomDestination,
) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn('[avo] ****************************************************');
    InternalAvoLogger.warn('[avo] WARNING Avo cannot be initialized in noop mode in production:');
    InternalAvoLogger.warn('[avo] - Overwriting configuration with noop=false.');
    InternalAvoLogger.warn(
      '[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true',
    );
    InternalAvoLogger.warn('[avo] ****************************************************');
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log('[avo] ****************************************************');
    InternalAvoLogger.log('[avo] Avo is now initialized in noop mode. This means:');
    InternalAvoLogger.log('[avo] - No events will be sent');
    InternalAvoLogger.log('[avo] - No network requests are made');
    InternalAvoLogger.log('[avo] ****************************************************');
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ =
    !__AVO_NOOP__ &&
    ((typeof window !== 'undefined' && (window as any).location.search.indexOf('avo_debug=1') > -1) ||
      (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn('[avo] Avo Inspector not provided in initAvo() call');
  }

  setSystemProperties(systemProperties);

  destinationOptions = destinationOptions || {};

  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position);
    }

    (function () {
      if (typeof (window as any) === 'undefined') {
        return;
      }
      let init = function () {
        let iframe: any = document.createElement('iframe');
        document.body.appendChild(iframe);
        iframe.id = 'avo-debugger';
        iframe.src = 'https://www.avo.app/_debugger';
        iframe.style = 'display: none;';
      };

      if (document.body) {
        init();
      } else {
        document.addEventListener('DOMContentLoaded', init);
      }
    })();
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }

    RudderStack = RudderStackDestination;
    if (__AVO_ENV__ === 'prod') {
      RudderStack && RudderStack.make && RudderStack.make(__AVO_ENV__, null);
    } else if (__AVO_ENV__ === 'dev') {
      RudderStack && RudderStack.make && RudderStack.make(__AVO_ENV__, null);
    } else {
      console[__REPORT_FAILURE_AS__ || 'error'](
        '[avo] No staging key is set for RudderStack. Head to destination settings in Avo to set a staging key.',
      );
      RudderStack && RudderStack.make && RudderStack.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

function assertFromAssets(fromAssets: FromAssets[], _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertList('0EFQhKJ5ZM', 'fromAssets', fromAssets));
  if (fromAssets !== null && fromAssets !== undefined && fromAssets.forEach) {
    fromAssets.forEach(function (value, index) {
      messages = messages.concat(
        AvoAssert.assertObject('0EFQhKJ5ZM', 'item at index ' + index + ' in fromAssets', value),
      );
    });
  }
  return messages;
}

function assertTradeFromAssets(tradeFromAssets: TradeFromAssets[], _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertList('1_G4u6cVb', 'trade_from_assets', tradeFromAssets));
  if (tradeFromAssets !== null && tradeFromAssets !== undefined && tradeFromAssets.forEach) {
    tradeFromAssets.forEach(function (value, index) {
      messages = messages.concat(
        AvoAssert.assertObject('1_G4u6cVb', 'item at index ' + index + ' in trade_from_assets', value),
      );
    });
  }
  return messages;
}

function assertFromAssetsBefore(fromAssetsBefore: FromAssetsBefore[], _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertList('3fTNXgRcp', 'fromAssetsBefore', fromAssetsBefore));
  if (fromAssetsBefore !== null && fromAssetsBefore !== undefined && fromAssetsBefore.forEach) {
    fromAssetsBefore.forEach(function (value, index) {
      messages = messages.concat(
        AvoAssert.assertObject('3fTNXgRcp', 'item at index ' + index + ' in fromAssetsBefore', value),
      );
    });
  }
  return messages;
}

function assertTradeToAssets(tradeToAssets: TradeToAssets[], _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertList('6WLiOlA6N', 'trade_to_assets', tradeToAssets));
  if (tradeToAssets !== null && tradeToAssets !== undefined && tradeToAssets.forEach) {
    tradeToAssets.forEach(function (value, index) {
      messages = messages.concat(
        AvoAssert.assertObject('6WLiOlA6N', 'item at index ' + index + ' in trade_to_assets', value),
      );
    });
  }
  return messages;
}

function assertOrders(orders: Orders, _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(
    AvoAssert.assertObject('UXKInqqZSe', _label ? 'orders' + ': ' + _label : 'orders', orders),
  );
  if (orders !== null && orders !== undefined) {
  }
  return messages;
}

function assertToAssetsAfter(toAssetsAfter: ToAssetsAfter[], _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertList('_O9HojtY9', 'toAssetsAfter', toAssetsAfter));
  if (toAssetsAfter !== null && toAssetsAfter !== undefined && toAssetsAfter.forEach) {
    toAssetsAfter.forEach(function (value, index) {
      messages = messages.concat(
        AvoAssert.assertObject('_O9HojtY9', 'item at index ' + index + ' in toAssetsAfter', value),
      );
    });
  }
  return messages;
}

function assertToAssets(toAssets: ToAssets[], _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertList('k_B9pQ8fRP', 'toAssets', toAssets));
  if (toAssets !== null && toAssets !== undefined && toAssets.forEach) {
    toAssets.forEach(function (value, index) {
      messages = messages.concat(
        AvoAssert.assertObject('k_B9pQ8fRP', 'item at index ' + index + ' in toAssets', value),
      );
    });
  }
  return messages;
}

function assertFromAssetsAfter(fromAssetsAfter: FromAssetsAfter[], _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertList('llem1u6Fj', 'fromAssetsAfter', fromAssetsAfter));
  if (fromAssetsAfter !== null && fromAssetsAfter !== undefined && fromAssetsAfter.forEach) {
    fromAssetsAfter.forEach(function (value, index) {
      messages = messages.concat(
        AvoAssert.assertObject('llem1u6Fj', 'item at index ' + index + ' in fromAssetsAfter', value),
      );
    });
  }
  return messages;
}

function assertToAssetsBefore(toAssetsBefore: ToAssetsBefore[], _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertList('vpkPVgq6_', 'toAssetsBefore', toAssetsBefore));
  if (toAssetsBefore !== null && toAssetsBefore !== undefined && toAssetsBefore.forEach) {
    toAssetsBefore.forEach(function (value, index) {
      messages = messages.concat(
        AvoAssert.assertObject('vpkPVgq6_', 'item at index ' + index + ' in toAssetsBefore', value),
      );
    });
  }
  return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface SingleCategoryAssetFromAssetsTableOpenedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  assetCode: string;
  category: string;
  source: string;
}
/**
 * Single Category Asset From Assets Table Opened: When a user clicks on a single category on a single asset row within Assets List page.
 *
 * When to trigger this event:
 * 1. User clicked on a single category on a single asset row within Assets List page.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/LH5KWYdCi/trigger/gqjq9EhOM
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.category: Asset Category Name
 * @param properties.source: where does the button live that was clicked - entry points
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/LH5KWYdCi}
 */
export function singleCategoryAssetFromAssetsTableOpened(
  properties: SingleCategoryAssetFromAssetsTableOpenedProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'YK6mbPkLgc', name: 'category', value: properties.category });
  eventPropertiesArray.push({ id: 'GfwWDva0-i', name: 'source', value: properties.source });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'LH5KWYdCi',
        '2ad6ada0a586a7f362cfabf7dca2efd6a27c87d911884959320fea3d765ebb26',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Single Category Asset From Assets Table Opened', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'LH5KWYdCi',
        'Single Category Asset From Assets Table Opened',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Single Category Asset From Assets Table Opened',
        eventProperties,
        'LH5KWYdCi',
        '2ad6ada0a586a7f362cfabf7dca2efd6a27c87d911884959320fea3d765ebb26',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Single Category Asset From Assets Table Opened', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SingleCategoryPageOpenedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  category: string;
}
/**
 * Single Category Page Opened: When a user views/open a Single Category page (page load).
 *
 * When to trigger this event:
 * 1. Single category page is loaded/viewed.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/1cLyKKmNv/trigger/v_etr1IjD
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.category: Asset Category Name
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/1cLyKKmNv}
 */
export function singleCategoryPageOpened(properties: SingleCategoryPageOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'YK6mbPkLgc', name: 'category', value: properties.category });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '1cLyKKmNv',
        'bbbbcf0ef793694e3285e3e5581136f0dd361512926c20f74a676d6d865f6f29',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Single Category Page Opened', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '1cLyKKmNv',
        'Single Category Page Opened',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Single Category Page Opened',
        eventProperties,
        '1cLyKKmNv',
        'bbbbcf0ef793694e3285e3e5581136f0dd361512926c20f74a676d6d865f6f29',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Single Category Page Opened', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TourExitedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  tourName: string;
  tourStep: number;
}
/**
 * Tour Exited: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.tourName: no description
 * @param properties.tourStep: The step at which the tour was exited
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/DOGteutc6}
 */
export function tourExited(properties: TourExitedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'XTrG54h0EX', name: 'tour_name', value: properties.tourName });
  eventPropertiesArray.push({ id: 'T3mq013b-', name: 'tour_step', value: properties.tourStep });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'DOGteutc6',
        '7bfee742f7555f619ae6a89b5dd189ce9567b4fe1532d2a2c0af78b28f320d4b',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Tour Exited', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('DOGteutc6', 'Tour Exited', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Tour Exited',
        eventProperties,
        'DOGteutc6',
        '7bfee742f7555f619ae6a89b5dd189ce9567b4fe1532d2a2c0af78b28f320d4b',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Tour Exited', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TourCompletedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  tourName: string;
}
/**
 * Tour Completed: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.tourName: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Ovxy4L5os}
 */
export function tourCompleted(properties: TourCompletedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'XTrG54h0EX', name: 'tour_name', value: properties.tourName });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Ovxy4L5os',
        '258d954590a5448ff924bc79cb0624762ec9ec01607f16fc07afe04d2cfc8af9',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Tour Completed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('Ovxy4L5os', 'Tour Completed', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Tour Completed',
        eventProperties,
        'Ovxy4L5os',
        '258d954590a5448ff924bc79cb0624762ec9ec01607f16fc07afe04d2cfc8af9',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Tour Completed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TourStartedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  tourName: string;
}
/**
 * Tour Started: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.tourName: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/qCRFosx3j}
 */
export function tourStarted(properties: TourStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'XTrG54h0EX', name: 'tour_name', value: properties.tourName });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'qCRFosx3j',
        'b6307d091d9d2407aa427c4c993f2779f9dccb1a22b4a299c47b0763aea8852c',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Tour Started', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('qCRFosx3j', 'Tour Started', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Tour Started',
        eventProperties,
        'qCRFosx3j',
        'b6307d091d9d2407aa427c4c993f2779f9dccb1a22b4a299c47b0763aea8852c',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Tour Started', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TradeTypeSelectedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  layout: string;
  tradeType: TradeTypeValueType;
  swyftxPro: string | null | undefined;
}
/**
 * Trade Type Selected: User selects type of trade from the order/trade panel
 *
 * When to trigger this event:
 * 1. Pro variant
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/HVoVQ_NTU/trigger/_JQkU0dnC
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.layout: no description
 * @param properties.tradeType: no description
 * @param properties.swyftxPro: Differentiator for actions happening within Swyftx Pro UI
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/HVoVQ_NTU}
 */
export function tradeTypeSelected(properties: TradeTypeSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'nFSjmRQoLT', name: 'tradeType', value: properties.tradeType });
  properties.swyftxPro !== undefined && properties.swyftxPro !== null
    ? eventPropertiesArray.push({ id: 'DVYn9DJjX', name: 'swyftx_pro', value: properties.swyftxPro })
    : eventPropertiesArray.push({ id: 'DVYn9DJjX', name: 'swyftx_pro', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'HVoVQ_NTU',
        'f986c59835e0660ada4972f289d8be56b71bde09dc0ce4bbaef849e8e4626c37',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Trade Type Selected', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('HVoVQ_NTU', 'Trade Type Selected', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Trade Type Selected',
        eventProperties,
        'HVoVQ_NTU',
        'f986c59835e0660ada4972f289d8be56b71bde09dc0ce4bbaef849e8e4626c37',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Trade Type Selected', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UntrackedItemClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  layout: string;
}
/**
 * Untracked Item Clicked: When any item that does not have a specific event setup.
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.layout: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/_oTeYa7N2}
 */
export function untrackedItemClicked(properties: UntrackedItemClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '_oTeYa7N2',
        '50871e8b60d7a69f3122ff654abf6593355547f6667ae93d350171d74465c079',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Untracked Item Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('_oTeYa7N2', 'Untracked Item Clicked', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Untracked Item Clicked',
        eventProperties,
        '_oTeYa7N2',
        '50871e8b60d7a69f3122ff654abf6593355547f6667ae93d350171d74465c079',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Untracked Item Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ViewedLatestNewsProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  newsFeedPreference: string;
}
/**
 * Viewed Latest News: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.newsFeedPreference: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/TCO4xVgjw}
 */
export function viewedLatestNews(properties: ViewedLatestNewsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '3oMWB7Cba2', name: 'news_feed_preference', value: properties.newsFeedPreference });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'TCO4xVgjw',
        'bab1e10e2cb521c28aeef210abac62c5885d19069813c2b95f66b9dce45392af',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Viewed Latest News', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('TCO4xVgjw', 'Viewed Latest News', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Viewed Latest News',
        eventProperties,
        'TCO4xVgjw',
        'bab1e10e2cb521c28aeef210abac62c5885d19069813c2b95f66b9dce45392af',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Viewed Latest News', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ViewedLatestNewsOnAssetPageProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Viewed Latest News on Asset Page: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/_w-NFTzeW}
 */
export function viewedLatestNewsOnAssetPage(properties: ViewedLatestNewsOnAssetPageProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '_w-NFTzeW',
        'a3a959a4e88cdd6450bd64a520cf853f890cec7b19429d6969e8b3adf4b522a0',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Viewed Latest News on Asset Page', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '_w-NFTzeW',
        'Viewed Latest News on Asset Page',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Viewed Latest News on Asset Page',
        eventProperties,
        '_w-NFTzeW',
        'a3a959a4e88cdd6450bd64a520cf853f890cec7b19429d6969e8b3adf4b522a0',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Viewed Latest News on Asset Page', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ViewedReferAFriendPageProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  customDestinationPageName_: string;
}
/**
 * Viewed Refer A Friend Page: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/I8-rk8NZi}
 */
export function viewedReferAFriendPage(properties: ViewedReferAFriendPageProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'I8-rk8NZi',
        'b6e6ff71338315c5917cfeeafbe25e30e165537ad56a7346c12ae141f3292854',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Viewed Refer A Friend Page', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'I8-rk8NZi',
        'Viewed Refer A Friend Page',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    // destination RudderStack
    if (RudderStack.logPage) {
      RudderStack.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface WhatsNewActionClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  action: string;
  whatsNewFeature: string;
}
/**
 * Whats New Action Clicked: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.action: no description
 * @param properties.whatsNewFeature: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/eNoWAFfx0}
 */
export function whatsNewActionClicked(properties: WhatsNewActionClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'ITWPf12d0p', name: 'action', value: properties.action });
  eventPropertiesArray.push({ id: 'rt8v78-H24', name: 'whats_new_feature', value: properties.whatsNewFeature });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'eNoWAFfx0',
        '8afa1b9af2d054a86622b4b968933680639983d0e041735fc88e231648956b3e',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Whats New Action Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'eNoWAFfx0',
        'Whats New Action Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Whats New Action Clicked',
        eventProperties,
        'eNoWAFfx0',
        '8afa1b9af2d054a86622b4b968933680639983d0e041735fc88e231648956b3e',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Whats New Action Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface WhatsNewModalClosedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  whatsNewFeature: string;
  step: number;
}
/**
 * Whats New Modal Closed: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.whatsNewFeature: no description
 * @param properties.step: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/qjiS7OgJs}
 */
export function whatsNewModalClosed(properties: WhatsNewModalClosedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'rt8v78-H24', name: 'whats_new_feature', value: properties.whatsNewFeature });
  eventPropertiesArray.push({ id: '4-QvIgsUA', name: 'step', value: properties.step });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'qjiS7OgJs',
        'b37952b098e14a9ae520fc02e8a2f11facc3d2ee027f13d66a2ea7664cc7fbde',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Whats New Modal Closed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('qjiS7OgJs', 'Whats New Modal Closed', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Whats New Modal Closed',
        eventProperties,
        'qjiS7OgJs',
        'b37952b098e14a9ae520fc02e8a2f11facc3d2ee027f13d66a2ea7664cc7fbde',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Whats New Modal Closed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface WithdrawSendNavClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  layout: string;
}
/**
 * Withdraw Send Nav Clicked: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.layout: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/IZAAwj5o1}
 */
export function withdrawSendNavClicked(properties: WithdrawSendNavClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'IZAAwj5o1',
        'fa635071a0786cdcff9bb1e5ba86cad2dd6d294170599db5a587f852df7de84d',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Withdraw Send Nav Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'IZAAwj5o1',
        'Withdraw Send Nav Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Withdraw Send Nav Clicked',
        eventProperties,
        'IZAAwj5o1',
        'fa635071a0786cdcff9bb1e5ba86cad2dd6d294170599db5a587f852df7de84d',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Withdraw Send Nav Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface WhatsNewModalOpenedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  method: string;
  whatsNewFeature: string;
}
/**
 * Whats New Modal Opened: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.method: no description
 * @param properties.whatsNewFeature: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Sv3WLhYa-}
 */
export function whatsNewModalOpened(properties: WhatsNewModalOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'eZue9LL4JO', name: 'method', value: properties.method });
  eventPropertiesArray.push({ id: 'rt8v78-H24', name: 'whats_new_feature', value: properties.whatsNewFeature });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Sv3WLhYa-',
        '37b6f73fce757530c035acc1ace7c9fd63d8c0023c95f5741c1b5c6105dc2863',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Whats New Modal Opened', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('Sv3WLhYa-', 'Whats New Modal Opened', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Whats New Modal Opened',
        eventProperties,
        'Sv3WLhYa-',
        '37b6f73fce757530c035acc1ace7c9fd63d8c0023c95f5741c1b5c6105dc2863',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Whats New Modal Opened', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ViewedSingleAssetPageProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  assetCode: string;
  assetId: number;
  assetName: string;
}
/**
 * Viewed Single Asset Page: When a user visits a single asset page
 *
 * When to trigger this event:
 * 1. User opened/viewed
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/5XhMFRKbl/trigger/wXhTfgHec
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.assetId: The database ID of the asset
 * @param properties.assetName: The full name of the asset (eg. Bitcoin or Ethereum)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/5XhMFRKbl}
 */
export function viewedSingleAssetPage(properties: ViewedSingleAssetPageProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'yPbM0S1s5E', name: 'asset_name', value: properties.assetName });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '5XhMFRKbl',
        '0c3e27dee4e267cb528b6816ce35546aa6b2e5b44151b5d6778cb40eff6c7c36',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Viewed Single Asset Page', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '5XhMFRKbl',
        'Viewed Single Asset Page',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Viewed Single Asset Page',
        eventProperties,
        '5XhMFRKbl',
        '0c3e27dee4e267cb528b6816ce35546aa6b2e5b44151b5d6778cb40eff6c7c36',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Viewed Single Asset Page', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface RegisterStartedProperties {
  country: string | null | undefined;
  registrationAccountTypeSelected: RegistrationAccountTypeSelectedValueType;
}
/**
 * Register Started: When a user completes the first step of creating an account.
 * 
 * When to trigger this event:
 * 1. The event fires when you click Continue on this screen
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/DqrpQd87J/trigger/NEPhXCNNI
 * 
 * @param properties the properties associatied with this event
 * @param properties.country: Two-letter country code representing what country the user has selected. (Note: This is used for signup which is residency, and verification which is citizenship and/or current residency)
 * @param properties.registrationAccountTypeSelected: Determines if the user selected personal or entity during the registration flow, when creating an account.

 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/DqrpQd87J}
 */
export function registerStarted(properties: RegisterStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.country !== undefined && properties.country !== null
    ? eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: properties.country })
    : eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: null });
  eventPropertiesArray.push({
    id: 'COJKSqaTN',
    name: 'registration_account_type_selected',
    value: properties.registrationAccountTypeSelected,
  });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'DqrpQd87J',
        '221d4f503195383a6276ff1b2a77d8ca9c90eddc0a742f678478859fac967ac3',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Register Started', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('DqrpQd87J', 'Register Started', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Register Started',
        eventProperties,
        'DqrpQd87J',
        '221d4f503195383a6276ff1b2a77d8ca9c90eddc0a742f678478859fac967ac3',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Register Started', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProceededWithCardDepositProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  amount: number;
  currency: string | null | undefined;
  depositOption: string;
}
/**
 * Proceeded With Card Deposit: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.amount: The amount of the asset
 * @param properties.currency: Ignore - mandatory for Braze integration
 * @param properties.depositOption: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/wggsQvLXj}
 */
export function proceededWithCardDeposit(properties: ProceededWithCardDepositProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'E_qDLUcWGUv_', name: 'amount', value: properties.amount });
  properties.currency !== undefined && properties.currency !== null
    ? eventPropertiesArray.push({ id: 'Yz7wBFPdgiD9', name: 'currency', value: properties.currency })
    : eventPropertiesArray.push({ id: 'Yz7wBFPdgiD9', name: 'currency', value: null });
  eventPropertiesArray.push({ id: 'mAYpfGackl', name: 'depositOption', value: properties.depositOption });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'wggsQvLXj',
        '68c85c183fe6997ee082d68a4c7a9f159dd74945d3343146cb77f107e11ac516',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Proceeded With Card Deposit', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'wggsQvLXj',
        'Proceeded With Card Deposit',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Proceeded With Card Deposit',
        eventProperties,
        'wggsQvLXj',
        '68c85c183fe6997ee082d68a4c7a9f159dd74945d3343146cb77f107e11ac516',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Proceeded With Card Deposit', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PriceSideSelectedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  layout: string;
  priceSide: string;
  assetCode: string;
  assetId: number;
}
/**
 * Price Side Selected: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.layout: no description
 * @param properties.priceSide: no description
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.assetId: The database ID of the asset
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/gXpnHhnw3}
 */
export function priceSideSelected(properties: PriceSideSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'jJWpfDo-L9', name: 'priceSide', value: properties.priceSide });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'gXpnHhnw3',
        'cc8b94964eb5c9829f76be93afdd416c5879b2e8001be0320757ef79ed4122aa',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Price Side Selected', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('gXpnHhnw3', 'Price Side Selected', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Price Side Selected',
        eventProperties,
        'gXpnHhnw3',
        'cc8b94964eb5c9829f76be93afdd416c5879b2e8001be0320757ef79ed4122aa',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Price Side Selected', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OrderPlacedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  layout: string;
  tradeType: TradeTypeValueType;
  tradeFromAssets: TradeFromAssets[];
  tradeToAssets: TradeToAssets[];
}
/**
 * Order Placed: FE event when user confirms/creates a new order (of any type)
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.layout: no description
 * @param properties.tradeType: no description
 * @param properties.tradeFromAssets: The assets to be traded from (sold)
 * @param properties.tradeToAssets: The assets to be traded to (bought)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/FNgfF8j41}
 */
export function orderPlaced(properties: OrderPlacedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'nFSjmRQoLT', name: 'tradeType', value: properties.tradeType });
  eventPropertiesArray.push({
    id: '1_G4u6cVb',
    name: 'trade_from_assets',
    value: properties.tradeFromAssets.map(function (value) {
      return {
        amount: value.amount,
        asset_id: value.assetId,
        asset_code: value.assetCode,
        portion: value.portion,
      };
    }),
  });
  eventPropertiesArray.push({
    id: '6WLiOlA6N',
    name: 'trade_to_assets',
    value: properties.tradeToAssets.map(function (value) {
      return {
        asset_id: value.assetId,
        asset_code: value.assetCode,
        amount: value.amount,
        portion: value.portion,
      };
    }),
  });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertTradeFromAssets(properties.tradeFromAssets));
    messages = messages.concat(assertTradeToAssets(properties.tradeToAssets));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'FNgfF8j41',
        'c4e0252dfe4e1ac8365c39b39a1d06d4b9f4b7f754e44ba7b02863779639f826',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Order Placed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('FNgfF8j41', 'Order Placed', messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Order Placed': " + messages[0]!.message);
      }
    } else {
      messages.forEach(function (m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Order Placed',
        eventProperties,
        'FNgfF8j41',
        'c4e0252dfe4e1ac8365c39b39a1d06d4b9f4b7f754e44ba7b02863779639f826',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Order Placed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OrderDetailsReviewedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  layout: string | null | undefined;
  tradeType: TradeTypeValueType;
  trigger: number | null | undefined;
  tradeFromAssets: TradeFromAssets[];
  tradeToAssets: TradeToAssets[];
  sliderUsed: boolean | null | undefined;
  sliderInputUsed: boolean | null | undefined;
  quantityFieldUsed: boolean | null | undefined;
  limitAssetCode: string | null | undefined;
  fromAssetPercentage: number | null | undefined;
}
/**
 * Order Details Reviewed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.layout: no description
 * @param properties.tradeType: no description
 * @param properties.trigger: The price the order should trigger at for limit/stop orders (or the current price for market orders)

Also used for price alerts (both price alerts and volatility alerts)
 * @param properties.tradeFromAssets: The assets to be traded from (sold)
 * @param properties.tradeToAssets: The assets to be traded to (bought)
 * @param properties.sliderUsed: no description
 * @param properties.sliderInputUsed: no description
 * @param properties.quantityFieldUsed: no description
 * @param properties.limitAssetCode: no description
 * @param properties.fromAssetPercentage: no description
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/vnkNWbKiM}
 */
export function orderDetailsReviewed(properties: OrderDetailsReviewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.layout !== undefined && properties.layout !== null
    ? eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout })
    : eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: null });
  eventPropertiesArray.push({ id: 'nFSjmRQoLT', name: 'tradeType', value: properties.tradeType });
  properties.trigger !== undefined && properties.trigger !== null
    ? eventPropertiesArray.push({ id: '0opETRudzoSX', name: 'trigger', value: properties.trigger })
    : eventPropertiesArray.push({ id: '0opETRudzoSX', name: 'trigger', value: null });
  eventPropertiesArray.push({
    id: '1_G4u6cVb',
    name: 'trade_from_assets',
    value: properties.tradeFromAssets.map(function (value) {
      return {
        amount: value.amount,
        asset_id: value.assetId,
        asset_code: value.assetCode,
        portion: value.portion,
      };
    }),
  });
  eventPropertiesArray.push({
    id: '6WLiOlA6N',
    name: 'trade_to_assets',
    value: properties.tradeToAssets.map(function (value) {
      return {
        asset_id: value.assetId,
        asset_code: value.assetCode,
        amount: value.amount,
        portion: value.portion,
      };
    }),
  });
  properties.sliderUsed !== undefined && properties.sliderUsed !== null
    ? eventPropertiesArray.push({ id: '5zsfj-CnF', name: 'slider_used', value: properties.sliderUsed })
    : eventPropertiesArray.push({ id: '5zsfj-CnF', name: 'slider_used', value: null });
  properties.sliderInputUsed !== undefined && properties.sliderInputUsed !== null
    ? eventPropertiesArray.push({ id: 'KmgA_5bMX', name: 'slider_input_used', value: properties.sliderInputUsed })
    : eventPropertiesArray.push({ id: 'KmgA_5bMX', name: 'slider_input_used', value: null });
  properties.quantityFieldUsed !== undefined && properties.quantityFieldUsed !== null
    ? eventPropertiesArray.push({ id: 'ai8W8tj2OS', name: 'quantity_field_used', value: properties.quantityFieldUsed })
    : eventPropertiesArray.push({ id: 'ai8W8tj2OS', name: 'quantity_field_used', value: null });
  properties.limitAssetCode !== undefined && properties.limitAssetCode !== null
    ? eventPropertiesArray.push({ id: 'GXpv2dX8K', name: 'limit_asset_code', value: properties.limitAssetCode })
    : eventPropertiesArray.push({ id: 'GXpv2dX8K', name: 'limit_asset_code', value: null });
  properties.fromAssetPercentage !== undefined && properties.fromAssetPercentage !== null
    ? eventPropertiesArray.push({
        id: 'qng2qJL31',
        name: 'from_asset_percentage',
        value: properties.fromAssetPercentage,
      })
    : eventPropertiesArray.push({ id: 'qng2qJL31', name: 'from_asset_percentage', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertTradeFromAssets(properties.tradeFromAssets));
    messages = messages.concat(assertTradeToAssets(properties.tradeToAssets));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'vnkNWbKiM',
        'e618e86ccd55b29d4b9b2530951083502218430c06575fa95027a1f29a9aaf1c',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Order Details Reviewed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('vnkNWbKiM', 'Order Details Reviewed', messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Order Details Reviewed': " + messages[0]!.message);
      }
    } else {
      messages.forEach(function (m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Order Details Reviewed',
        eventProperties,
        'vnkNWbKiM',
        'e618e86ccd55b29d4b9b2530951083502218430c06575fa95027a1f29a9aaf1c',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Order Details Reviewed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OpenedProfitAndStopLossModalProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Opened Profit and Stop Loss Modal: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/hns34BVVt}
 */
export function openedProfitAndStopLossModal(properties: OpenedProfitAndStopLossModalProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'hns34BVVt',
        '7e2b40ec33d39647bf9d3353cea1c26a8c9312ef27d3ff7ab2dcd91057b44428',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Opened Profit and Stop Loss Modal', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'hns34BVVt',
        'Opened Profit and Stop Loss Modal',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Opened Profit and Stop Loss Modal',
        eventProperties,
        'hns34BVVt',
        '7e2b40ec33d39647bf9d3353cea1c26a8c9312ef27d3ff7ab2dcd91057b44428',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Opened Profit and Stop Loss Modal', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OpenedCategoryFilterDropdownProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Opened Category Filter Dropdown: User opened the full Categories list dropdown on Asset List page
 *
 * When to trigger this event:
 * 1. User opened the full Categories list dropdown on Asset List page
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/tv_T0dnVg/trigger/fLhog8v-Q
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/tv_T0dnVg}
 */
export function openedCategoryFilterDropdown(properties: OpenedCategoryFilterDropdownProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'tv_T0dnVg',
        '6e3a4007410e67e89effb8081950e4ce71fdd4c9ae9f4b1555cab76c7f3e109b',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Opened Category Filter Dropdown', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'tv_T0dnVg',
        'Opened Category Filter Dropdown',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Opened Category Filter Dropdown',
        eventProperties,
        'tv_T0dnVg',
        '6e3a4007410e67e89effb8081950e4ce71fdd4c9ae9f4b1555cab76c7f3e109b',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Opened Category Filter Dropdown', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingWizardStepCompleteProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  stepId: string;
}
/**
 * Onboarding Wizard Step Complete: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.stepId: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/SHB93x2bs}
 */
export function onboardingWizardStepComplete(properties: OnboardingWizardStepCompleteProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'SHB93x2bs',
        '94ada1bc7e778eede32873e373a8fe2aeaf0f4eb6903f950d1903542cd6f6478',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Onboarding Wizard Step Complete', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'SHB93x2bs',
        'Onboarding Wizard Step Complete',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Onboarding Wizard Step Complete',
        eventProperties,
        'SHB93x2bs',
        '94ada1bc7e778eede32873e373a8fe2aeaf0f4eb6903f950d1903542cd6f6478',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Onboarding Wizard Step Complete', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UXFlowExitedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  stepId: string;
  featureName: string | null | undefined;
  modalName: ModalNameValueType | null | undefined;
}
/**
 * UX Flow Exited: When users exit part way through a given UX flow

eg.  
Onboarding wizard
Recurring order creation
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.stepId: no description
 * @param properties.featureName: Name of overall feature / flow being interacted with (optional)
 * @param properties.modalName: Name of the modal in question (optional)
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/lpTBqZu3N}
 */
export function uxFlowExited(properties: UXFlowExitedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId });
  properties.featureName !== undefined && properties.featureName !== null
    ? eventPropertiesArray.push({ id: 'jtQWj9fe2', name: 'feature_name', value: properties.featureName })
    : eventPropertiesArray.push({ id: 'jtQWj9fe2', name: 'feature_name', value: null });
  properties.modalName !== undefined && properties.modalName !== null
    ? eventPropertiesArray.push({ id: 'NO9CObS3y', name: 'modal_name', value: properties.modalName })
    : eventPropertiesArray.push({ id: 'NO9CObS3y', name: 'modal_name', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'lpTBqZu3N',
        '75d7bc6ca9efd93bcdcb8487bd576eb091793154e376238bfacd46384161054d',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('UX Flow Exited', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('lpTBqZu3N', 'UX Flow Exited', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'UX Flow Exited',
        eventProperties,
        'lpTBqZu3N',
        '75d7bc6ca9efd93bcdcb8487bd576eb091793154e376238bfacd46384161054d',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('UX Flow Exited', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NoNewsReturnedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  filterSelection: string[];
  filterType: string;
  newsFeedPreference: string;
}
/**
 * No News Returned: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.filterSelection: no description
 * @param properties.filterType: no description
 * @param properties.newsFeedPreference: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/PM9Yt7XTp}
 */
export function noNewsReturned(properties: NoNewsReturnedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'M8Pz3LrlgS', name: 'filter_selection', value: properties.filterSelection });
  eventPropertiesArray.push({ id: '_OgyruRb6e', name: 'filter_type', value: properties.filterType });
  eventPropertiesArray.push({ id: '3oMWB7Cba2', name: 'news_feed_preference', value: properties.newsFeedPreference });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'PM9Yt7XTp',
        'c2620f77f5078361ee0a24fc147f5aa30f3f5d50fc7172917c06d58a0ee898d1',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('No News Returned', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('PM9Yt7XTp', 'No News Returned', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'No News Returned',
        eventProperties,
        'PM9Yt7XTp',
        'c2620f77f5078361ee0a24fc147f5aa30f3f5d50fc7172917c06d58a0ee898d1',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('No News Returned', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingWizardStepStartedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  stepId: string | null | undefined;
}
/**
 * Onboarding Wizard Step Started: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.stepId: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/AzQj8f9vV}
 */
export function onboardingWizardStepStarted(properties: OnboardingWizardStepStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.stepId !== undefined && properties.stepId !== null
    ? eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId })
    : eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'AzQj8f9vV',
        '7a40ae2cb4216a6433a19e098579bf4c65cf12608d67080cec1e2b1e49f9859c',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Onboarding Wizard Step Started', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'AzQj8f9vV',
        'Onboarding Wizard Step Started',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Onboarding Wizard Step Started',
        eventProperties,
        'AzQj8f9vV',
        '7a40ae2cb4216a6433a19e098579bf4c65cf12608d67080cec1e2b1e49f9859c',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Onboarding Wizard Step Started', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingWizardBackClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  stepId: string;
}
/**
 * Onboarding Wizard Back Clicked: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.stepId: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/ykhQc3LKM}
 */
export function onboardingWizardBackClicked(properties: OnboardingWizardBackClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ykhQc3LKM',
        '98a3e16bd123bb77d53081ecfd8661f8e69853b1f7d86e8375986fee39c6acf3',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Onboarding Wizard Back Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'ykhQc3LKM',
        'Onboarding Wizard Back Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Onboarding Wizard Back Clicked',
        eventProperties,
        'ykhQc3LKM',
        '98a3e16bd123bb77d53081ecfd8661f8e69853b1f7d86e8375986fee39c6acf3',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Onboarding Wizard Back Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingWizardStartedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Onboarding Wizard Started: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/a0vGJUbSn}
 */
export function onboardingWizardStarted(properties: OnboardingWizardStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'a0vGJUbSn',
        '75fb23cfa7a6e0b7e1c9f76ab96e34f1a6b99d158b29726a7b7c8284c83dc583',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Onboarding Wizard Started', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'a0vGJUbSn',
        'Onboarding Wizard Started',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Onboarding Wizard Started',
        eventProperties,
        'a0vGJUbSn',
        '75fb23cfa7a6e0b7e1c9f76ab96e34f1a6b99d158b29726a7b7c8284c83dc583',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Onboarding Wizard Started', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NoNewsFilterAvailableProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  filterSearched: string;
  newsFeedPreference: string;
}
/**
 * No News Filter Available: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.filterSearched: no description
 * @param properties.newsFeedPreference: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/7UVs9eFwC}
 */
export function noNewsFilterAvailable(properties: NoNewsFilterAvailableProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'uE4mFJM1lZ', name: 'filter_searched', value: properties.filterSearched });
  eventPropertiesArray.push({ id: '3oMWB7Cba2', name: 'news_feed_preference', value: properties.newsFeedPreference });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '7UVs9eFwC',
        '01e46cf3dc0d15f40a58a6d087087640ab939117639f8089846ad8b265477cbb',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('No News Filter Available', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '7UVs9eFwC',
        'No News Filter Available',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'No News Filter Available',
        eventProperties,
        '7UVs9eFwC',
        '01e46cf3dc0d15f40a58a6d087087640ab939117639f8089846ad8b265477cbb',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('No News Filter Available', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MarketTickerToggledProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  marketTickerToggleState: boolean;
}
/**
 * Market Ticker Toggled: When a user toggles the Market Ticker display on or off.
 *
 * When to trigger this event:
 * 1. When a user toggles the Market Ticker ON or OFF.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/8gHtCjkTD/trigger/9WzYtVG3S
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.marketTickerToggleState: To capture the state of Market Ticker on/off toggle.
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/8gHtCjkTD}
 */
export function marketTickerToggled(properties: MarketTickerToggledProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({
    id: 'AUXEVPawwT',
    name: 'market_ticker_toggle_state',
    value: properties.marketTickerToggleState,
  });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '8gHtCjkTD',
        '9adeb0791230576874e8fa6bd88cd3b3e48b082820336197749039a6dabd4d23',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Market Ticker Toggled', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('8gHtCjkTD', 'Market Ticker Toggled', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Market Ticker Toggled',
        eventProperties,
        '8gHtCjkTD',
        '9adeb0791230576874e8fa6bd88cd3b3e48b082820336197749039a6dabd4d23',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Market Ticker Toggled', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MigrateInitiatedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  exchange: string;
  feeFree: boolean;
}
/**
 * Migrate Initiated: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.exchange: The exchange that is being migrated from
 * @param properties.feeFree: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Xurzz9nUn}
 */
export function migrateInitiated(properties: MigrateInitiatedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'BjP68ejWWGMr', name: 'exchange', value: properties.exchange });
  eventPropertiesArray.push({ id: 'njF1O9oG_X', name: 'feeFree', value: properties.feeFree });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Xurzz9nUn',
        'f89a5ea6c37a8859b53fa1f8b7008a3f80ec5eb8c02b4f0a1d065f77141ad1ed',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Migrate Initiated', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('Xurzz9nUn', 'Migrate Initiated', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Migrate Initiated',
        eventProperties,
        'Xurzz9nUn',
        'f89a5ea6c37a8859b53fa1f8b7008a3f80ec5eb8c02b4f0a1d065f77141ad1ed',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Migrate Initiated', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MarketTickerAssetClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  assetCode: string;
  assetId: number;
  assetName: string;
  percentageChange: string;
  assetPriceBaseCurrency: string;
  marketTickerSort: MarketTickerSortValueType;
  marketTickerVariant: MarketTickerVariantValueType;
  marketTickerVisibleAssets: MarketTickerVisibleAssetsValueType | null | undefined;
}
/**
 * Market Ticker Asset Clicked: When a user clicks on any asset in the Market Ticker.
 *
 * When to trigger this event:
 * 1. When a user clicks on a single asset within the market ticker.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/n2fq7aUvE/trigger/xsD1ZR6XE
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.assetId: The database ID of the asset
 * @param properties.assetName: The full name of the asset (eg. Bitcoin or Ethereum)
 * @param properties.percentageChange: no description
 * @param properties.assetPriceBaseCurrency: The price of the asset on the ticker in the user's base currency (eg 40,000 if the user clicks on BTC: 40,000 AUD)
 * @param properties.marketTickerSort: The sorting of the market ticker eg. Gainers, Losers, Market Cap, Newly Listed.
 * @param properties.marketTickerVariant: The variant of market ticker display style selected by the user (eg. Scrolling or Static)
 * @param properties.marketTickerVisibleAssets: The assets shown within market ticker based on users favourites or owned balances.
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/n2fq7aUvE}
 */
export function marketTickerAssetClicked(properties: MarketTickerAssetClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'yPbM0S1s5E', name: 'asset_name', value: properties.assetName });
  eventPropertiesArray.push({ id: 'D9nEoZ5yBT', name: 'percentage_change', value: properties.percentageChange });
  eventPropertiesArray.push({
    id: 'UMX73ahGL',
    name: 'asset_price_base_currency',
    value: properties.assetPriceBaseCurrency,
  });
  eventPropertiesArray.push({ id: '1FnM66AjB', name: 'market_ticker_sort', value: properties.marketTickerSort });
  eventPropertiesArray.push({ id: 'ZYr5-Z85i', name: 'market_ticker_variant', value: properties.marketTickerVariant });
  properties.marketTickerVisibleAssets !== undefined && properties.marketTickerVisibleAssets !== null
    ? eventPropertiesArray.push({
        id: 'YQHpSwgSC',
        name: 'market_ticker_visible_assets',
        value: properties.marketTickerVisibleAssets,
      })
    : eventPropertiesArray.push({ id: 'YQHpSwgSC', name: 'market_ticker_visible_assets', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'n2fq7aUvE',
        '74253140b9ec118b94222c283159b0abae675a5c140d821989d37849722b453c',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Market Ticker Asset Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'n2fq7aUvE',
        'Market Ticker Asset Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Market Ticker Asset Clicked',
        eventProperties,
        'n2fq7aUvE',
        '74253140b9ec118b94222c283159b0abae675a5c140d821989d37849722b453c',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Market Ticker Asset Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface KoinlySSOSessionStartedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  withApiKey: boolean;
}
/**
 * Koinly SSO Session Started: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.withApiKey: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/zShcwh7Zx}
 */
export function koinlySsoSessionStarted(properties: KoinlySSOSessionStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'x_lzfdsZCl', name: 'with_api_key', value: properties.withApiKey });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'zShcwh7Zx',
        'ecec3e9926b382ab333b92208d208ef71ba688f03bad6dc20097d63a5e907b97',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Koinly SSO Session Started', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'zShcwh7Zx',
        'Koinly SSO Session Started',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Koinly SSO Session Started',
        eventProperties,
        'zShcwh7Zx',
        'ecec3e9926b382ab333b92208d208ef71ba688f03bad6dc20097d63a5e907b97',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Koinly SSO Session Started', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface KoinlyConnectAccountButtonClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Koinly Connect Account Button Clicked: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/uT-gaVLc7}
 */
export function koinlyConnectAccountButtonClicked(properties: KoinlyConnectAccountButtonClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'uT-gaVLc7',
        '527a3a08eb14624510913bb94f720662ae1c57467f2c0cb5fb7ec51b698d3854',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Koinly Connect Account Button Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'uT-gaVLc7',
        'Koinly Connect Account Button Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Koinly Connect Account Button Clicked',
        eventProperties,
        'uT-gaVLc7',
        '527a3a08eb14624510913bb94f720662ae1c57467f2c0cb5fb7ec51b698d3854',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Koinly Connect Account Button Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HighSlippageTradeProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  fromAsset: string | null | undefined;
  price: Price;
  slippagePercentage: number;
  toAsset: string | null | undefined;
}
/**
 * High Slippage Trade: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.fromAsset: no description
 * @param properties.price: no description
 * @param properties.slippagePercentage: no description
 * @param properties.toAsset: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/poGGWzpBK}
 */
export function highSlippageTrade(properties: HighSlippageTradeProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.fromAsset !== undefined && properties.fromAsset !== null
    ? eventPropertiesArray.push({ id: 'm2s5utbw9l', name: 'fromAsset', value: properties.fromAsset })
    : eventPropertiesArray.push({ id: 'm2s5utbw9l', name: 'fromAsset', value: null });
  eventPropertiesArray.push({ id: 'wz_7slktMH', name: 'price', value: properties.price });
  eventPropertiesArray.push({ id: '41PxNcjM0_', name: 'slippagePercentage', value: properties.slippagePercentage });
  properties.toAsset !== undefined && properties.toAsset !== null
    ? eventPropertiesArray.push({ id: 'h56dEZvV6F', name: 'toAsset', value: properties.toAsset })
    : eventPropertiesArray.push({ id: 'h56dEZvV6F', name: 'toAsset', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'poGGWzpBK',
        '2f94f60a2b5e31073fe990d0095f5bef041765a5c664a9ddb21cb719ca6dad4b',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('High Slippage Trade', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('poGGWzpBK', 'High Slippage Trade', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'High Slippage Trade',
        eventProperties,
        'poGGWzpBK',
        '2f94f60a2b5e31073fe990d0095f5bef041765a5c664a9ddb21cb719ca6dad4b',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('High Slippage Trade', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface IntervalSelectedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  interval: string;
  layout: string;
  assetId: number;
  assetCode: string;
}
/**
 * Interval Selected: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.interval: no description
 * @param properties.layout: no description
 * @param properties.assetId: The database ID of the asset
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/VJqHNj5mH}
 */
export function intervalSelected(properties: IntervalSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'J0vzfuWq5d', name: 'interval', value: properties.interval });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'VJqHNj5mH',
        '88918ffe185967595eb5afdc9810b92ee4351b2003686ca805946f2a2894cd51',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Interval Selected', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('VJqHNj5mH', 'Interval Selected', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Interval Selected',
        eventProperties,
        'VJqHNj5mH',
        '88918ffe185967595eb5afdc9810b92ee4351b2003686ca805946f2a2894cd51',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Interval Selected', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface IndicatorSelectedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  indicator: string;
  layout: string;
  assetId: number;
  assetCode: string;
}
/**
 * Indicator Selected: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.indicator: no description
 * @param properties.layout: no description
 * @param properties.assetId: The database ID of the asset
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/ZXhrQ6wdE}
 */
export function indicatorSelected(properties: IndicatorSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'bEIjHmBHcR', name: 'indicator', value: properties.indicator });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ZXhrQ6wdE',
        '3c6828c5c87c2ceba0545b389276e24d8e317592821829c779f0ae98184014ce',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Indicator Selected', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('ZXhrQ6wdE', 'Indicator Selected', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Indicator Selected',
        eventProperties,
        'ZXhrQ6wdE',
        '3c6828c5c87c2ceba0545b389276e24d8e317592821829c779f0ae98184014ce',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Indicator Selected', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FullscreenChartOpenedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  layout: string;
  assetId: number;
  assetCode: string;
}
/**
 * Fullscreen Chart Opened: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.layout: no description
 * @param properties.assetId: The database ID of the asset
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Kxg74fvhK}
 */
export function fullscreenChartOpened(properties: FullscreenChartOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Kxg74fvhK',
        '411d3662831763b52a7e51de7bb397f1108ad05d3b4ccd2b68c11773a273ad38',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Fullscreen Chart Opened', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Kxg74fvhK',
        'Fullscreen Chart Opened',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Fullscreen Chart Opened',
        eventProperties,
        'Kxg74fvhK',
        '411d3662831763b52a7e51de7bb397f1108ad05d3b4ccd2b68c11773a273ad38',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Fullscreen Chart Opened', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FilteredCategoryFromTradePageProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  category: string;
}
/**
 * Filtered Category from Trade Page: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.category: Asset Category Name
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/cUN6Ak474}
 */
export function filteredCategoryFromTradePage(properties: FilteredCategoryFromTradePageProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'YK6mbPkLgc', name: 'category', value: properties.category });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'cUN6Ak474',
        '2c405e5fabae9c135bcd7b7df8d42c336d1d151a5f52230249e7bd2d5783905b',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Filtered Category from Trade Page', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'cUN6Ak474',
        'Filtered Category from Trade Page',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Filtered Category from Trade Page',
        eventProperties,
        'cUN6Ak474',
        '2c405e5fabae9c135bcd7b7df8d42c336d1d151a5f52230249e7bd2d5783905b',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Filtered Category from Trade Page', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DepositFundsTappedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  component: string;
}
/**
 * Deposit Funds Tapped: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.component: Name of the react component
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/De57TCHtg}
 */
export function depositFundsTapped(properties: DepositFundsTappedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'zhKfyo0ZNZ', name: 'component', value: properties.component });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'De57TCHtg',
        '0420c11cf54e2fcd69dbc17d196e40aef58cd664237daa9584ff83591f79727a',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Deposit Funds Tapped', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('De57TCHtg', 'Deposit Funds Tapped', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Deposit Funds Tapped',
        eventProperties,
        'De57TCHtg',
        '0420c11cf54e2fcd69dbc17d196e40aef58cd664237daa9584ff83591f79727a',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Deposit Funds Tapped', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DemoModeToggledProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  enabled: boolean;
}
/**
 * Demo Mode Toggled: The user toggles demo mode on or off
 *
 * When to trigger this event:
 * 1. Fires when the slider is toggled in either direction
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/gr6pGpJ3S/trigger/sNkTOvekJ
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.enabled: Whether the value was toggled on (true) or off (false)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/gr6pGpJ3S}
 */
export function demoModeToggled(properties: DemoModeToggledProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'tweuUsMG1s', name: 'enabled', value: properties.enabled });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'gr6pGpJ3S',
        '6064475cc8d61da319e95c681372316961100876f04926a8f521117dacbc006f',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Demo Mode Toggled', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('gr6pGpJ3S', 'Demo Mode Toggled', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Demo Mode Toggled',
        eventProperties,
        'gr6pGpJ3S',
        '6064475cc8d61da319e95c681372316961100876f04926a8f521117dacbc006f',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Demo Mode Toggled', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DashboardLayoutSelectorModalOpenedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Dashboard Layout Selector Modal Opened: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/gNt0-LAZY}
 */
export function dashboardLayoutSelectorModalOpened(properties: DashboardLayoutSelectorModalOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'gNt0-LAZY',
        'cdc08ac040d85d919b2e36c852746e3db2b34523d8191f3e408dd526f5c8ccd7',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Dashboard Layout Selector Modal Opened', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'gNt0-LAZY',
        'Dashboard Layout Selector Modal Opened',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Dashboard Layout Selector Modal Opened',
        eventProperties,
        'gNt0-LAZY',
        'cdc08ac040d85d919b2e36c852746e3db2b34523d8191f3e408dd526f5c8ccd7',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Dashboard Layout Selector Modal Opened', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DashboardLayoutChangedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  newLayout: string;
  prevLayout: string;
}
/**
 * Dashboard Layout Changed: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.newLayout: no description
 * @param properties.prevLayout: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/tIqjnlOdq}
 */
export function dashboardLayoutChanged(properties: DashboardLayoutChangedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'S0EHf2iv-4', name: 'new_layout', value: properties.newLayout });
  eventPropertiesArray.push({ id: 'KpulIljGss', name: 'prev_layout', value: properties.prevLayout });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'tIqjnlOdq',
        'afaa8b1be4a492227e9d449ad22df0bd6a8e3efda54f7003e310c478d6746074',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Dashboard Layout Changed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'tIqjnlOdq',
        'Dashboard Layout Changed',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Dashboard Layout Changed',
        eventProperties,
        'tIqjnlOdq',
        'afaa8b1be4a492227e9d449ad22df0bd6a8e3efda54f7003e310c478d6746074',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Dashboard Layout Changed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CreatedTakeProfitProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  calculationType: string;
  calculationValueType: string;
  estimatedPercentage: string;
  estimatedProfit: string;
  relatedOrderUuid: string;
  placedOrderUuid: string;
}
/**
 * Created Take Profit: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.calculationType: did the user input a specific price value or use a calculation (like $ amount or % distance)

eg.  trigger price or target
 * @param properties.calculationValueType: what denomination was the value entered

eg.  percentage vs. dollar value/price
 * @param properties.estimatedPercentage: no description
 * @param properties.estimatedProfit: no description
 * @param properties.relatedOrderUuid: ID of the initial order that new orders are based off

eg.  the initial market buy that triggers the order prompting flow
 * @param properties.placedOrderUuid: ID of the secondary order being created 

eg.  the take profit/stop-loss as part of order prompting flow
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/0z732xKNj}
 */
export function createdTakeProfit(properties: CreatedTakeProfitProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'sh2lNfWIWa', name: 'calculationType', value: properties.calculationType });
  eventPropertiesArray.push({ id: 'HIlupdTPL2', name: 'calculationValueType', value: properties.calculationValueType });
  eventPropertiesArray.push({ id: 'XU-YMlu3Pa', name: 'estimatedPercentage', value: properties.estimatedPercentage });
  eventPropertiesArray.push({ id: 'dDc_cf359x', name: 'estimatedProfit', value: properties.estimatedProfit });
  eventPropertiesArray.push({ id: '_cd3r-6zDe', name: 'relatedOrderUuid', value: properties.relatedOrderUuid });
  eventPropertiesArray.push({ id: 'xvu8OUchD', name: 'placedOrderUuid', value: properties.placedOrderUuid });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '0z732xKNj',
        'd59f1cf53c8b8b99dc5f1134b27765735f0b6e23c9f4e91b4cb91108bdd21791',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Created Take Profit', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('0z732xKNj', 'Created Take Profit', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Created Take Profit',
        eventProperties,
        '0z732xKNj',
        'd59f1cf53c8b8b99dc5f1134b27765735f0b6e23c9f4e91b4cb91108bdd21791',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Created Take Profit', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CreatedStopLossProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  calculationType: string;
  calculationValueType: string;
  estimatedLoss: string;
  estimatedPercentage: string;
  relatedOrderUuid: string;
  placedOrderUuid: string;
}
/**
 * Created Stop Loss: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.calculationType: did the user input a specific price value or use a calculation (like $ amount or % distance)

eg.  trigger price or target
 * @param properties.calculationValueType: what denomination was the value entered

eg.  percentage vs. dollar value/price
 * @param properties.estimatedLoss: no description
 * @param properties.estimatedPercentage: no description
 * @param properties.relatedOrderUuid: ID of the initial order that new orders are based off

eg.  the initial market buy that triggers the order prompting flow
 * @param properties.placedOrderUuid: ID of the secondary order being created 

eg.  the take profit/stop-loss as part of order prompting flow
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/TPmDmRgDO}
 */
export function createdStopLoss(properties: CreatedStopLossProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'sh2lNfWIWa', name: 'calculationType', value: properties.calculationType });
  eventPropertiesArray.push({ id: 'HIlupdTPL2', name: 'calculationValueType', value: properties.calculationValueType });
  eventPropertiesArray.push({ id: 'jefhu9xOOu', name: 'estimatedLoss', value: properties.estimatedLoss });
  eventPropertiesArray.push({ id: 'XU-YMlu3Pa', name: 'estimatedPercentage', value: properties.estimatedPercentage });
  eventPropertiesArray.push({ id: '_cd3r-6zDe', name: 'relatedOrderUuid', value: properties.relatedOrderUuid });
  eventPropertiesArray.push({ id: 'xvu8OUchD', name: 'placedOrderUuid', value: properties.placedOrderUuid });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'TPmDmRgDO',
        '497a6de5a6593a534cca3a679fd88a11f805bbfb223fa68bc1297158ebc67c83',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Created Stop Loss', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('TPmDmRgDO', 'Created Stop Loss', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Created Stop Loss',
        eventProperties,
        'TPmDmRgDO',
        '497a6de5a6593a534cca3a679fd88a11f805bbfb223fa68bc1297158ebc67c83',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Created Stop Loss', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CopiedReferAFriendLinkProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Copied Refer A Friend Link: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/yiBA2X4FT}
 */
export function copiedReferAFriendLink(properties: CopiedReferAFriendLinkProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'yiBA2X4FT',
        'f759f8f8b71813d8a76f70395ce9b03a8646597951e19bd5b7850f2e4c6da0ce',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Copied Refer A Friend Link', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'yiBA2X4FT',
        'Copied Refer A Friend Link',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Copied Refer A Friend Link',
        eventProperties,
        'yiBA2X4FT',
        'f759f8f8b71813d8a76f70395ce9b03a8646597951e19bd5b7850f2e4c6da0ce',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Copied Refer A Friend Link', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ConfirmedCardDetailsProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  depositOption: string;
}
/**
 * Confirmed Card Details: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.depositOption: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/bHbscHlmB}
 */
export function confirmedCardDetails(properties: ConfirmedCardDetailsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'mAYpfGackl', name: 'depositOption', value: properties.depositOption });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'bHbscHlmB',
        'ecf91ccc5347d829b24b32b036a5dd124b9e32f7439298185e9ab5cf258fc878',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Confirmed Card Details', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('bHbscHlmB', 'Confirmed Card Details', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Confirmed Card Details',
        eventProperties,
        'bHbscHlmB',
        'ecf91ccc5347d829b24b32b036a5dd124b9e32f7439298185e9ab5cf258fc878',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Confirmed Card Details', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClickedShowMoreLatestNewsProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  newsFeedPreference: string;
}
/**
 * Clicked Show More Latest News: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.newsFeedPreference: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/aBPRe626R}
 */
export function clickedShowMoreLatestNews(properties: ClickedShowMoreLatestNewsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '3oMWB7Cba2', name: 'news_feed_preference', value: properties.newsFeedPreference });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'aBPRe626R',
        '6141ce79a850c2b250a07e6a4e08840e811a6c62271fc30f77c6dc6ada901f89',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Clicked Show More Latest News', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'aBPRe626R',
        'Clicked Show More Latest News',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Clicked Show More Latest News',
        eventProperties,
        'aBPRe626R',
        '6141ce79a850c2b250a07e6a4e08840e811a6c62271fc30f77c6dc6ada901f89',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Clicked Show More Latest News', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClickedPromotedCategoryFromAssetListPageProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  category: string;
}
/**
 * Clicked Promoted Category From Asset List Page: A user clicked on a category chip on the Asset List page, when 'All Assets' table is active.
 *
 * When to trigger this event:
 * 1. A user clicked on a category chip on the Asset List page, when 'All Assets' table is active.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/_VsslAzyK/trigger/NCHws4Agj
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.category: Asset Category Name
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/_VsslAzyK}
 */
export function clickedPromotedCategoryFromAssetListPage(
  properties: ClickedPromotedCategoryFromAssetListPageProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'YK6mbPkLgc', name: 'category', value: properties.category });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '_VsslAzyK',
        'f4519ce1b7208103f02bdd3b0c262bc9137825d1168346e18c03379b2498afc3',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Clicked Promoted Category From Asset List Page', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '_VsslAzyK',
        'Clicked Promoted Category From Asset List Page',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Clicked Promoted Category From Asset List Page',
        eventProperties,
        '_VsslAzyK',
        'f4519ce1b7208103f02bdd3b0c262bc9137825d1168346e18c03379b2498afc3',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Clicked Promoted Category From Asset List Page', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClickedNewsArticleProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  articleAssets: string[];
  articleLink: string;
  articlePublishedDate: string;
  articleTitle: string;
}
/**
 * Clicked News Article: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.articleAssets: A list of the assets mentioned in the article
 * @param properties.articleLink: The link to the article that the customer was directed to
 * @param properties.articlePublishedDate: When the article was originally published
 * @param properties.articleTitle: Article title
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/1kyas31Jr}
 */
export function clickedNewsArticle(properties: ClickedNewsArticleProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'p5nDel2MKc', name: 'article_assets', value: properties.articleAssets });
  eventPropertiesArray.push({ id: 'Bb0Zuum-I7', name: 'article_link', value: properties.articleLink });
  eventPropertiesArray.push({
    id: 'GoWVlFx6qI',
    name: 'article_published_date',
    value: properties.articlePublishedDate,
  });
  eventPropertiesArray.push({ id: 'hbhCqitElB', name: 'article_title', value: properties.articleTitle });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '1kyas31Jr',
        '2864ec5a47d2055b6a6ae946130543071268d7a9f05397878df5d3cfc5ca060c',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Clicked News Article', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('1kyas31Jr', 'Clicked News Article', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Clicked News Article',
        eventProperties,
        '1kyas31Jr',
        '2864ec5a47d2055b6a6ae946130543071268d7a9f05397878df5d3cfc5ca060c',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Clicked News Article', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClickedAssetOnMoversDashboardTileProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  assetPrice: string;
  percentageGain24h: string;
  assetId: number;
  assetCode: string;
  tileFilter: string;
}
/**
 * Clicked Asset On Movers Dashboard Tile: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.assetPrice: no description
 * @param properties.percentageGain24h: no description
 * @param properties.assetId: The database ID of the asset
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.tileFilter: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/GkYEbfarf}
 */
export function clickedAssetOnMoversDashboardTile(properties: ClickedAssetOnMoversDashboardTileProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'CUT59yP4gP', name: 'assetPrice', value: properties.assetPrice });
  eventPropertiesArray.push({ id: 'u3D5vup7hi', name: 'percentageGain24h', value: properties.percentageGain24h });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'naB-X92_VY', name: 'tileFilter', value: properties.tileFilter });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'GkYEbfarf',
        'cfff35d072cb4117c74c0eff1f588dc6ddd0310992da01876ccaf7479e5f3100',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Clicked Asset On Movers Dashboard Tile', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'GkYEbfarf',
        'Clicked Asset On Movers Dashboard Tile',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Clicked Asset On Movers Dashboard Tile',
        eventProperties,
        'GkYEbfarf',
        'cfff35d072cb4117c74c0eff1f588dc6ddd0310992da01876ccaf7479e5f3100',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Clicked Asset On Movers Dashboard Tile', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ChartOpenedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  layout: string;
  assetCode: string;
  assetId: number;
}
/**
 * Chart Opened: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.layout: no description
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.assetId: The database ID of the asset
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/SfMfhAfdf}
 */
export function chartOpened(properties: ChartOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'SfMfhAfdf',
        '9756776ad3f091a5677b11daaa932c98f27c5789c1653faaacdef4b5a6fd4e49',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Chart Opened', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('SfMfhAfdf', 'Chart Opened', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Chart Opened',
        eventProperties,
        'SfMfhAfdf',
        '9756776ad3f091a5677b11daaa932c98f27c5789c1653faaacdef4b5a6fd4e49',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Chart Opened', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClickedPromotedCategoryFromTradePageProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  category: string;
}
/**
 * Clicked Promoted Category From Trade Page: When a user clicks a single category chip on the Trade page (web only).
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.category: Asset Category Name
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/b1IKSM2zS}
 */
export function clickedPromotedCategoryFromTradePage(properties: ClickedPromotedCategoryFromTradePageProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'YK6mbPkLgc', name: 'category', value: properties.category });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'b1IKSM2zS',
        '1f694df4aa72e07299feeeaa2c827449bf38d4b7359c3a4f710b3df5f8caca06',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Clicked Promoted Category From Trade Page', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'b1IKSM2zS',
        'Clicked Promoted Category From Trade Page',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Clicked Promoted Category From Trade Page',
        eventProperties,
        'b1IKSM2zS',
        '1f694df4aa72e07299feeeaa2c827449bf38d4b7359c3a4f710b3df5f8caca06',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Clicked Promoted Category From Trade Page', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ChartClosedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  layout: string;
  assetId: number;
  assetCode: string;
}
/**
 * Chart Closed: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.layout: no description
 * @param properties.assetId: The database ID of the asset
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/vehJ-xGlz}
 */
export function chartClosed(properties: ChartClosedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'vehJ-xGlz',
        '4429a75f418034b196dbc0c91ebb1e080f2f95eb3d534a1a976b1aa6818601a0',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Chart Closed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('vehJ-xGlz', 'Chart Closed', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Chart Closed',
        eventProperties,
        'vehJ-xGlz',
        '4429a75f418034b196dbc0c91ebb1e080f2f95eb3d534a1a976b1aa6818601a0',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Chart Closed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ChartAreaClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  layout: string;
  assetId: number;
  assetCode: string;
}
/**
 * Chart Area Clicked: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.layout: no description
 * @param properties.assetId: The database ID of the asset
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/cho46eCEN}
 */
export function chartAreaClicked(properties: ChartAreaClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'cho46eCEN',
        'a85ad0b3bf2766601412cd5b7c77142fcccdf1090fcac4131bae360524f23a3f',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Chart Area Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('cho46eCEN', 'Chart Area Clicked', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Chart Area Clicked',
        eventProperties,
        'cho46eCEN',
        'a85ad0b3bf2766601412cd5b7c77142fcccdf1090fcac4131bae360524f23a3f',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Chart Area Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClickedCardDepositProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  depositOption: string;
}
/**
 * Clicked Card Deposit: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.depositOption: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/pbGEU4Iim}
 */
export function clickedCardDeposit(properties: ClickedCardDepositProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'mAYpfGackl', name: 'depositOption', value: properties.depositOption });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'pbGEU4Iim',
        '74a55003c45639a80dd5cc795fa44dbcea2bc10f91cf62d66d1304cbd3469c17',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Clicked Card Deposit', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('pbGEU4Iim', 'Clicked Card Deposit', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Clicked Card Deposit',
        eventProperties,
        'pbGEU4Iim',
        '74a55003c45639a80dd5cc795fa44dbcea2bc10f91cf62d66d1304cbd3469c17',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Clicked Card Deposit', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CategoryListOpenedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Category List Opened: When a user opens Category tabs on Asset List page.
 *
 * When to trigger this event:
 * 1. A user clicked on Categories tab on the Asset List page.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/OM1r-954B/trigger/vmV9Kiplp
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/OM1r-954B}
 */
export function categoryListOpened(properties: CategoryListOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'OM1r-954B',
        '6427df2b102312c42d966d25b6b367efe25655f62861ce5fcf6118f7874a1b3d',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Category List Opened', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('OM1r-954B', 'Category List Opened', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Category List Opened',
        eventProperties,
        'OM1r-954B',
        '6427df2b102312c42d966d25b6b367efe25655f62861ce5fcf6118f7874a1b3d',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Category List Opened', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ChangedTabOnMoversDashboardTileProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  previousTileFilter: string;
  tileFilter: string;
  tileView: string;
}
/**
 * Changed Tab On Movers Dashboard Tile: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.previousTileFilter: no description
 * @param properties.tileFilter: no description
 * @param properties.tileView: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/6KuHSulJC}
 */
export function changedTabOnMoversDashboardTile(properties: ChangedTabOnMoversDashboardTileProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '2C95zluI74', name: 'previousTileFilter', value: properties.previousTileFilter });
  eventPropertiesArray.push({ id: 'naB-X92_VY', name: 'tileFilter', value: properties.tileFilter });
  eventPropertiesArray.push({ id: 'QSrqDZ4ztP', name: 'tileView', value: properties.tileView });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '6KuHSulJC',
        'f6d871339c1efdd507e15004fd789f1be1ac71556d3d085faa36199afde99424',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Changed Tab On Movers Dashboard Tile', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '6KuHSulJC',
        'Changed Tab On Movers Dashboard Tile',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Changed Tab On Movers Dashboard Tile',
        eventProperties,
        '6KuHSulJC',
        'f6d871339c1efdd507e15004fd789f1be1ac71556d3d085faa36199afde99424',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Changed Tab On Movers Dashboard Tile', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CardDepositFailedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  amount: number;
  currency: string | null | undefined;
  depositOption: string;
}
/**
 * Card Deposit Failed: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.amount: The amount of the asset
 * @param properties.currency: Ignore - mandatory for Braze integration
 * @param properties.depositOption: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/g3EycOLui}
 */
export function cardDepositFailed(properties: CardDepositFailedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'E_qDLUcWGUv_', name: 'amount', value: properties.amount });
  properties.currency !== undefined && properties.currency !== null
    ? eventPropertiesArray.push({ id: 'Yz7wBFPdgiD9', name: 'currency', value: properties.currency })
    : eventPropertiesArray.push({ id: 'Yz7wBFPdgiD9', name: 'currency', value: null });
  eventPropertiesArray.push({ id: 'mAYpfGackl', name: 'depositOption', value: properties.depositOption });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'g3EycOLui',
        '42b67470d6c1f16ab170084cacaf023b842d72c717d1b34eab40e6b43b6a1945',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Card Deposit Failed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('g3EycOLui', 'Card Deposit Failed', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Card Deposit Failed',
        eventProperties,
        'g3EycOLui',
        '42b67470d6c1f16ab170084cacaf023b842d72c717d1b34eab40e6b43b6a1945',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Card Deposit Failed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CardDepositSuccessfulProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  amount: number;
  currency: string | null | undefined;
  depositOption: string;
}
/**
 * Card Deposit Successful: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.amount: The amount of the asset
 * @param properties.currency: Ignore - mandatory for Braze integration
 * @param properties.depositOption: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/bG7DmKAEb}
 */
export function cardDepositSuccessful(properties: CardDepositSuccessfulProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'E_qDLUcWGUv_', name: 'amount', value: properties.amount });
  properties.currency !== undefined && properties.currency !== null
    ? eventPropertiesArray.push({ id: 'Yz7wBFPdgiD9', name: 'currency', value: properties.currency })
    : eventPropertiesArray.push({ id: 'Yz7wBFPdgiD9', name: 'currency', value: null });
  eventPropertiesArray.push({ id: 'mAYpfGackl', name: 'depositOption', value: properties.depositOption });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'bG7DmKAEb',
        'e1bde2a34a05ed5be9740eaaf682f797adc4457b31a9cc2801e948242c525b63',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Card Deposit Successful', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'bG7DmKAEb',
        'Card Deposit Successful',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Card Deposit Successful',
        eventProperties,
        'bG7DmKAEb',
        'e1bde2a34a05ed5be9740eaaf682f797adc4457b31a9cc2801e948242c525b63',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Card Deposit Successful', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BundleOpenedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  fromAssets: FromAssets[];
  layout: string;
  tradeType: TradeTypeValueType;
}
/**
 * Bundle Opened: When a user clicks Buy on single bundle
 *
 * When to trigger this event:
 * 1. Fired when the user clicks buy on a bundle
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/qjIxwVkKz/trigger/MHge8IuDc
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.fromAssets: no description
 * @param properties.layout: no description
 * @param properties.tradeType: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/qjIxwVkKz}
 */
export function bundleOpened(properties: BundleOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({
    id: '0EFQhKJ5ZM',
    name: 'fromAssets',
    value: properties.fromAssets.map(function (value) {
      return {
        asset_id: value.assetId,
        asset_code: value.assetCode,
      };
    }),
  });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'nFSjmRQoLT', name: 'tradeType', value: properties.tradeType });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertFromAssets(properties.fromAssets));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'qjIxwVkKz',
        '8c9306969669e39eee3bd0a92f0b8fd50d014f8a97b18f19148a33f5231a3420',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Bundle Opened', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('qjIxwVkKz', 'Bundle Opened', messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Bundle Opened': " + messages[0]!.message);
      }
    } else {
      messages.forEach(function (m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Bundle Opened',
        eventProperties,
        'qjIxwVkKz',
        '8c9306969669e39eee3bd0a92f0b8fd50d014f8a97b18f19148a33f5231a3420',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Bundle Opened', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BundlesNavClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  layout: string;
}
/**
 * Bundles Nav Clicked: When a user clicks on the Bundles item in web side menu.
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.layout: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/_gEQj7ZZy}
 */
export function bundlesNavClicked(properties: BundlesNavClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '_gEQj7ZZy',
        'ed80ff0ddcd32f36639b9f55a8f68b1a75a3b179c454a6270d90cb2123d6bdfb',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Bundles Nav Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('_gEQj7ZZy', 'Bundles Nav Clicked', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Bundles Nav Clicked',
        eventProperties,
        '_gEQj7ZZy',
        'ed80ff0ddcd32f36639b9f55a8f68b1a75a3b179c454a6270d90cb2123d6bdfb',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Bundles Nav Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BaseCurrencySelectedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  layout: string;
  newBaseCurrencyCode: string;
  newBaseCurrencyId: number;
}
/**
 * Base Currency Selected: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.layout: no description
 * @param properties.newBaseCurrencyCode: no description
 * @param properties.newBaseCurrencyId: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/XATL3FkTc}
 */
export function baseCurrencySelected(properties: BaseCurrencySelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: '4DnYuNUu7e', name: 'newBaseCurrencyCode', value: properties.newBaseCurrencyCode });
  eventPropertiesArray.push({ id: '00tJTo-lI9', name: 'newBaseCurrencyId', value: properties.newBaseCurrencyId });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'XATL3FkTc',
        'd68b3fcab3cdbc74338b6c26747dae733b0d2293a40428669ceb9ebac6ac7c36',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Base Currency Selected', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('XATL3FkTc', 'Base Currency Selected', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Base Currency Selected',
        eventProperties,
        'XATL3FkTc',
        'd68b3fcab3cdbc74338b6c26747dae733b0d2293a40428669ceb9ebac6ac7c36',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Base Currency Selected', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface RedirectToAffiliatePageProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Redirect To Affiliate Page: When a user is redirected to Affiliate page.
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Qecv0j5IR}
 */
export function redirectToAffiliatePage(properties: RedirectToAffiliatePageProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Qecv0j5IR',
        '816c6e0b7c45608b330ac42d5c0d5d0c0a1fe6b1153828bcb53907b40cb2b393',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Redirect To Affiliate Page', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Qecv0j5IR',
        'Redirect To Affiliate Page',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Redirect To Affiliate Page',
        eventProperties,
        'Qecv0j5IR',
        '816c6e0b7c45608b330ac42d5c0d5d0c0a1fe6b1153828bcb53907b40cb2b393',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Redirect To Affiliate Page', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchedLatestNewsProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  filterSearched: string;
  filterSelection: string[];
  filterType: string;
  newsFeedPreference: string;
}
/**
 * Searched Latest News: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.filterSearched: no description
 * @param properties.filterSelection: no description
 * @param properties.filterType: no description
 * @param properties.newsFeedPreference: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/zQ-Gp-Q_5}
 */
export function searchedLatestNews(properties: SearchedLatestNewsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'uE4mFJM1lZ', name: 'filter_searched', value: properties.filterSearched });
  eventPropertiesArray.push({ id: 'M8Pz3LrlgS', name: 'filter_selection', value: properties.filterSelection });
  eventPropertiesArray.push({ id: '_OgyruRb6e', name: 'filter_type', value: properties.filterType });
  eventPropertiesArray.push({ id: '3oMWB7Cba2', name: 'news_feed_preference', value: properties.newsFeedPreference });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'zQ-Gp-Q_5',
        'f970379829468fa4caf105784b5b2cb369b10d5524a30ab5ebe8a01b5a4f4821',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Searched Latest News', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('zQ-Gp-Q_5', 'Searched Latest News', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Searched Latest News',
        eventProperties,
        'zQ-Gp-Q_5',
        'f970379829468fa4caf105784b5b2cb369b10d5524a30ab5ebe8a01b5a4f4821',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Searched Latest News', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ViewedReferAFriendDashboardTileProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Viewed Refer A Friend Dashboard Tile: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/nfJhlHjJ3}
 */
export function viewedReferAFriendDashboardTile(properties: ViewedReferAFriendDashboardTileProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'nfJhlHjJ3',
        '7b914c1619ada93f87571c6d831332871bb0ffcc35476ecf96e7ac23ac5306f5',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Viewed Refer A Friend Dashboard Tile', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'nfJhlHjJ3',
        'Viewed Refer A Friend Dashboard Tile',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Viewed Refer A Friend Dashboard Tile',
        eventProperties,
        'nfJhlHjJ3',
        '7b914c1619ada93f87571c6d831332871bb0ffcc35476ecf96e7ac23ac5306f5',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Viewed Refer A Friend Dashboard Tile', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SOWStartedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * SOW Started: SOW Form Started
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/tjTFwprJM}
 */
export function sowStarted(properties: SOWStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'tjTFwprJM',
        '38c7bc44e2dbdfad03d0970e5d989631d2d18a2442fe6aad3259380b4e802e4e',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('SOW Started', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('tjTFwprJM', 'SOW Started', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'SOW Started',
        eventProperties,
        'tjTFwprJM',
        '38c7bc44e2dbdfad03d0970e5d989631d2d18a2442fe6aad3259380b4e802e4e',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('SOW Started', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SOWStepCompletedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  stepId: string;
}
/**
 * SOW Step Completed: SOW Form Step Completed
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.stepId: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/jZEk9iSkv}
 */
export function sowStepCompleted(properties: SOWStepCompletedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'jZEk9iSkv',
        'e38a02f860353aa1794e1ae9bc9fc4b89bbf4762dc0fb19e3abc3d6292217e37',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('SOW Step Completed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('jZEk9iSkv', 'SOW Step Completed', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'SOW Step Completed',
        eventProperties,
        'jZEk9iSkv',
        'e38a02f860353aa1794e1ae9bc9fc4b89bbf4762dc0fb19e3abc3d6292217e37',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('SOW Step Completed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SOWExitedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * SOW Exited: User exited the SOW form
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/08gBhO0k2}
 */
export function sowExited(properties: SOWExitedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '08gBhO0k2',
        '81a97e30a8a30c8f640e65b4d698a34eb37a64c19dff6ae1cf928dde3f6f1c27',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('SOW Exited', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('08gBhO0k2', 'SOW Exited', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'SOW Exited',
        eventProperties,
        '08gBhO0k2',
        '81a97e30a8a30c8f640e65b4d698a34eb37a64c19dff6ae1cf928dde3f6f1c27',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('SOW Exited', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SOWSubmittedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * SOW Submitted: SOW Form Submitted
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/DqjKKJEXe}
 */
export function sowSubmitted(properties: SOWSubmittedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'DqjKKJEXe',
        'a51a549ee2bb74b5826fa01a5ff499fbcbf37048cc75c2a6e755c304d010b936',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('SOW Submitted', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('DqjKKJEXe', 'SOW Submitted', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'SOW Submitted',
        eventProperties,
        'DqjKKJEXe',
        'a51a549ee2bb74b5826fa01a5ff499fbcbf37048cc75c2a6e755c304d010b936',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('SOW Submitted', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SOWAdditionalInformationSubmittedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * SOW Additional Information Submitted: User submitted additional information for their SOW form
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/KY-YZI0wD}
 */
export function sowAdditionalInformationSubmitted(properties: SOWAdditionalInformationSubmittedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'KY-YZI0wD',
        '7a094466b77269d0374f1adf902a012070e8b78cb0f6bbd94668ebf322e6f0ee',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('SOW Additional Information Submitted', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'KY-YZI0wD',
        'SOW Additional Information Submitted',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'SOW Additional Information Submitted',
        eventProperties,
        'KY-YZI0wD',
        '7a094466b77269d0374f1adf902a012070e8b78cb0f6bbd94668ebf322e6f0ee',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('SOW Additional Information Submitted', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClosedProfitAndStopLossModalProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Closed Profit and Stop Loss Modal: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/ze2y2i0Ws}
 */
export function closedProfitAndStopLossModal(properties: ClosedProfitAndStopLossModalProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ze2y2i0Ws',
        '1fe06a4a518c9f1ab9c37e1d78be1db0efbd28d24bfea1755bd94e1f5218cb8d',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Closed Profit and Stop Loss Modal', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'ze2y2i0Ws',
        'Closed Profit and Stop Loss Modal',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Closed Profit and Stop Loss Modal',
        eventProperties,
        'ze2y2i0Ws',
        '1fe06a4a518c9f1ab9c37e1d78be1db0efbd28d24bfea1755bd94e1f5218cb8d',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Closed Profit and Stop Loss Modal', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClickedReferAFriendDashboardBannerProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  buttonName: string;
}
/**
 * Clicked Refer A Friend Dashboard Banner: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.buttonName: The label text used directly in/on the button (eg. Buy, Sell, Quick Buy, Deposit)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/gdrxV6FeN}
 */
export function clickedReferAFriendDashboardBanner(properties: ClickedReferAFriendDashboardBannerProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'nixKBhAtEi', name: 'button_name', value: properties.buttonName });
  eventPropertiesArray.push({ id: '0N4M6cIDDh', name: 'title', value: 'Refer a friend banner' });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'gdrxV6FeN',
        '780d5d8de48b9674944747f07f8a145f5be41b9e14eb52f69895969e956f10c5',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Clicked Refer A Friend Dashboard Banner', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'gdrxV6FeN',
        'Clicked Refer A Friend Dashboard Banner',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Clicked Refer A Friend Dashboard Banner',
        eventProperties,
        'gdrxV6FeN',
        '780d5d8de48b9674944747f07f8a145f5be41b9e14eb52f69895969e956f10c5',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Clicked Refer A Friend Dashboard Banner', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface RecurringOrderOpenedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  layout: string;
  source: string;
}
/**
 * Recurring Order Opened: Clicking the create recurring/auto invest button (from various sources)
 *
 * When to trigger this event:
 * 1. Entry point - clicking the create recurring order button
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/JnQU7VaX_/trigger/BcyGyWLuR
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.layout: no description
 * @param properties.source: where does the button live that was clicked - entry points
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/JnQU7VaX_}
 */
export function recurringOrderOpened(properties: RecurringOrderOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'GfwWDva0-i', name: 'source', value: properties.source });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'JnQU7VaX_',
        '7b8bd0c029929c65f5878bd11c33749d0661ffb97d021d517af3c6b3f4fc9cf2',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Recurring Order Opened', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('JnQU7VaX_', 'Recurring Order Opened', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Recurring Order Opened',
        eventProperties,
        'JnQU7VaX_',
        '7b8bd0c029929c65f5878bd11c33749d0661ffb97d021d517af3c6b3f4fc9cf2',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Recurring Order Opened', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DeepLinkCapturedProperties {
  metadata: string | null | undefined;
  path: string | null | undefined;
  url: string | null | undefined;
  utmCampaign: string | null | undefined;
  utmMedium: string | null | undefined;
  utmSource: string | null | undefined;
}
/**
 * Deep Link Captured: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.metadata: The metadata of the deposit address or deep link
 * @param properties.path: no description
 * @param properties.url: no description
 * @param properties.utmCampaign: The UTM campaign (if any) that resulted in the user registering
 * @param properties.utmMedium: The UTM medium (if any) that resulted in the user registering
 * @param properties.utmSource: The UTM source (if any) that resulted in the user registering
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/irrqAxc4Q}
 */
export function deepLinkCaptured(properties: DeepLinkCapturedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.metadata !== undefined && properties.metadata !== null
    ? eventPropertiesArray.push({ id: '8ktmKCRnxNoD', name: 'metadata', value: properties.metadata })
    : eventPropertiesArray.push({ id: '8ktmKCRnxNoD', name: 'metadata', value: null });
  properties.path !== undefined && properties.path !== null
    ? eventPropertiesArray.push({ id: 'Xn1L45pJZu', name: 'path', value: properties.path })
    : eventPropertiesArray.push({ id: 'Xn1L45pJZu', name: 'path', value: null });
  properties.url !== undefined && properties.url !== null
    ? eventPropertiesArray.push({ id: 'Ai2jZzVMxm', name: 'url', value: properties.url })
    : eventPropertiesArray.push({ id: 'Ai2jZzVMxm', name: 'url', value: null });
  properties.utmCampaign !== undefined && properties.utmCampaign !== null
    ? eventPropertiesArray.push({ id: 'AgVbvOONb', name: 'utm_campaign', value: properties.utmCampaign })
    : eventPropertiesArray.push({ id: 'AgVbvOONb', name: 'utm_campaign', value: null });
  properties.utmMedium !== undefined && properties.utmMedium !== null
    ? eventPropertiesArray.push({ id: 'NaWf3dSn4', name: 'utm_medium', value: properties.utmMedium })
    : eventPropertiesArray.push({ id: 'NaWf3dSn4', name: 'utm_medium', value: null });
  properties.utmSource !== undefined && properties.utmSource !== null
    ? eventPropertiesArray.push({ id: 'ehohzHomF', name: 'utm_source', value: properties.utmSource })
    : eventPropertiesArray.push({ id: 'ehohzHomF', name: 'utm_source', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'irrqAxc4Q',
        '500588959a815b2cc52fd022608ad1d335bc75c5947ea0a321cf7e93e4be7e18',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Deep Link Captured', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('irrqAxc4Q', 'Deep Link Captured', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Deep Link Captured',
        eventProperties,
        'irrqAxc4Q',
        '500588959a815b2cc52fd022608ad1d335bc75c5947ea0a321cf7e93e4be7e18',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Deep Link Captured', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CategoryListBuyButtonClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  category: string;
}
/**
 * Category List Buy Button Clicked: When a user clicks 'Buy' on a single category row on the Asset List page, where Categories tab is active.
 *
 * When to trigger this event:
 * 1. A user clicks Buy in a single category row, in the 'Categories' tab on Asset List page.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/iwaLV-ruF/trigger/wtccsE-54
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.category: Asset Category Name
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/iwaLV-ruF}
 */
export function categoryListBuyButtonClicked(properties: CategoryListBuyButtonClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'YK6mbPkLgc', name: 'category', value: properties.category });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'iwaLV-ruF',
        '7e546ab5d9c902cb8e8a24b53fc64f8d8198ba0b7264a2fcbd01a46537b8c166',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Category List Buy Button Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'iwaLV-ruF',
        'Category List Buy Button Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Category List Buy Button Clicked',
        eventProperties,
        'iwaLV-ruF',
        '7e546ab5d9c902cb8e8a24b53fc64f8d8198ba0b7264a2fcbd01a46537b8c166',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Category List Buy Button Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DeepLinkHandledProperties {
  metadata: string | null | undefined;
  path: string | null | undefined;
  url: string | null | undefined;
}
/**
 * Deep Link Handled: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.metadata: The metadata of the deposit address or deep link
 * @param properties.path: no description
 * @param properties.url: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/82N3gXxPw}
 */
export function deepLinkHandled(properties: DeepLinkHandledProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.metadata !== undefined && properties.metadata !== null
    ? eventPropertiesArray.push({ id: '8ktmKCRnxNoD', name: 'metadata', value: properties.metadata })
    : eventPropertiesArray.push({ id: '8ktmKCRnxNoD', name: 'metadata', value: null });
  properties.path !== undefined && properties.path !== null
    ? eventPropertiesArray.push({ id: 'Xn1L45pJZu', name: 'path', value: properties.path })
    : eventPropertiesArray.push({ id: 'Xn1L45pJZu', name: 'path', value: null });
  properties.url !== undefined && properties.url !== null
    ? eventPropertiesArray.push({ id: 'Ai2jZzVMxm', name: 'url', value: properties.url })
    : eventPropertiesArray.push({ id: 'Ai2jZzVMxm', name: 'url', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '82N3gXxPw',
        '5dfd7b4a3aaed974f977e0ade63525540e1051bd4492ce68a03c49a220061e03',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Deep Link Handled', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('82N3gXxPw', 'Deep Link Handled', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Deep Link Handled',
        eventProperties,
        '82N3gXxPw',
        '5dfd7b4a3aaed974f977e0ade63525540e1051bd4492ce68a03c49a220061e03',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Deep Link Handled', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FilteredCategoryFromAssetListPageProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  category: string;
}
/**
 * Filtered Category from Asset List Page: User selected an asset on the Categories list dropdown on Asset List page.
 *
 * When to trigger this event:
 * 1. User selected an asset on the Categories list dropdown on Asset List page.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/5C1bAyF1p/trigger/or9ST1mow
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.category: Asset Category Name
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/5C1bAyF1p}
 */
export function filteredCategoryFromAssetListPage(properties: FilteredCategoryFromAssetListPageProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'YK6mbPkLgc', name: 'category', value: properties.category });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '5C1bAyF1p',
        '02da71ec3ebf0325c536fbc52aaac47f9cfe77336ac9ffa4788b251dc4f67b8b',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Filtered Category from Asset List Page', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '5C1bAyF1p',
        'Filtered Category from Asset List Page',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Filtered Category from Asset List Page',
        eventProperties,
        '5C1bAyF1p',
        '02da71ec3ebf0325c536fbc52aaac47f9cfe77336ac9ffa4788b251dc4f67b8b',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Filtered Category from Asset List Page', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClickedCategoryFromAssetPageProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  category: string;
  assetId: number;
  assetCode: string;
}
/**
 * Clicked Category from Asset Page: When a user clicks on a single category chip from a Single Asset Page
 *
 * When to trigger this event:
 * 1. User clicked on single category chip from Single Asset Page asset Info component.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/GMoHGRklM/trigger/KhIOxf-Tw
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.category: Asset Category Name
 * @param properties.assetId: The database ID of the asset
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/GMoHGRklM}
 */
export function clickedCategoryFromAssetPage(properties: ClickedCategoryFromAssetPageProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'YK6mbPkLgc', name: 'category', value: properties.category });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'GMoHGRklM',
        'fd3bd49228532fc2ad3fc443145ecd19e9c8f3d3be9a840d045a5d96fd579cfc',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Clicked Category from Asset Page', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'GMoHGRklM',
        'Clicked Category from Asset Page',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Clicked Category from Asset Page',
        eventProperties,
        'GMoHGRklM',
        'fd3bd49228532fc2ad3fc443145ecd19e9c8f3d3be9a840d045a5d96fd579cfc',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Clicked Category from Asset Page', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface WithdrawFundsTappedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  component: string;
}
/**
 * Withdraw Funds Tapped: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.component: Name of the react component
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/lyaJBylGF}
 */
export function withdrawFundsTapped(properties: WithdrawFundsTappedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'zhKfyo0ZNZ', name: 'component', value: properties.component });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'lyaJBylGF',
        '26ad061233de78e8bf47eefdb3790388fd6bb086dbe6beddf1eff536130bdcaf',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Withdraw Funds Tapped', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('lyaJBylGF', 'Withdraw Funds Tapped', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Withdraw Funds Tapped',
        eventProperties,
        'lyaJBylGF',
        '26ad061233de78e8bf47eefdb3790388fd6bb086dbe6beddf1eff536130bdcaf',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Withdraw Funds Tapped', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MigrateCheckboxAcceptedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Migrate Checkbox Accepted: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/J0K-8v1Eb}
 */
export function migrateCheckboxAccepted(properties: MigrateCheckboxAcceptedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'J0K-8v1Eb',
        '3ef0ecfed65c0c42c50d689b729d1959209d3a6f2d06929a81728422e6539957',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Migrate Checkbox Accepted', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'J0K-8v1Eb',
        'Migrate Checkbox Accepted',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Migrate Checkbox Accepted',
        eventProperties,
        'J0K-8v1Eb',
        '3ef0ecfed65c0c42c50d689b729d1959209d3a6f2d06929a81728422e6539957',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Migrate Checkbox Accepted', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SwitchedNewsTabProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  switchedTo: string;
}
/**
 * Switched News Tab: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.switchedTo: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/9atOdqpfH}
 */
export function switchedNewsTab(properties: SwitchedNewsTabProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0a9TdcDePH', name: 'switched_to', value: properties.switchedTo });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '9atOdqpfH',
        'f576e599e1eecc2cb57745131f9af1502109839a3b6c8f1204d47fbdda35849f',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Switched News Tab', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('9atOdqpfH', 'Switched News Tab', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Switched News Tab',
        eventProperties,
        '9atOdqpfH',
        'f576e599e1eecc2cb57745131f9af1502109839a3b6c8f1204d47fbdda35849f',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Switched News Tab', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface RecurringOrderCreatedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  orders: Orders;
  templateSource: TemplateSourceValueType;
}
/**
 * Recurring Order Created: Existing event for web FE when a recurring order is created

Likely to be the one we use going forward to cover all FE creation events
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.orders: no description
 * @param properties.templateSource: What the template source was - DEPOSIT for recurring orders, ACCOUNT for auto-invest orders
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/lWBgqT9LJ}
 */
export function recurringOrderCreated(properties: RecurringOrderCreatedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({
    id: 'UXKInqqZSe',
    name: 'orders',
    value: {
      from_asset_codes: properties.orders.fromAssetCodes,
      from_asset_ids: properties.orders.fromAssetIds,
      percentages: properties.orders.percentages,
      to_asset_codes: properties.orders.toAssetCodes,
      to_asset_ids: properties.orders.toAssetIds,
      from_qtys: properties.orders.fromQtys,
      to_qtys: properties.orders.toQtys,
      trigger_prices: properties.orders.triggerPrices,
      fee_per_units: properties.orders.feePerUnits,
    },
  });
  eventPropertiesArray.push({ id: 'KMkVj6WSv', name: 'template_source', value: properties.templateSource });
  eventPropertiesArray.push({ id: 'nFSjmRQoLT', name: 'tradeType', value: 'Recurring' });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertOrders(properties.orders));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'lWBgqT9LJ',
        'a8691a9b8b4b2271b6fd5393a84b3bf6467da6c4bf23957dacf3572304e86000',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Recurring Order Created', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'lWBgqT9LJ',
        'Recurring Order Created',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Recurring Order Created': " + messages[0]!.message);
      }
    } else {
      messages.forEach(function (m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Recurring Order Created',
        eventProperties,
        'lWBgqT9LJ',
        'a8691a9b8b4b2271b6fd5393a84b3bf6467da6c4bf23957dacf3572304e86000',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Recurring Order Created', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface RecurringOrderUpsellClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  layout: string;
}
/**
 * Recurring Order Upsell Clicked: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.layout: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/1GwnVRFGE}
 */
export function recurringOrderUpsellClicked(properties: RecurringOrderUpsellClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '1GwnVRFGE',
        'e68fc81cbae6b16df2e4c2d4d8da003ac003d3a7d57b785a481b6263d024cc98',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Recurring Order Upsell Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '1GwnVRFGE',
        'Recurring Order Upsell Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Recurring Order Upsell Clicked',
        eventProperties,
        '1GwnVRFGE',
        'e68fc81cbae6b16df2e4c2d4d8da003ac003d3a7d57b785a481b6263d024cc98',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Recurring Order Upsell Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface RefreshedLatestNewsProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  newsFeedPreference: string;
}
/**
 * Refreshed Latest News: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.newsFeedPreference: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/HFyRRf4-c}
 */
export function refreshedLatestNews(properties: RefreshedLatestNewsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '3oMWB7Cba2', name: 'news_feed_preference', value: properties.newsFeedPreference });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'HFyRRf4-c',
        'b460678d03f0b563cf6229de74b66b53f6527ef1b72659e962fcec5989e1dbc9',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Refreshed Latest News', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('HFyRRf4-c', 'Refreshed Latest News', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Refreshed Latest News',
        eventProperties,
        'HFyRRf4-c',
        'b460678d03f0b563cf6229de74b66b53f6527ef1b72659e962fcec5989e1dbc9',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Refreshed Latest News', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CategoryListSortedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  direction: string;
  sortKey: string;
}
/**
 * Category List Sorted: When a user sorts the Category list on Assets List page.
 * 
 * When to trigger this event:
 * 1. A user filtered on the Categories table. 
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Dh0MS0LH0/trigger/kGvrFDFCz
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.direction: Whether this is a buy or sell or swap etc

Includes Buy (long) and Sell (short) for derivatives positions
-  direction will be locked to the direction of the overall position open (the close position event will have the same direction as the open event) 
 * @param properties.sortKey: no description
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Dh0MS0LH0}
 */
export function categoryListSorted(properties: CategoryListSortedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '3OSDJUQA94', name: 'direction', value: properties.direction });
  eventPropertiesArray.push({ id: 'h5_AMzzJKC', name: 'sort_key', value: properties.sortKey });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Dh0MS0LH0',
        '038dfe7f98e6a7a5c270e2dda6022006cffa9864f2a07dc50ce456d4e594c3e3',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Category List Sorted', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('Dh0MS0LH0', 'Category List Sorted', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Category List Sorted',
        eventProperties,
        'Dh0MS0LH0',
        '038dfe7f98e6a7a5c270e2dda6022006cffa9864f2a07dc50ce456d4e594c3e3',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Category List Sorted', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LearnArticleOpenedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  layout: string;
  articleLink: string;
  articleTitle: string;
}
/**
 * Learn Article Opened: When users click on a Learn article
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/0QCgb4l_d/trigger/N9Og8VGSv
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.layout: no description
 * @param properties.articleLink: The link to the article that the customer was directed to
 * @param properties.articleTitle: Article title
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/0QCgb4l_d}
 */
export function learnArticleOpened(properties: LearnArticleOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'Bb0Zuum-I7', name: 'article_link', value: properties.articleLink });
  eventPropertiesArray.push({ id: 'hbhCqitElB', name: 'article_title', value: properties.articleTitle });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '0QCgb4l_d',
        'c582a714ebf0e7ff58e9e6c55d218b2320e65bf982e5b086caddd2bb38dba757',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Learn Article Opened', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('0QCgb4l_d', 'Learn Article Opened', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Learn Article Opened',
        eventProperties,
        '0QCgb4l_d',
        'c582a714ebf0e7ff58e9e6c55d218b2320e65bf982e5b086caddd2bb38dba757',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Learn Article Opened', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SingleCategoryAssetFromMoversCardOpenedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  assetCode: string;
  category: string;
  source: string;
}
/**
 * Single Category Asset From Movers Card Opened: When a user selects a single asset from the Gainers and Losers title on Single Category page.
 *
 * When to trigger this event:
 * 1. User clicked on a single asset from the Gainers and Losers title on Single Category page.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/J5oqj4L3X/trigger/mnNK-0ytA
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.category: Asset Category Name
 * @param properties.source: where does the button live that was clicked - entry points
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/J5oqj4L3X}
 */
export function singleCategoryAssetFromMoversCardOpened(properties: SingleCategoryAssetFromMoversCardOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'YK6mbPkLgc', name: 'category', value: properties.category });
  eventPropertiesArray.push({ id: 'GfwWDva0-i', name: 'source', value: properties.source });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'J5oqj4L3X',
        '868ae8b4c29c314d2bc84fcf651eb7aae06b5a82e9ddce763fee44e512d5780d',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Single Category Asset From Movers Card Opened', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'J5oqj4L3X',
        'Single Category Asset From Movers Card Opened',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Single Category Asset From Movers Card Opened',
        eventProperties,
        'J5oqj4L3X',
        '868ae8b4c29c314d2bc84fcf651eb7aae06b5a82e9ddce763fee44e512d5780d',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Single Category Asset From Movers Card Opened', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SingleCategoryNewsArticleOpenedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  article: string;
  category: string;
}
/**
 * Single Category News Article Opened: When a user clicks on a single News Articles on Single Category page.
 *
 * When to trigger this event:
 * 1. When a user clicks on a single News Articles on Single Category page.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/NSV1asqNO/trigger/0ENCMCjAT
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.article: Article title
 * @param properties.category: Asset Category Name
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/NSV1asqNO}
 */
export function singleCategoryNewsArticleOpened(properties: SingleCategoryNewsArticleOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'wURjEtkDqH', name: 'article', value: properties.article });
  eventPropertiesArray.push({ id: 'YK6mbPkLgc', name: 'category', value: properties.category });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'NSV1asqNO',
        '1f28e66525efe7ddbf70fa1e39defb8d630beb2ccdad25f9c24379a869bcee0d',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Single Category News Article Opened', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'NSV1asqNO',
        'Single Category News Article Opened',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Single Category News Article Opened',
        eventProperties,
        'NSV1asqNO',
        '1f28e66525efe7ddbf70fa1e39defb8d630beb2ccdad25f9c24379a869bcee0d',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Single Category News Article Opened', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SingleCategoryPageBuyBundleClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  category: string;
}
/**
 * Single Category Page Buy Bundle Clicked: When a user clicks the Buy button on a single category.
 *
 * When to trigger this event:
 * 1. User clicked Buy button on Single Category page.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/MshO5IH2I/trigger/bJsGQPJ9f
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.category: Asset Category Name
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/MshO5IH2I}
 */
export function singleCategoryPageBuyBundleClicked(properties: SingleCategoryPageBuyBundleClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'YK6mbPkLgc', name: 'category', value: properties.category });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'MshO5IH2I',
        '62b957845c68709133a4f045949befbbd73e7039083030dfd8f1577432e1dabb',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Single Category Page Buy Bundle Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'MshO5IH2I',
        'Single Category Page Buy Bundle Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Single Category Page Buy Bundle Clicked',
        eventProperties,
        'MshO5IH2I',
        '62b957845c68709133a4f045949befbbd73e7039083030dfd8f1577432e1dabb',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Single Category Page Buy Bundle Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SwitchedLatestNewsViewProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  switchedView: string;
}
/**
 * Switched Latest News View: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.switchedView: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/bt8WgcPh4}
 */
export function switchedLatestNewsView(properties: SwitchedLatestNewsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'k_V0zxNk8y', name: 'switched_view', value: properties.switchedView });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'bt8WgcPh4',
        '8e56c53970ba2829fb5a27589373d1529dac44f84d9c23a4bff61f24346207ac',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Switched Latest News View', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'bt8WgcPh4',
        'Switched Latest News View',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Switched Latest News View',
        eventProperties,
        'bt8WgcPh4',
        '8e56c53970ba2829fb5a27589373d1529dac44f84d9c23a4bff61f24346207ac',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Switched Latest News View', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MigrateConfirmedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  exchange: string;
  feeFree: boolean;
}
/**
 * Migrate Confirmed: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.exchange: The exchange that is being migrated from
 * @param properties.feeFree: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/By7z6mWf3}
 */
export function migrateConfirmed(properties: MigrateConfirmedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'BjP68ejWWGMr', name: 'exchange', value: properties.exchange });
  eventPropertiesArray.push({ id: 'njF1O9oG_X', name: 'feeFree', value: properties.feeFree });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'By7z6mWf3',
        '8603e97d7c29c6dbb18326e4220d637f07d751e90bec32e283b279c1870f245f',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Migrate Confirmed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('By7z6mWf3', 'Migrate Confirmed', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Migrate Confirmed',
        eventProperties,
        'By7z6mWf3',
        '8603e97d7c29c6dbb18326e4220d637f07d751e90bec32e283b279c1870f245f',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Migrate Confirmed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ChartTypeSelectedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  chartType: ChartTypeValueType;
  layout: string;
  assetId: number;
  assetCode: string;
}
/**
 * Chart Type Selected: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.chartType: no description
 * @param properties.layout: no description
 * @param properties.assetId: The database ID of the asset
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/42Q8OI5-v}
 */
export function chartTypeSelected(properties: ChartTypeSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'kYOgTbrt8q', name: 'chartType', value: properties.chartType });
  eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '42Q8OI5-v',
        '1028a30e5544e84ec33524bb2cfc92ae72c338a338edc33b8d7a1c82cb698950',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Chart Type Selected', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('42Q8OI5-v', 'Chart Type Selected', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Chart Type Selected',
        eventProperties,
        '42Q8OI5-v',
        '1028a30e5544e84ec33524bb2cfc92ae72c338a338edc33b8d7a1c82cb698950',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Chart Type Selected', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SingleCategoryPageTradeButtonClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  assetCode: string;
  category: string;
  tradeSide: string;
}
/**
 * Single Category Page Trade Button Clicked: A user clicked a trade button (buy or sell) on the assets table list from Single Category page.
 *
 * When to trigger this event:
 * 1. Clicked Buy or Sell on the table row from single category page.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/wWSIQxZJT/trigger/6IfYuo7jv
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.category: Asset Category Name
 * @param properties.tradeSide: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/wWSIQxZJT}
 */
export function singleCategoryPageTradeButtonClicked(properties: SingleCategoryPageTradeButtonClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'YK6mbPkLgc', name: 'category', value: properties.category });
  eventPropertiesArray.push({ id: 'RnL-i6P02P', name: 'trade_side', value: properties.tradeSide });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'wWSIQxZJT',
        '4175bba8feaca7b160bb95a2dc964e45956a0a80e40dd5633f502614f72af55d',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Single Category Page Trade Button Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'wWSIQxZJT',
        'Single Category Page Trade Button Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Single Category Page Trade Button Clicked',
        eventProperties,
        'wWSIQxZJT',
        '4175bba8feaca7b160bb95a2dc964e45956a0a80e40dd5633f502614f72af55d',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Single Category Page Trade Button Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SOWStepStartedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  stepId: string;
}
/**
 * SOW Step Started: SOW Form Step Started
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.stepId: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/eU8IAJ6bl}
 */
export function sowStepStarted(properties: SOWStepStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'eU8IAJ6bl',
        '13b55b621d6dc2e54c9df0fc265a9e2fb8578124d8419236eecf36fe8dc4c97d',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('SOW Step Started', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('eU8IAJ6bl', 'SOW Step Started', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'SOW Step Started',
        eventProperties,
        'eU8IAJ6bl',
        '13b55b621d6dc2e54c9df0fc265a9e2fb8578124d8419236eecf36fe8dc4c97d',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('SOW Step Started', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SOWBackClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  stepId: string;
}
/**
 * SOW Back Clicked: User clicked Back on the SOW form to return to a previous step
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.stepId: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Q6-C2LWV3}
 */
export function sowBackClicked(properties: SOWBackClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Q6-C2LWV3',
        '97e1f515258406c2d095960c15144d8ff4cf20e100234a9bd29469091c8b365d',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('SOW Back Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('Q6-C2LWV3', 'SOW Back Clicked', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'SOW Back Clicked',
        eventProperties,
        'Q6-C2LWV3',
        '97e1f515258406c2d095960c15144d8ff4cf20e100234a9bd29469091c8b365d',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('SOW Back Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UpdatedTradeAmountProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  amount: number;
}
/**
 * Updated Trade Amount: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.amount: The amount of the asset
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/BP3sQaMGx}
 */
export function updatedTradeAmount(properties: UpdatedTradeAmountProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'E_qDLUcWGUv_', name: 'amount', value: properties.amount });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'BP3sQaMGx',
        'b301405002bf873a73376a7a040952a107bf97eeebc59d64b2ec4e06eb808610',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Updated Trade Amount', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('BP3sQaMGx', 'Updated Trade Amount', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Updated Trade Amount',
        eventProperties,
        'BP3sQaMGx',
        'b301405002bf873a73376a7a040952a107bf97eeebc59d64b2ec4e06eb808610',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Updated Trade Amount', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SwitchedLimitAssetProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  assetCode: string;
  direction: string | null | undefined;
  assetId: number;
}
/**
 * Switched Limit Asset: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.direction: Whether this is a buy or sell or swap etc

Includes Buy (long) and Sell (short) for derivatives positions
-  direction will be locked to the direction of the overall position open (the close position event will have the same direction as the open event) 
 * @param properties.assetId: The database ID of the asset
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/_gpx9zqs8}
 */
export function switchedLimitAsset(properties: SwitchedLimitAssetProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  properties.direction !== undefined && properties.direction !== null
    ? eventPropertiesArray.push({ id: '3OSDJUQA94', name: 'direction', value: properties.direction })
    : eventPropertiesArray.push({ id: '3OSDJUQA94', name: 'direction', value: null });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '_gpx9zqs8',
        '116954b6954419ceb34e6212c12dfeeb126e6dc4d281e36e9d415903d87db10d',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Switched Limit Asset', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('_gpx9zqs8', 'Switched Limit Asset', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Switched Limit Asset',
        eventProperties,
        '_gpx9zqs8',
        '116954b6954419ceb34e6212c12dfeeb126e6dc4d281e36e9d415903d87db10d',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Switched Limit Asset', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClickedReviewTradeProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  direction: string | null | undefined;
  assetId: number | null | undefined;
  assetCode: string | null | undefined;
  amount: number | null | undefined;
  limitedAssetId: number | null | undefined;
  limitedAssetCode: string | null | undefined;
}
/**
 * Clicked Review Trade: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.direction: Whether this is a buy or sell or swap etc

Includes Buy (long) and Sell (short) for derivatives positions
-  direction will be locked to the direction of the overall position open (the close position event will have the same direction as the open event) 
 * @param properties.assetId: The database ID of the asset
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.amount: The amount of the asset
 * @param properties.limitedAssetId: The limiting asset ID when performing a quick buy
 * @param properties.limitedAssetCode: The limiting asset code when performing a quick buy
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/n5F4awu-i}
 */
export function clickedReviewTrade(properties: ClickedReviewTradeProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.direction !== undefined && properties.direction !== null
    ? eventPropertiesArray.push({ id: '3OSDJUQA94', name: 'direction', value: properties.direction })
    : eventPropertiesArray.push({ id: '3OSDJUQA94', name: 'direction', value: null });
  properties.assetId !== undefined && properties.assetId !== null
    ? eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId })
    : eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: null });
  properties.assetCode !== undefined && properties.assetCode !== null
    ? eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode })
    : eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: null });
  properties.amount !== undefined && properties.amount !== null
    ? eventPropertiesArray.push({ id: 'E_qDLUcWGUv_', name: 'amount', value: properties.amount })
    : eventPropertiesArray.push({ id: 'E_qDLUcWGUv_', name: 'amount', value: null });
  properties.limitedAssetId !== undefined && properties.limitedAssetId !== null
    ? eventPropertiesArray.push({ id: 'APUjes988', name: 'limited_asset_id', value: properties.limitedAssetId })
    : eventPropertiesArray.push({ id: 'APUjes988', name: 'limited_asset_id', value: null });
  properties.limitedAssetCode !== undefined && properties.limitedAssetCode !== null
    ? eventPropertiesArray.push({ id: '8HO-2izYb', name: 'limited_asset_code', value: properties.limitedAssetCode })
    : eventPropertiesArray.push({ id: '8HO-2izYb', name: 'limited_asset_code', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'n5F4awu-i',
        'e6f1db2d9fe2b67b5122e46a31665c0666d93717396912f54aa3ff17f926d490',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Clicked Review Trade', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('n5F4awu-i', 'Clicked Review Trade', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Clicked Review Trade',
        eventProperties,
        'n5F4awu-i',
        'e6f1db2d9fe2b67b5122e46a31665c0666d93717396912f54aa3ff17f926d490',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Clicked Review Trade', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClickedPreMinusSelectedAmountProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  quickBuyPresetAmount: QuickBuyPresetAmountValueType;
  assetId: number | null | undefined;
  limitedAssetId: number | null | undefined;
  limitedAssetCode: string | null | undefined;
  assetCode: string | null | undefined;
  direction: string | null | undefined;
}
/**
 * Clicked Pre-Selected Amount: The user selects one of the preset amounts for quick buy
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.quickBuyPresetAmount: The amount selected for quick buy from the provided presets
 * @param properties.assetId: The database ID of the asset
 * @param properties.limitedAssetId: The limiting asset ID when performing a quick buy
 * @param properties.limitedAssetCode: The limiting asset code when performing a quick buy
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.direction: Whether this is a buy or sell or swap etc

Includes Buy (long) and Sell (short) for derivatives positions
-  direction will be locked to the direction of the overall position open (the close position event will have the same direction as the open event) 
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/QUhUYgzKI}
 */
export function clickedPreSelectedAmount(properties: ClickedPreMinusSelectedAmountProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({
    id: 'nqzBrp1lF',
    name: 'quick_buy_preset_amount',
    value: properties.quickBuyPresetAmount,
  });
  properties.assetId !== undefined && properties.assetId !== null
    ? eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId })
    : eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: null });
  properties.limitedAssetId !== undefined && properties.limitedAssetId !== null
    ? eventPropertiesArray.push({ id: 'APUjes988', name: 'limited_asset_id', value: properties.limitedAssetId })
    : eventPropertiesArray.push({ id: 'APUjes988', name: 'limited_asset_id', value: null });
  properties.limitedAssetCode !== undefined && properties.limitedAssetCode !== null
    ? eventPropertiesArray.push({ id: '8HO-2izYb', name: 'limited_asset_code', value: properties.limitedAssetCode })
    : eventPropertiesArray.push({ id: '8HO-2izYb', name: 'limited_asset_code', value: null });
  properties.assetCode !== undefined && properties.assetCode !== null
    ? eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode })
    : eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: null });
  properties.direction !== undefined && properties.direction !== null
    ? eventPropertiesArray.push({ id: '3OSDJUQA94', name: 'direction', value: properties.direction })
    : eventPropertiesArray.push({ id: '3OSDJUQA94', name: 'direction', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'QUhUYgzKI',
        '1dadb816c0f1886137ba5b87c0eddb45df4084435ae079cc1da0b885876ee63f',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Clicked Pre-Selected Amount', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'QUhUYgzKI',
        'Clicked Pre-Selected Amount',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Clicked Pre-Selected Amount',
        eventProperties,
        'QUhUYgzKI',
        '1dadb816c0f1886137ba5b87c0eddb45df4084435ae079cc1da0b885876ee63f',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Clicked Pre-Selected Amount', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SelectedTradeAssetProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  assetCode: string;
  direction: string | null | undefined;
  assetId: number;
}
/**
 * Selected Trade Asset: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.direction: Whether this is a buy or sell or swap etc

Includes Buy (long) and Sell (short) for derivatives positions
-  direction will be locked to the direction of the overall position open (the close position event will have the same direction as the open event) 
 * @param properties.assetId: The database ID of the asset
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/OtnaWqt6f}
 */
export function selectedTradeAsset(properties: SelectedTradeAssetProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  properties.direction !== undefined && properties.direction !== null
    ? eventPropertiesArray.push({ id: '3OSDJUQA94', name: 'direction', value: properties.direction })
    : eventPropertiesArray.push({ id: '3OSDJUQA94', name: 'direction', value: null });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'OtnaWqt6f',
        '1099bf1a4bfab055ad7fa88d712e0ffa125c643394834b0179ab077c4ec68628',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Selected Trade Asset', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('OtnaWqt6f', 'Selected Trade Asset', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Selected Trade Asset',
        eventProperties,
        'OtnaWqt6f',
        '1099bf1a4bfab055ad7fa88d712e0ffa125c643394834b0179ab077c4ec68628',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Selected Trade Asset', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UpdatedPaymentOptionProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  paymentOption: string;
}
/**
 * Updated Payment Option: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.paymentOption: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Y1vGE-8zb}
 */
export function updatedPaymentOption(properties: UpdatedPaymentOptionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'Hu7q_A4Fe6', name: 'paymentOption', value: properties.paymentOption });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Y1vGE-8zb',
        'be16c4713ae25b0eb8e594f76fa47655c861bbaa06d384a8f860d5f8252c7355',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Updated Payment Option', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('Y1vGE-8zb', 'Updated Payment Option', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Updated Payment Option',
        eventProperties,
        'Y1vGE-8zb',
        'be16c4713ae25b0eb8e594f76fa47655c861bbaa06d384a8f860d5f8252c7355',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Updated Payment Option', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SwitchedTradeDirectionProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  direction: string;
  assetId: number | null | undefined;
  assetCode: string | null | undefined;
  limitedAssetId: number | null | undefined;
  limitedAssetCode: string | null | undefined;
}
/**
 * Switched Trade Direction: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.direction: Whether this is a buy or sell or swap etc

Includes Buy (long) and Sell (short) for derivatives positions
-  direction will be locked to the direction of the overall position open (the close position event will have the same direction as the open event) 
 * @param properties.assetId: The database ID of the asset
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.limitedAssetId: The limiting asset ID when performing a quick buy
 * @param properties.limitedAssetCode: The limiting asset code when performing a quick buy
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/QcsrrsxFu}
 */
export function switchedTradeDirection(properties: SwitchedTradeDirectionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '3OSDJUQA94', name: 'direction', value: properties.direction });
  properties.assetId !== undefined && properties.assetId !== null
    ? eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId })
    : eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: null });
  properties.assetCode !== undefined && properties.assetCode !== null
    ? eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode })
    : eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: null });
  properties.limitedAssetId !== undefined && properties.limitedAssetId !== null
    ? eventPropertiesArray.push({ id: 'APUjes988', name: 'limited_asset_id', value: properties.limitedAssetId })
    : eventPropertiesArray.push({ id: 'APUjes988', name: 'limited_asset_id', value: null });
  properties.limitedAssetCode !== undefined && properties.limitedAssetCode !== null
    ? eventPropertiesArray.push({ id: '8HO-2izYb', name: 'limited_asset_code', value: properties.limitedAssetCode })
    : eventPropertiesArray.push({ id: '8HO-2izYb', name: 'limited_asset_code', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'QcsrrsxFu',
        '45dba4fd5c6401e5d74cff77cb343dcbaa422c555087f9845b456b8962c4583f',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Switched Trade Direction', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'QcsrrsxFu',
        'Switched Trade Direction',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Switched Trade Direction',
        eventProperties,
        'QcsrrsxFu',
        '45dba4fd5c6401e5d74cff77cb343dcbaa422c555087f9845b456b8962c4583f',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Switched Trade Direction', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface QuickBuyTradeExecutedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  direction: string;
  amount: number;
  assetCode: string;
  paymentOption: string;
  assetId: number | null | undefined;
  limitedAssetId: number | null | undefined;
  limitedAssetCode: string | null | undefined;
  userCountryValue: number | null | undefined;
}
/**
 * Quick Buy Trade Executed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.direction: Whether this is a buy or sell or swap etc

Includes Buy (long) and Sell (short) for derivatives positions
-  direction will be locked to the direction of the overall position open (the close position event will have the same direction as the open event) 
 * @param properties.amount: The amount of the asset
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.paymentOption: no description
 * @param properties.assetId: The database ID of the asset
 * @param properties.limitedAssetId: The limiting asset ID when performing a quick buy
 * @param properties.limitedAssetCode: The limiting asset code when performing a quick buy
 * @param properties.userCountryValue: The value in the user's country currency
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/VPsApb5tbE}
 */
export function quickBuyTradeExecuted(properties: QuickBuyTradeExecutedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '3OSDJUQA94', name: 'direction', value: properties.direction });
  eventPropertiesArray.push({ id: 'E_qDLUcWGUv_', name: 'amount', value: properties.amount });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'Hu7q_A4Fe6', name: 'paymentOption', value: properties.paymentOption });
  properties.assetId !== undefined && properties.assetId !== null
    ? eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId })
    : eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: null });
  properties.limitedAssetId !== undefined && properties.limitedAssetId !== null
    ? eventPropertiesArray.push({ id: 'APUjes988', name: 'limited_asset_id', value: properties.limitedAssetId })
    : eventPropertiesArray.push({ id: 'APUjes988', name: 'limited_asset_id', value: null });
  properties.limitedAssetCode !== undefined && properties.limitedAssetCode !== null
    ? eventPropertiesArray.push({ id: '8HO-2izYb', name: 'limited_asset_code', value: properties.limitedAssetCode })
    : eventPropertiesArray.push({ id: '8HO-2izYb', name: 'limited_asset_code', value: null });
  properties.userCountryValue !== undefined && properties.userCountryValue !== null
    ? eventPropertiesArray.push({ id: 'K2Bbo1U8w5MP', name: 'user_country_value', value: properties.userCountryValue })
    : eventPropertiesArray.push({ id: 'K2Bbo1U8w5MP', name: 'user_country_value', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'VPsApb5tbE',
        '5d062bd167ec948951fb8f715af1f4b2103ddd3c6bfc61311f17bf62ca988ff8',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Quick Buy Trade Executed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'VPsApb5tbE',
        'Quick Buy Trade Executed',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Quick Buy Trade Executed',
        eventProperties,
        'VPsApb5tbE',
        '5d062bd167ec948951fb8f715af1f4b2103ddd3c6bfc61311f17bf62ca988ff8',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Quick Buy Trade Executed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface QuickBuyTradeCompletedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Quick Buy Trade Completed: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/nqTQvzHI1H}
 */
export function quickBuyTradeCompleted(properties: QuickBuyTradeCompletedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'nqTQvzHI1H',
        'c9115a9bb0388057a2a2e9ee51c6922e8636ed8d6774e4a652e6cbd2aa25c030',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Quick Buy Trade Completed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'nqTQvzHI1H',
        'Quick Buy Trade Completed',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Quick Buy Trade Completed',
        eventProperties,
        'nqTQvzHI1H',
        'c9115a9bb0388057a2a2e9ee51c6922e8636ed8d6774e4a652e6cbd2aa25c030',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Quick Buy Trade Completed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface WebIdentifyProperties {
  userId_: string;
}
/**
 * Web Identify: Identifies the user on Web upon registration/login, not a real event
 *
 * @param properties the properties associatied with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/ALYmwHkfnv}
 */
export function webIdentify(properties: WebIdentifyProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ALYmwHkfnv',
        'f61e7a2933c2f0a77ae106a6add478220d9a44f3aab28b58f9dc551efb151fb4',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Web Identify', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('ALYmwHkfnv', 'Web Identify', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    // destination RudderStack
    RudderStack.identify(properties.userId_);
  } else {
    // do nothing
  }
}

export interface PageViewedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  customDestinationPageName_: string;
  assetCode: string | null | undefined;
  assetId: number | null | undefined;
  layout: string | null | undefined;
  userId: string | null | undefined;
}
/**
 * Page Viewed: No description
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.assetId: The database ID of the asset
 * @param properties.layout: no description
 * @param properties.userId: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/LjgppMsmlh}
 */
export function pageViewed(properties: PageViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.assetCode !== undefined && properties.assetCode !== null
    ? eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode })
    : eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: null });
  properties.assetId !== undefined && properties.assetId !== null
    ? eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId })
    : eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: null });
  properties.layout !== undefined && properties.layout !== null
    ? eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: properties.layout })
    : eventPropertiesArray.push({ id: '0TpR6u3YbC', name: 'layout', value: null });
  properties.userId !== undefined && properties.userId !== null
    ? eventPropertiesArray.push({ id: 'hlvDl9JoverHkdqkTrOGr', name: 'user_id', value: properties.userId })
    : eventPropertiesArray.push({ id: 'hlvDl9JoverHkdqkTrOGr', name: 'user_id', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'LjgppMsmlh',
        '813cd1ef35635b01e0fe1f6aeab07354300e9ffc3c6aa53494817690eb0d3990',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Page Viewed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('LjgppMsmlh', 'Page Viewed', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    // destination RudderStack
    if (RudderStack.logPage) {
      RudderStack.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface GlobalSearchBarOpenedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  globalSearchOpenMethod: GlobalSearchOpenMethodValueType[];
}
/**
 * Global Search Bar Opened: When a user opens the global search bar initially
 * 
 * When to trigger this event:
 * 1. Clicking on the Search icon in the top right manually
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/YHAfeIhwf/trigger/dtw0_jDHa
 * 2. Typing the ' / ' key to automatically bring up the search bar

(web only)
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/YHAfeIhwf/trigger/quOsJt3dR
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.globalSearchOpenMethod: Method used to open the Global Search Bar

Did they click on it manually or use the ' / ' shortcut ?
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/YHAfeIhwf}
 */
export function globalSearchBarOpened(properties: GlobalSearchBarOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({
    id: 'Q3GmfFafT',
    name: 'global_search_open_method',
    value: properties.globalSearchOpenMethod,
  });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'YHAfeIhwf',
        'a4720b437da9e0c07cade069a90748e2f6bb6b2c723a1de4129f400092858c67',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Global Search Bar Opened', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'YHAfeIhwf',
        'Global Search Bar Opened',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Global Search Bar Opened',
        eventProperties,
        'YHAfeIhwf',
        'a4720b437da9e0c07cade069a90748e2f6bb6b2c723a1de4129f400092858c67',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Global Search Bar Opened', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface GlobalSearchBarInputFieldCompletedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  inputFieldContent: string;
}
/**
 * Global Search Bar Input Field Completed: When a user actually types something into the input field itself

(different to clicking an option that was pre-filled / suggested without ever typing anything)


Logic for what counts as a 'Completed' action is when the mouse moves away from the input field and it becomes 'blurred'
 * 
 * When to trigger this event:
 * 1. The function auto-completes as you type, so you do not need to hit Enter / confirm
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/ymzXnY_Rm/trigger/v4BM0R0mm
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.inputFieldContent: What is entered into the search bar input field

(may need to have some kind of smarts to only log once the user has stopped typing)
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/ymzXnY_Rm}
 */
export function globalSearchBarInputFieldCompleted(properties: GlobalSearchBarInputFieldCompletedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '6fKWm8Gel', name: 'input_field_content', value: properties.inputFieldContent });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ymzXnY_Rm',
        'e7a1f3643dc569e90cddbd1f748c4f61fd3b020bae0d7eaf971c1018dcaf427c',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Global Search Bar Input Field Completed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'ymzXnY_Rm',
        'Global Search Bar Input Field Completed',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Global Search Bar Input Field Completed',
        eventProperties,
        'ymzXnY_Rm',
        'e7a1f3643dc569e90cddbd1f748c4f61fd3b020bae0d7eaf971c1018dcaf427c',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Global Search Bar Input Field Completed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface GlobalSearchBarResultClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  searchBarResultName: string;
  searchBarResultCategory: string;
}
/**
 * Global Search Bar Result Clicked: Clicking on something that popped up in the search component
 * 
 * When to trigger this event:
 * 1. Actually clicking on something that popped up in the search component
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/tcVeY-urr/trigger/bGr3qtlyz
 * 2. The headings / categories that split up the results provided
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/tcVeY-urr/trigger/vgdSqczU9
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.searchBarResultName: The title/name of the row in the search results
 * @param properties.searchBarResultCategory: Category / headings input on new uplift

eg.

Settings
Favourite assets
Other assets
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/tcVeY-urr}
 */
export function globalSearchBarResultClicked(properties: GlobalSearchBarResultClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'vaOj9OQM0', name: 'search_bar_result_name', value: properties.searchBarResultName });
  eventPropertiesArray.push({
    id: 'nWEJ4V_bu',
    name: 'search_bar_result_category',
    value: properties.searchBarResultCategory,
  });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'tcVeY-urr',
        '2e63aaac54440a66b421e1c4c20857e48c57c9191fb5f630a231c89a37f598eb',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Global Search Bar Result Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'tcVeY-urr',
        'Global Search Bar Result Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Global Search Bar Result Clicked',
        eventProperties,
        'tcVeY-urr',
        '2e63aaac54440a66b421e1c4c20857e48c57c9191fb5f630a231c89a37f598eb',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Global Search Bar Result Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ViewedRegisterPageProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  customDestinationPageName_: string;
  referralCode: string | null | undefined;
  promoCode: string;
  utmMedium: string | null | undefined;
  utmSource: string | null | undefined;
  utmCampaign: string | null | undefined;
}
/**
 * Viewed Register Page: A new unidentified user viewed the register page.
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.customDestinationPageName_: Name of the page or screen
 * @param properties.referralCode: The referral code a user includes to sign up, provided by an affiliate
 * @param properties.promoCode: The promo code a user used to register
 * @param properties.utmMedium: The UTM medium (if any) that resulted in the user registering
 * @param properties.utmSource: The UTM source (if any) that resulted in the user registering
 * @param properties.utmCampaign: The UTM campaign (if any) that resulted in the user registering
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/UOsJqJdpr}
 */
export function viewedRegisterPage(properties: ViewedRegisterPageProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.referralCode !== undefined && properties.referralCode !== null
    ? eventPropertiesArray.push({ id: 'KQRReZcwI2FA', name: 'referral_code', value: properties.referralCode })
    : eventPropertiesArray.push({ id: 'KQRReZcwI2FA', name: 'referral_code', value: null });
  eventPropertiesArray.push({ id: 'RwuJkZFe5mW0', name: 'promo_code', value: properties.promoCode });
  properties.utmMedium !== undefined && properties.utmMedium !== null
    ? eventPropertiesArray.push({ id: 'NaWf3dSn4', name: 'utm_medium', value: properties.utmMedium })
    : eventPropertiesArray.push({ id: 'NaWf3dSn4', name: 'utm_medium', value: null });
  properties.utmSource !== undefined && properties.utmSource !== null
    ? eventPropertiesArray.push({ id: 'ehohzHomF', name: 'utm_source', value: properties.utmSource })
    : eventPropertiesArray.push({ id: 'ehohzHomF', name: 'utm_source', value: null });
  properties.utmCampaign !== undefined && properties.utmCampaign !== null
    ? eventPropertiesArray.push({ id: 'AgVbvOONb', name: 'utm_campaign', value: properties.utmCampaign })
    : eventPropertiesArray.push({ id: 'AgVbvOONb', name: 'utm_campaign', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'UOsJqJdpr',
        '9158dc10448d9e1c1ed1ceeeef4d880293c31f2c31d1b70115bc5036451be565',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Viewed Register Page', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('UOsJqJdpr', 'Viewed Register Page', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    // destination RudderStack
    if (RudderStack.logPage) {
      RudderStack.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface GettingStartedTileOpenedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  tileName: TileNameValueType;
}
/**
 * Getting Started Tile Opened: When a user clicks one of the Getting Started tiles on the onboarding dashboard
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.tileName: Title of the tile
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Mo3SAiP8i5}
 */
export function gettingStartedTileOpened(properties: GettingStartedTileOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'FVB72d8FB', name: 'tile_name', value: properties.tileName });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Mo3SAiP8i5',
        'ee818e5bb22b3d0975307e5fad93a01dca84d58c80e28955c30ab1ddf644c825',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Getting Started Tile Opened', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Mo3SAiP8i5',
        'Getting Started Tile Opened',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Getting Started Tile Opened',
        eventProperties,
        'Mo3SAiP8i5',
        'ee818e5bb22b3d0975307e5fad93a01dca84d58c80e28955c30ab1ddf644c825',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Getting Started Tile Opened', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AssetSelectedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  searchValue: string | null | undefined;
  quickFilterUsed: QuickFilterUsedValueType;
  assetCode: string;
  modalName: ModalNameValueType | null | undefined;
  featureName: string | null | undefined;
}
/**
 * Asset Selected: Specific user interactions at the asset selection stage on recurring order creation modal
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/GyiVofC2MC/trigger/WMH3Cg45d
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.searchValue: manually typing something into the input field
 * @param properties.quickFilterUsed: Initially created specifically in recurring orders creation flow - could be expanded further
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.modalName: Name of the modal in question (optional)
 * @param properties.featureName: Name of overall feature / flow being interacted with (optional)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/GyiVofC2MC}
 */
export function assetSelected(properties: AssetSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.searchValue !== undefined && properties.searchValue !== null
    ? eventPropertiesArray.push({ id: 's-9MPC7rWG', name: 'search_value', value: properties.searchValue })
    : eventPropertiesArray.push({ id: 's-9MPC7rWG', name: 'search_value', value: null });
  eventPropertiesArray.push({ id: 'huc7rn3_b', name: 'quick_filter_used', value: properties.quickFilterUsed });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  properties.modalName !== undefined && properties.modalName !== null
    ? eventPropertiesArray.push({ id: 'NO9CObS3y', name: 'modal_name', value: properties.modalName })
    : eventPropertiesArray.push({ id: 'NO9CObS3y', name: 'modal_name', value: null });
  properties.featureName !== undefined && properties.featureName !== null
    ? eventPropertiesArray.push({ id: 'jtQWj9fe2', name: 'feature_name', value: properties.featureName })
    : eventPropertiesArray.push({ id: 'jtQWj9fe2', name: 'feature_name', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'GyiVofC2MC',
        '68d7c289aabd40c07cd5dd6eb297b49f58125ebf13d8cae6a454fe26f30c3740',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Asset Selected', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('GyiVofC2MC', 'Asset Selected', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Asset Selected',
        eventProperties,
        'GyiVofC2MC',
        '68d7c289aabd40c07cd5dd6eb297b49f58125ebf13d8cae6a454fe26f30c3740',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Asset Selected', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface RecurringOrderCreationAmountSelectedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  presetAmount: string | null | undefined;
  amount: number;
}
/**
 * Recurring Order Creation Amount Selected: Set your preferences stage of recurring order setup
 *
 * When to trigger this event:
 * 1. Just measuring usage of the quick input buttons
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/fEQ57iZE2L/trigger/u0b7XHcrX
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.presetAmount: Value on the preset button
 * @param properties.amount: The amount of the asset
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/fEQ57iZE2L}
 */
export function recurringOrderCreationAmountSelected(properties: RecurringOrderCreationAmountSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.presetAmount !== undefined && properties.presetAmount !== null
    ? eventPropertiesArray.push({ id: 'tkoJKqqRX', name: 'preset_amount', value: properties.presetAmount })
    : eventPropertiesArray.push({ id: 'tkoJKqqRX', name: 'preset_amount', value: null });
  eventPropertiesArray.push({ id: 'E_qDLUcWGUv_', name: 'amount', value: properties.amount });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'fEQ57iZE2L',
        '34e221f3eac906f4f59a1f0c894f13c2e96f442b861a493848daaeff9a8649b9',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Recurring Order Creation Amount Selected', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'fEQ57iZE2L',
        'Recurring Order Creation Amount Selected',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Recurring Order Creation Amount Selected',
        eventProperties,
        'fEQ57iZE2L',
        '34e221f3eac906f4f59a1f0c894f13c2e96f442b861a493848daaeff9a8649b9',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Recurring Order Creation Amount Selected', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FollowUpActionPromptClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  buttonName: string;
  modalName: ModalNameValueType | null | undefined;
  featureName: string | null | undefined;
}
/**
 * Follow Up Action Prompt Clicked: When a user clicks a CTA button we have put at the end of a flow as a follow up option

eg. 
Create another order
View wallet
Deposit funds
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/NjRMjbPKAE/trigger/MyCD3RTEt
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.buttonName: The label text used directly in/on the button (eg. Buy, Sell, Quick Buy, Deposit)
 * @param properties.modalName: Name of the modal in question (optional)
 * @param properties.featureName: Name of overall feature / flow being interacted with (optional)
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/NjRMjbPKAE}
 */
export function followUpActionPromptClicked(properties: FollowUpActionPromptClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'nixKBhAtEi', name: 'button_name', value: properties.buttonName });
  properties.modalName !== undefined && properties.modalName !== null
    ? eventPropertiesArray.push({ id: 'NO9CObS3y', name: 'modal_name', value: properties.modalName })
    : eventPropertiesArray.push({ id: 'NO9CObS3y', name: 'modal_name', value: null });
  properties.featureName !== undefined && properties.featureName !== null
    ? eventPropertiesArray.push({ id: 'jtQWj9fe2', name: 'feature_name', value: properties.featureName })
    : eventPropertiesArray.push({ id: 'jtQWj9fe2', name: 'feature_name', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'NjRMjbPKAE',
        '84d5d22ab9361b379d16dc7876425dcc4f344dc8e959ccbc90dcba11bd06876c',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Follow Up Action Prompt Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'NjRMjbPKAE',
        'Follow Up Action Prompt Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Follow Up Action Prompt Clicked',
        eventProperties,
        'NjRMjbPKAE',
        '84d5d22ab9361b379d16dc7876425dcc4f344dc8e959ccbc90dcba11bd06876c',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Follow Up Action Prompt Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClipboardCopyButtonClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  modalName: ModalNameValueType | null | undefined;
  fieldName: string;
}
/**
 * Clipboard (Copy) Button Clicked: When users actually click the clipboard icon we have on the platform to copy a value (usually deposit address details)
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/vbPK26mRwP/trigger/vzwNU-Ak4
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.modalName: Name of the modal in question (optional)
 * @param properties.fieldName: Name of the field being copied
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/vbPK26mRwP}
 */
export function clipboardCopyButtonClicked(properties: ClipboardCopyButtonClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.modalName !== undefined && properties.modalName !== null
    ? eventPropertiesArray.push({ id: 'NO9CObS3y', name: 'modal_name', value: properties.modalName })
    : eventPropertiesArray.push({ id: 'NO9CObS3y', name: 'modal_name', value: null });
  eventPropertiesArray.push({ id: 'hptpoOFaD', name: 'field_name', value: properties.fieldName });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'vbPK26mRwP',
        'c1fa14698f29522d06e52c5d128211d0e1b88f89a6251d9b68420f987f64aecc',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Clipboard (Copy) Button Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'vbPK26mRwP',
        'Clipboard (Copy) Button Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Clipboard (Copy) Button Clicked',
        eventProperties,
        'vbPK26mRwP',
        'c1fa14698f29522d06e52c5d128211d0e1b88f89a6251d9b68420f987f64aecc',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Clipboard (Copy) Button Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CheckboxTickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  modalName: ModalNameValueType | null | undefined;
}
/**
 * Checkbox Ticked: When users check any opt-out checkbox to dismiss warning messages (generally)
 *
 * When to trigger this event:
 * 1. number of different flows where we have a dismissible modal for warning messages
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/LN76LjmD49/trigger/WY-NHwKR5
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.modalName: Name of the modal in question (optional)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/LN76LjmD49}
 */
export function checkboxTicked(properties: CheckboxTickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.modalName !== undefined && properties.modalName !== null
    ? eventPropertiesArray.push({ id: 'NO9CObS3y', name: 'modal_name', value: properties.modalName })
    : eventPropertiesArray.push({ id: 'NO9CObS3y', name: 'modal_name', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'LN76LjmD49',
        '96354c2308be2139ebb09aa4cb173776262d53a6e7f740f0ca7f421315b1c047',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Checkbox Ticked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('LN76LjmD49', 'Checkbox Ticked', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Checkbox Ticked',
        eventProperties,
        'LN76LjmD49',
        '96354c2308be2139ebb09aa4cb173776262d53a6e7f740f0ca7f421315b1c047',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Checkbox Ticked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ViewedUniversalTradePageProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  customDestinationPageName_: string;
}
/**
 * Viewed Universal Trade Page: A user visited the Universal Trade Page on web.
 *
 * When to trigger this event:
 * 1. Whenever the user lands on /trade URL. This can be done by the side menu, mobile menu, or clicking any relevant button with /trade as the path/url/route.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/xK8GWuPjkZ/trigger/8mYYKgsaK
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.customDestinationPageName_: Name of the page or screen
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/xK8GWuPjkZ}
 */
export function viewedUniversalTradePage(properties: ViewedUniversalTradePageProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'xK8GWuPjkZ',
        'b19e01d0340efa1272938425b6b2955d9a965153d08297201990e1070cd08b52',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Viewed Universal Trade Page', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'xK8GWuPjkZ',
        'Viewed Universal Trade Page',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    // destination RudderStack
    if (RudderStack.logPage) {
      RudderStack.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
    } else {
      InternalAvoLogger.error('Page method is not implemented in the destination', '');
    }
  } else {
    // do nothing
  }
}

export interface OpenedAssetListDropdownProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  assetId: number;
  assetCode: string;
  assetName: string;
  ownsAsset: boolean;
  assetBalance: string;
}
/**
 * Opened Asset List Dropdown: When a user clicks on the Asset dropdown select, this triggers the Asset List dropdown to open. This component allows user to view, filter and search for assets.
 * 
 * When to trigger this event:
 * 1. User clicked on Asset dropdown/select.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/bGh8PQW_fF/trigger/UP7nKeyMD
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.assetId: The database ID of the asset
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.assetName: The full name of the asset (eg. Bitcoin or Ethereum)
 * @param properties.ownsAsset: A simple prop to help us know if a user owns the asset be interacted with. 

If true=user currently owns asset
If false = user does not currently own asset.
 * @param properties.assetBalance: Allows us to know the users current balance (if owned) of the asset they are interacting with.
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/bGh8PQW_fF}
 */
export function openedAssetListDropdown(properties: OpenedAssetListDropdownProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'yPbM0S1s5E', name: 'asset_name', value: properties.assetName });
  eventPropertiesArray.push({ id: '1MbomDpPy', name: 'owns_asset', value: properties.ownsAsset });
  eventPropertiesArray.push({ id: 'oDclpi2Nv', name: 'asset_balance', value: properties.assetBalance });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'bGh8PQW_fF',
        'df1d22d09c6c0a8245436fe0aed9a6754c4d0b9ee5a5f96a10c6903344be54b0',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Opened Asset List Dropdown', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'bGh8PQW_fF',
        'Opened Asset List Dropdown',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Opened Asset List Dropdown',
        eventProperties,
        'bGh8PQW_fF',
        'df1d22d09c6c0a8245436fe0aed9a6754c4d0b9ee5a5f96a10c6903344be54b0',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Opened Asset List Dropdown', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchedInAssetDropdownProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Searched In Asset Dropdown: This event occurs when a user searches within the Asset Dropdown
 *
 * When to trigger this event:
 * 1. A user inputs into the search field on Asset Dropdown
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/v3G6W4EoTN/trigger/FJnvj_Fax
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/v3G6W4EoTN}
 */
export function searchedInAssetDropdown(properties: SearchedInAssetDropdownProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'v3G6W4EoTN',
        '8125ec4094a7d2ecdccf7254ee0622e21ba46c11ffabd65b2f9446e737b7b819',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Searched In Asset Dropdown', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'v3G6W4EoTN',
        'Searched In Asset Dropdown',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Searched In Asset Dropdown',
        eventProperties,
        'v3G6W4EoTN',
        '8125ec4094a7d2ecdccf7254ee0622e21ba46c11ffabd65b2f9446e737b7b819',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Searched In Asset Dropdown', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ChangedAssetViewedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  assetId: number;
  assetCode: string;
  assetType: AssetTypeValueType;
  ownsAsset: boolean;
  assetBalance: string | null | undefined;
}
/**
 * Changed Asset Viewed: When a user selects an asset in the Asset Dropdown list, changing the asset being viewed on Universal Trade Page.
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/UX8T2HceWb/trigger/v7HfMx_p6
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.assetId: The database ID of the asset
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.assetType: The type of the asset (CRYPTO or FIAT)
 * @param properties.ownsAsset: A simple prop to help us know if a user owns the asset be interacted with. 

If true=user currently owns asset
If false = user does not currently own asset.
 * @param properties.assetBalance: Allows us to know the users current balance (if owned) of the asset they are interacting with.
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/UX8T2HceWb}
 */
export function changedAssetViewed(properties: ChangedAssetViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'kOIyxd6WewhU', name: 'asset_type', value: properties.assetType });
  eventPropertiesArray.push({ id: '1MbomDpPy', name: 'owns_asset', value: properties.ownsAsset });
  properties.assetBalance !== undefined && properties.assetBalance !== null
    ? eventPropertiesArray.push({ id: 'oDclpi2Nv', name: 'asset_balance', value: properties.assetBalance })
    : eventPropertiesArray.push({ id: 'oDclpi2Nv', name: 'asset_balance', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'UX8T2HceWb',
        'f58cc6b7bfd06fcabbed3eef100a6f9ab3e486cf376f12bc89f1f1c351343f9a',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Changed Asset Viewed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('UX8T2HceWb', 'Changed Asset Viewed', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Changed Asset Viewed',
        eventProperties,
        'UX8T2HceWb',
        'f58cc6b7bfd06fcabbed3eef100a6f9ab3e486cf376f12bc89f1f1c351343f9a',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Changed Asset Viewed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OpenedAssetInfoModalProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  assetId: number;
  assetCode: string;
  ownsAsset: boolean;
  assetBalance: string | null | undefined;
}
/**
 * Opened Asset Info Modal: When a user opens the Asset Info modal. This modal contains key information on an asset, such as name, ranking, market cap, website, socials and a description. This information is populated using CoinGecko.
 * 
 * When to trigger this event:
 * 1. When a user clicks on this component
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/4ALNJAz7Gf/trigger/iLxZlrDU8
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.assetId: The database ID of the asset
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.ownsAsset: A simple prop to help us know if a user owns the asset be interacted with. 

If true=user currently owns asset
If false = user does not currently own asset.
 * @param properties.assetBalance: Allows us to know the users current balance (if owned) of the asset they are interacting with.
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/4ALNJAz7Gf}
 */
export function openedAssetInfoModal(properties: OpenedAssetInfoModalProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: '1MbomDpPy', name: 'owns_asset', value: properties.ownsAsset });
  properties.assetBalance !== undefined && properties.assetBalance !== null
    ? eventPropertiesArray.push({ id: 'oDclpi2Nv', name: 'asset_balance', value: properties.assetBalance })
    : eventPropertiesArray.push({ id: 'oDclpi2Nv', name: 'asset_balance', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '4ALNJAz7Gf',
        '1ae7137aca3cbbba7bdd6cc2badbdb7dab22da34785696f691eb3f367d5afd04',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Opened Asset Info Modal', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '4ALNJAz7Gf',
        'Opened Asset Info Modal',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Opened Asset Info Modal',
        eventProperties,
        '4ALNJAz7Gf',
        '1ae7137aca3cbbba7bdd6cc2badbdb7dab22da34785696f691eb3f367d5afd04',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Opened Asset Info Modal', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClickedLearnMoreOnAssetInfoModalProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  assetId: number;
  assetName: string;
  assetCode: string;
  ownsAsset: boolean;
  assetBalance: string | null | undefined;
}
/**
 * Clicked Learn More On Asset Info Modal: When a user clicks the call to action on Asset Info Modal to learn more about an asset.
 * 
 * When to trigger this event:
 * 1. Call to action on Asset Info Modal is clicked.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/PEdJUBFxVy/trigger/rvWBSXydE
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.assetId: The database ID of the asset
 * @param properties.assetName: The full name of the asset (eg. Bitcoin or Ethereum)
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.ownsAsset: A simple prop to help us know if a user owns the asset be interacted with. 

If true=user currently owns asset
If false = user does not currently own asset.
 * @param properties.assetBalance: Allows us to know the users current balance (if owned) of the asset they are interacting with.
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/PEdJUBFxVy}
 */
export function clickedLearnMoreOnAssetInfoModal(properties: ClickedLearnMoreOnAssetInfoModalProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'm0IytUTGhsOu', name: 'asset_id', value: properties.assetId });
  eventPropertiesArray.push({ id: 'yPbM0S1s5E', name: 'asset_name', value: properties.assetName });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: '1MbomDpPy', name: 'owns_asset', value: properties.ownsAsset });
  properties.assetBalance !== undefined && properties.assetBalance !== null
    ? eventPropertiesArray.push({ id: 'oDclpi2Nv', name: 'asset_balance', value: properties.assetBalance })
    : eventPropertiesArray.push({ id: 'oDclpi2Nv', name: 'asset_balance', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'PEdJUBFxVy',
        'aba03607cd2b152c88a31194328492f8209a00c9a3330789e1829fa0a66f3185',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Clicked Learn More On Asset Info Modal', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'PEdJUBFxVy',
        'Clicked Learn More On Asset Info Modal',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Clicked Learn More On Asset Info Modal',
        eventProperties,
        'PEdJUBFxVy',
        'aba03607cd2b152c88a31194328492f8209a00c9a3330789e1829fa0a66f3185',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Clicked Learn More On Asset Info Modal', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClickedOnTableRowProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  tableName: TableNameValueType;
  tableHeadingSortLabel: string;
  tableSortDirection: TableSortDirectionValueType;
}
/**
 * Clicked On Table Row: When a user clicks on a table list row
 *
 * When to trigger this event:
 * 1. User clicks on table row
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/BB8d5xSwqk/trigger/MlovGH-EL
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.tableName: The name of the table component on frontend.
 * @param properties.tableHeadingSortLabel: The label of the table heading, which users will click on to sort the table by (eg. Price, % Change)
 * @param properties.tableSortDirection: The direction of the sort enabled (eg. ascending to descending)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/BB8d5xSwqk}
 */
export function clickedOnTableRow(properties: ClickedOnTableRowProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'JLXD71K_q', name: 'table_name', value: properties.tableName });
  eventPropertiesArray.push({
    id: 'cy-SL9qVo',
    name: 'table_heading_sort_label',
    value: properties.tableHeadingSortLabel,
  });
  eventPropertiesArray.push({ id: 'ZO-Xnspy7', name: 'table_sort_direction', value: properties.tableSortDirection });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'BB8d5xSwqk',
        'fe4590a7cf5e56a43b115f44bb0fc90fa46b2a9236a9ee8667cddc8e65f6d24c',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Clicked On Table Row', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('BB8d5xSwqk', 'Clicked On Table Row', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Clicked On Table Row',
        eventProperties,
        'BB8d5xSwqk',
        'fe4590a7cf5e56a43b115f44bb0fc90fa46b2a9236a9ee8667cddc8e65f6d24c',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Clicked On Table Row', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClickedButtonProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  buttonName: string;
  parentComponent: string | null | undefined;
  tableName: TableNameValueType | null | undefined;
  modalName: ModalNameValueType | null | undefined;
}
/**
 * Clicked Button: When a user clicks or taps a button within the UI.
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.buttonName: The label text used directly in/on the button (eg. Buy, Sell, Quick Buy, Deposit)
 * @param properties.parentComponent: The parent wrapper/component an individual component is contained within (eg. Button component within on Trade Panel Footer wrapper/component)
 * @param properties.tableName: The name of the table component on frontend.
 * @param properties.modalName: Name of the modal in question (optional)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/asGAzI9qnL}
 */
export function clickedButton(properties: ClickedButtonProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'nixKBhAtEi', name: 'button_name', value: properties.buttonName });
  properties.parentComponent !== undefined && properties.parentComponent !== null
    ? eventPropertiesArray.push({ id: 'FW4reCkeC', name: 'parent_component', value: properties.parentComponent })
    : eventPropertiesArray.push({ id: 'FW4reCkeC', name: 'parent_component', value: null });
  properties.tableName !== undefined && properties.tableName !== null
    ? eventPropertiesArray.push({ id: 'JLXD71K_q', name: 'table_name', value: properties.tableName })
    : eventPropertiesArray.push({ id: 'JLXD71K_q', name: 'table_name', value: null });
  properties.modalName !== undefined && properties.modalName !== null
    ? eventPropertiesArray.push({ id: 'NO9CObS3y', name: 'modal_name', value: properties.modalName })
    : eventPropertiesArray.push({ id: 'NO9CObS3y', name: 'modal_name', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'asGAzI9qnL',
        '8ba9d330ad592ca94705d0e2f5cee34844aa733677d8a42af8ecddb4a2f67380',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Clicked Button', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('asGAzI9qnL', 'Clicked Button', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Clicked Button',
        eventProperties,
        'asGAzI9qnL',
        '8ba9d330ad592ca94705d0e2f5cee34844aa733677d8a42af8ecddb4a2f67380',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Clicked Button', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ChangedTableSortProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  tableName: TableNameValueType;
  tableHeadingSortLabel: string;
  tableSortDirection: TableSortDirectionValueType;
}
/**
 * Changed Table Sort: When a user changes the sort of a table (eg. sorts by portfolio $value ascending to descending.)
 *
 * When to trigger this event:
 * 1. User clicks on a table header that has sorting properties.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/4kv_QW37_B/trigger/adWvoSaT3
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.tableName: The name of the table component on frontend.
 * @param properties.tableHeadingSortLabel: The label of the table heading, which users will click on to sort the table by (eg. Price, % Change)
 * @param properties.tableSortDirection: The direction of the sort enabled (eg. ascending to descending)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/4kv_QW37_B}
 */
export function changedTableSort(properties: ChangedTableSortProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'JLXD71K_q', name: 'table_name', value: properties.tableName });
  eventPropertiesArray.push({
    id: 'cy-SL9qVo',
    name: 'table_heading_sort_label',
    value: properties.tableHeadingSortLabel,
  });
  eventPropertiesArray.push({ id: 'ZO-Xnspy7', name: 'table_sort_direction', value: properties.tableSortDirection });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '4kv_QW37_B',
        'ae91e779f739dcd51a123ec73afc5e118e9c16ee0e955e8b9a50c7f5485e2eb1',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Changed Table Sort', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('4kv_QW37_B', 'Changed Table Sort', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Changed Table Sort',
        eventProperties,
        '4kv_QW37_B',
        'ae91e779f739dcd51a123ec73afc5e118e9c16ee0e955e8b9a50c7f5485e2eb1',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Changed Table Sort', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ChangedTableFilterProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  tableName: TableNameValueType;
  filterName: string;
  filterEnabled: boolean;
}
/**
 * Changed Table Filter: When a user changes or applies a filter on a table or list component, reducing the number of data shown in table/list.
 *
 * When to trigger this event:
 * 1. User filters to Current Asset being viewed on Open Orders Tab on UTP componenent.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/vDAvNFv8Z-/trigger/oRHQRRZps
 * 2. User filters to Current Asset or Hide Cancelled on Order History Tab on UTP component.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/vDAvNFv8Z-/trigger/GJuPXpTvh
 * 3. User sorts by date, asset, order direction or order status on All Orders tab on Asset List page.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/vDAvNFv8Z-/trigger/nJN7f5lVj
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.tableName: The name of the table component on frontend.
 * @param properties.filterName: The label used to name the filter eg. (eg. Current Asset, Hide Cancelled)
 * @param properties.filterEnabled: Tells us if the the filter is applied or not. True=enabled, False=disabled
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/vDAvNFv8Z-}
 */
export function changedTableFilter(properties: ChangedTableFilterProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'JLXD71K_q', name: 'table_name', value: properties.tableName });
  eventPropertiesArray.push({ id: 'H0hF-j63M', name: 'filter_name', value: properties.filterName });
  eventPropertiesArray.push({ id: '_rBg6P3Ks', name: 'filter_enabled', value: properties.filterEnabled });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'vDAvNFv8Z-',
        '62dfeca6999e25976318c455302af8626b60e13d18c6d10f7dbb0414e4b880db',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Changed Table Filter', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('vDAvNFv8Z-', 'Changed Table Filter', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Changed Table Filter',
        eventProperties,
        'vDAvNFv8Z-',
        '62dfeca6999e25976318c455302af8626b60e13d18c6d10f7dbb0414e4b880db',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Changed Table Filter', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MarketTickerVariantChangedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  marketTickerVariant: MarketTickerVariantValueType;
  marketTickerSort: MarketTickerSortValueType;
  marketTickerVisibleAssets: MarketTickerVisibleAssetsValueType | null | undefined;
}
/**
 * Market Ticker Variant Changed: When a user selects how they want the Market Ticker to display (eg. static or scrolling). We want to know when users change between these display types.
 *
 * When to trigger this event:
 * 1. When the ticker is displayed as Scrolling, the menu option will let them swap to Static display.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/tTxGz7ydXK/trigger/Sl8OwHMMb
 * 2. When the ticker is displayed as Static, the menu option will let them swap to Scrolling display.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/tTxGz7ydXK/trigger/ANUiCwTlX
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.marketTickerVariant: The variant of market ticker display style selected by the user (eg. Scrolling or Static)
 * @param properties.marketTickerSort: The sorting of the market ticker eg. Gainers, Losers, Market Cap, Newly Listed.
 * @param properties.marketTickerVisibleAssets: The assets shown within market ticker based on users favourites or owned balances.
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/tTxGz7ydXK}
 */
export function marketTickerVariantChanged(properties: MarketTickerVariantChangedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'ZYr5-Z85i', name: 'market_ticker_variant', value: properties.marketTickerVariant });
  eventPropertiesArray.push({ id: '1FnM66AjB', name: 'market_ticker_sort', value: properties.marketTickerSort });
  properties.marketTickerVisibleAssets !== undefined && properties.marketTickerVisibleAssets !== null
    ? eventPropertiesArray.push({
        id: 'YQHpSwgSC',
        name: 'market_ticker_visible_assets',
        value: properties.marketTickerVisibleAssets,
      })
    : eventPropertiesArray.push({ id: 'YQHpSwgSC', name: 'market_ticker_visible_assets', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'tTxGz7ydXK',
        '5259eca41d573f3ae25cbbb8675d055abab2d007c9774c058324f8751dec87e9',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Market Ticker Variant Changed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'tTxGz7ydXK',
        'Market Ticker Variant Changed',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Market Ticker Variant Changed',
        eventProperties,
        'tTxGz7ydXK',
        '5259eca41d573f3ae25cbbb8675d055abab2d007c9774c058324f8751dec87e9',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Market Ticker Variant Changed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MarketTickerSortChangedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  marketTickerSort: MarketTickerSortValueType;
  marketTickerVariant: MarketTickerVariantValueType;
  marketTickerVisibleAssets: MarketTickerVisibleAssetsValueType | null | undefined;
}
/**
 * Market Ticker Sort Changed: When a user changes which order to display the assets within Market Ticker (eg. Gainers, Losers, Market cap, New listings)
 *
 * When to trigger this event:
 * 1. A user clicks any option in the Sort By list.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/QUTF2KXgfe/trigger/Ie4VwPGEV
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.marketTickerSort: The sorting of the market ticker eg. Gainers, Losers, Market Cap, Newly Listed.
 * @param properties.marketTickerVariant: The variant of market ticker display style selected by the user (eg. Scrolling or Static)
 * @param properties.marketTickerVisibleAssets: The assets shown within market ticker based on users favourites or owned balances.
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/QUTF2KXgfe}
 */
export function marketTickerSortChanged(properties: MarketTickerSortChangedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '1FnM66AjB', name: 'market_ticker_sort', value: properties.marketTickerSort });
  eventPropertiesArray.push({ id: 'ZYr5-Z85i', name: 'market_ticker_variant', value: properties.marketTickerVariant });
  properties.marketTickerVisibleAssets !== undefined && properties.marketTickerVisibleAssets !== null
    ? eventPropertiesArray.push({
        id: 'YQHpSwgSC',
        name: 'market_ticker_visible_assets',
        value: properties.marketTickerVisibleAssets,
      })
    : eventPropertiesArray.push({ id: 'YQHpSwgSC', name: 'market_ticker_visible_assets', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'QUTF2KXgfe',
        '15b915b2d39ea331acac301df3180bfa11e0d0d1d283d26c5d75609a4a00fece',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Market Ticker Sort Changed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'QUTF2KXgfe',
        'Market Ticker Sort Changed',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Market Ticker Sort Changed',
        eventProperties,
        'QUTF2KXgfe',
        '15b915b2d39ea331acac301df3180bfa11e0d0d1d283d26c5d75609a4a00fece',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Market Ticker Sort Changed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MarketTickerVisibleAssetsChangedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  marketTickerVisibleAssets: MarketTickerVisibleAssetsValueType | null | undefined;
  marketTickerSort: MarketTickerSortValueType;
  marketTickerVariant: MarketTickerVariantValueType;
}
/**
 * Market Ticker Visible Assets Changed: When a user selects to view only Favourites or Owned assets in the Market Ticker
 *
 * When to trigger this event:
 * 1. A user clicks any option shown in the 'Show Only' list.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/z_N-aivBgP/trigger/2WusiaEY7
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.marketTickerVisibleAssets: The assets shown within market ticker based on users favourites or owned balances.
 * @param properties.marketTickerSort: The sorting of the market ticker eg. Gainers, Losers, Market Cap, Newly Listed.
 * @param properties.marketTickerVariant: The variant of market ticker display style selected by the user (eg. Scrolling or Static)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/z_N-aivBgP}
 */
export function marketTickerVisibleAssetsChanged(properties: MarketTickerVisibleAssetsChangedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.marketTickerVisibleAssets !== undefined && properties.marketTickerVisibleAssets !== null
    ? eventPropertiesArray.push({
        id: 'YQHpSwgSC',
        name: 'market_ticker_visible_assets',
        value: properties.marketTickerVisibleAssets,
      })
    : eventPropertiesArray.push({ id: 'YQHpSwgSC', name: 'market_ticker_visible_assets', value: null });
  eventPropertiesArray.push({ id: '1FnM66AjB', name: 'market_ticker_sort', value: properties.marketTickerSort });
  eventPropertiesArray.push({ id: 'ZYr5-Z85i', name: 'market_ticker_variant', value: properties.marketTickerVariant });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'z_N-aivBgP',
        '7341e21bfb38b18e2f9bfbfff31aadb6677db0f73fa426ac0518df34d6bfbddc',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Market Ticker Visible Assets Changed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'z_N-aivBgP',
        'Market Ticker Visible Assets Changed',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Market Ticker Visible Assets Changed',
        eventProperties,
        'z_N-aivBgP',
        '7341e21bfb38b18e2f9bfbfff31aadb6677db0f73fa426ac0518df34d6bfbddc',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Market Ticker Visible Assets Changed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AssetAllocationLockProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  assetCode: string;
  allocationPercentage: string;
  action: string;
}
/**
 * Asset Allocation Lock: Users hitting the lock icon to confirm an asset allocation
 *
 * When to trigger this event:
 * 1. Currently primarily on the recurring order creation/edit flow
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/ZnIbUX3bBf/trigger/ynSolEy6r
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.assetCode: The ticker code for the asset (eg. BTC or ETH)
 * @param properties.allocationPercentage: what % of total order allocated for given asset
 * @param properties.action: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/ZnIbUX3bBf}
 */
export function assetAllocationLock(properties: AssetAllocationLockProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'IEGxEiF3yAKh', name: 'asset_code', value: properties.assetCode });
  eventPropertiesArray.push({ id: 'MeMepFRyo', name: 'allocation_percentage', value: properties.allocationPercentage });
  eventPropertiesArray.push({ id: 'ITWPf12d0p', name: 'action', value: properties.action });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ZnIbUX3bBf',
        '40ba5c3eea60cbf03e8ccb8764eb85748ae2a9e66b99f766c93f3a330f19652e',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Asset Allocation Lock', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('ZnIbUX3bBf', 'Asset Allocation Lock', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Asset Allocation Lock',
        eventProperties,
        'ZnIbUX3bBf',
        '40ba5c3eea60cbf03e8ccb8764eb85748ae2a9e66b99f766c93f3a330f19652e',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Asset Allocation Lock', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ChangedChartTypeProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  chartType: ChartTypeValueType;
}
/**
 * Changed Chart Type: When a user changes the type of chart being viewed (eg. TradingView or Simple Charts)
 *
 * When to trigger this event:
 * 1. User clicked on TradingView or Simple on the Trade Page charts segmented toggle.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/tCNsTclPI/trigger/aibJmDNLU
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.chartType: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/tCNsTclPI}
 */
export function changedChartType(properties: ChangedChartTypeProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'kYOgTbrt8q', name: 'chartType', value: properties.chartType });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'tCNsTclPI',
        '2f96ed44d0eea96d97c592a2dcd3f4b987a068ff0cc2ee53b2a21a0a877d7397',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Changed Chart Type', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('tCNsTclPI', 'Changed Chart Type', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Changed Chart Type',
        eventProperties,
        'tCNsTclPI',
        '2f96ed44d0eea96d97c592a2dcd3f4b987a068ff0cc2ee53b2a21a0a877d7397',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Changed Chart Type', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ChangedCandlestickTimeframeProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Changed Candlestick Timeframe: When a user changes the candle timeframe on TradingView charts.
 *
 * When to trigger this event:
 * 1. A user changed candle timeframe on TradingView chartType.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/D7JCxgW7u/trigger/sSpV-7GaH
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/D7JCxgW7u}
 */
export function changedCandlestickTimeframe(properties: ChangedCandlestickTimeframeProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'D7JCxgW7u',
        'df7e2e6605a651e45d0990755283144a49ad5f30cd224c20da5a815f2277e5a6',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Changed Candlestick Timeframe', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'D7JCxgW7u',
        'Changed Candlestick Timeframe',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Changed Candlestick Timeframe',
        eventProperties,
        'D7JCxgW7u',
        'df7e2e6605a651e45d0990755283144a49ad5f30cd224c20da5a815f2277e5a6',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Changed Candlestick Timeframe', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ChangedCandleTypeProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  chartType: ChartTypeValueType;
  candleType: string;
}
/**
 * Changed Candle Type: When a user changes the candle type on charts (eg. Candlesticks, Area, Line, HeikinAshi)
 *
 * When to trigger this event:
 * 1. User changes the candle time when using TradingView chartType.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/DytrR1xuv/trigger/RvgoEgU7y
 * 2. User changes the candle type when using Simple Charts chartType.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/DytrR1xuv/trigger/W5AWxhE9u
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.chartType: no description
 * @param properties.candleType: The name of the candle type (eg. Candlesticks, Hollow Candlesticks, Area, Line etc.)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/DytrR1xuv}
 */
export function changedCandleType(properties: ChangedCandleTypeProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'kYOgTbrt8q', name: 'chartType', value: properties.chartType });
  eventPropertiesArray.push({ id: 'OLfSIBlJl', name: 'candle_type', value: properties.candleType });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'DytrR1xuv',
        '9139372927aa2a9ff39361209ec3a584980d48d5161a7d14b225da711c068afa',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Changed Candle Type', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('DytrR1xuv', 'Changed Candle Type', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Changed Candle Type',
        eventProperties,
        'DytrR1xuv',
        '9139372927aa2a9ff39361209ec3a584980d48d5161a7d14b225da711c068afa',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Changed Candle Type', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ChangedChartTimeframeProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  chartType: ChartTypeValueType;
  chartTimeframe: string;
}
/**
 * Changed Chart Timeframe: When a user changes the overall timeframe on a chart (eg. 1 Month, 6 Months, 1 Year, All)
 *
 * When to trigger this event:
 * 1. A user changes the overall chart timeframe when viewing TradingView chartType.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/ZObJgyJCt/trigger/-cbeNJ9tB
 * 2. A user changes the overall chart timeframe when viewing Simple Charts chartType.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/ZObJgyJCt/trigger/0OQjELXyI
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.chartType: no description
 * @param properties.chartTimeframe: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/ZObJgyJCt}
 */
export function changedChartTimeframe(properties: ChangedChartTimeframeProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'kYOgTbrt8q', name: 'chartType', value: properties.chartType });
  eventPropertiesArray.push({ id: '-PUPb7s3Kt', name: 'chart_timeframe', value: properties.chartTimeframe });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ZObJgyJCt',
        '71f849c05c65c28b07e01ff93cc1bc3c188f0051f44a5c91e9189bff42424a1f',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Changed Chart Timeframe', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'ZObJgyJCt',
        'Changed Chart Timeframe',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Changed Chart Timeframe',
        eventProperties,
        'ZObJgyJCt',
        '71f849c05c65c28b07e01ff93cc1bc3c188f0051f44a5c91e9189bff42424a1f',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Changed Chart Timeframe', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface EntityApplicationStartedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  platform: string | null | undefined;
}
/**
 * Entity Application Started: {"ops":[{"insert":"When a user begins the entity application form."},{"attributes":{"list":"bullet"},"insert":"\n"}]}
 * 
 * When to trigger this event:
 * 1. User lands on this page for the first time, and has steps all incompleted.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/BYPKlXCfHU/trigger/EshS3-khk
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.platform: Platform being used - web, mobile, or (not set) for API usage eg integrations, Widgets, etc

A property used for injection of information where there isn't context (e.g widgets, or Mobile Web in a webview that the mobile app opens)
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/BYPKlXCfHU}
 */
export function entityApplicationStarted(properties: EntityApplicationStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.platform !== undefined && properties.platform !== null
    ? eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: properties.platform })
    : eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'BYPKlXCfHU',
        '76c7df18baf96f3b1b066059d0a1d9b88d7cb8fc7036a8fd4521827164d9caa2',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Entity Application Started', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'BYPKlXCfHU',
        'Entity Application Started',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Entity Application Started',
        eventProperties,
        'BYPKlXCfHU',
        '76c7df18baf96f3b1b066059d0a1d9b88d7cb8fc7036a8fd4521827164d9caa2',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Entity Application Started', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface EntityApplicationSubmittedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  entityType: EntityTypeValueType | null | undefined;
  numberOfDirectors: number | null | undefined;
  numberOfShareholders: number | null | undefined;
  numberOfTrustees: number | null | undefined;
  numberOfCorporateTrustees: number | null | undefined;
  numberOfBeneficiaries: number | null | undefined;
  numberOfDocumentsUploaded: number;
  platform: string | null | undefined;
}
/**
 * Entity Application Submitted: User completes and submits the entity application form.
 * 
 * When to trigger this event:
 * 1. User has completed the entity application form, landing on the 'application submitted' screen. 
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/1u0X_ljH7K/trigger/2Xk8uGoAB
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.entityType: This event is to track and identify the number and the type of of entity investor.
 * @param properties.numberOfDirectors: Tracks the number of directors added during Entity Application > Add Members step. 
 * @param properties.numberOfShareholders: Tracks the number of shareholders added during Entity Application > Add Members step. 
 * @param properties.numberOfTrustees: Tracks the number of Trustees added during Entity Application > Add Members step. These could be individuals or generic (for SMSF).
 * @param properties.numberOfCorporateTrustees: Tracks the number of Corporate Trustees added during Entity Application > Add Members step. This is only track if a user has answered YES to 'do you have corporate trustee?' question.
 * @param properties.numberOfBeneficiaries: Tracks the number of beneficiaries added during Entity Application > Add Members step. 
 * @param properties.numberOfDocumentsUploaded: Tracks the number of documents uploaded during a form.
 * @param properties.platform: Platform being used - web, mobile, or (not set) for API usage eg integrations, Widgets, etc

A property used for injection of information where there isn't context (e.g widgets, or Mobile Web in a webview that the mobile app opens)
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/1u0X_ljH7K}
 */
export function entityApplicationSubmitted(properties: EntityApplicationSubmittedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.entityType !== undefined && properties.entityType !== null
    ? eventPropertiesArray.push({ id: 'GkSn8pyuK0N_', name: 'entity_type', value: properties.entityType })
    : eventPropertiesArray.push({ id: 'GkSn8pyuK0N_', name: 'entity_type', value: null });
  properties.numberOfDirectors !== undefined && properties.numberOfDirectors !== null
    ? eventPropertiesArray.push({ id: 'irnmEncWf', name: 'number_of_directors', value: properties.numberOfDirectors })
    : eventPropertiesArray.push({ id: 'irnmEncWf', name: 'number_of_directors', value: null });
  properties.numberOfShareholders !== undefined && properties.numberOfShareholders !== null
    ? eventPropertiesArray.push({
        id: 'bzHo3qCv1',
        name: 'number_of_shareholders',
        value: properties.numberOfShareholders,
      })
    : eventPropertiesArray.push({ id: 'bzHo3qCv1', name: 'number_of_shareholders', value: null });
  properties.numberOfTrustees !== undefined && properties.numberOfTrustees !== null
    ? eventPropertiesArray.push({ id: 'a_xPYBO8N', name: 'number_of_trustees', value: properties.numberOfTrustees })
    : eventPropertiesArray.push({ id: 'a_xPYBO8N', name: 'number_of_trustees', value: null });
  properties.numberOfCorporateTrustees !== undefined && properties.numberOfCorporateTrustees !== null
    ? eventPropertiesArray.push({
        id: 'ktPG0C7Ac',
        name: 'number_of_corporate_trustees',
        value: properties.numberOfCorporateTrustees,
      })
    : eventPropertiesArray.push({ id: 'ktPG0C7Ac', name: 'number_of_corporate_trustees', value: null });
  properties.numberOfBeneficiaries !== undefined && properties.numberOfBeneficiaries !== null
    ? eventPropertiesArray.push({
        id: 'vIU1ccQp7',
        name: 'number_of_beneficiaries',
        value: properties.numberOfBeneficiaries,
      })
    : eventPropertiesArray.push({ id: 'vIU1ccQp7', name: 'number_of_beneficiaries', value: null });
  eventPropertiesArray.push({
    id: '3vgh_7my3',
    name: 'number_of_documents_uploaded',
    value: properties.numberOfDocumentsUploaded,
  });
  properties.platform !== undefined && properties.platform !== null
    ? eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: properties.platform })
    : eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '1u0X_ljH7K',
        '29bcab00adf9c8fb17d26b7b82e46779c4bcf78a407f2f5b21a6421b5370a003',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Entity Application Submitted', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '1u0X_ljH7K',
        'Entity Application Submitted',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Entity Application Submitted',
        eventProperties,
        '1u0X_ljH7K',
        '29bcab00adf9c8fb17d26b7b82e46779c4bcf78a407f2f5b21a6421b5370a003',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Entity Application Submitted', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface EntityApplicationStepStartedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  entityType: EntityTypeValueType | null | undefined;
  stepId: string;
  platform: string | null | undefined;
}
/**
 * Entity Application Step Started: When a user starts a step in entity form.
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.entityType: This event is to track and identify the number and the type of of entity investor.
 * @param properties.stepId: no description
 * @param properties.platform: Platform being used - web, mobile, or (not set) for API usage eg integrations, Widgets, etc

A property used for injection of information where there isn't context (e.g widgets, or Mobile Web in a webview that the mobile app opens)
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/bS2THOKDdC}
 */
export function entityApplicationStepStarted(properties: EntityApplicationStepStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.entityType !== undefined && properties.entityType !== null
    ? eventPropertiesArray.push({ id: 'GkSn8pyuK0N_', name: 'entity_type', value: properties.entityType })
    : eventPropertiesArray.push({ id: 'GkSn8pyuK0N_', name: 'entity_type', value: null });
  eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId });
  properties.platform !== undefined && properties.platform !== null
    ? eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: properties.platform })
    : eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'bS2THOKDdC',
        'db9936f336263ffcb26cf4aa1200e51839f91313816d08030d5604af86066d0d',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Entity Application Step Started', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'bS2THOKDdC',
        'Entity Application Step Started',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Entity Application Step Started',
        eventProperties,
        'bS2THOKDdC',
        'db9936f336263ffcb26cf4aa1200e51839f91313816d08030d5604af86066d0d',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Entity Application Step Started', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface EntityApplicationStepCompletedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  entityType: EntityTypeValueType | null | undefined;
  stepId: string;
  platform: string | null | undefined;
}
/**
 * Entity Application Step Completed: When a user completes a step on the entity application form.
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.entityType: This event is to track and identify the number and the type of of entity investor.
 * @param properties.stepId: no description
 * @param properties.platform: Platform being used - web, mobile, or (not set) for API usage eg integrations, Widgets, etc

A property used for injection of information where there isn't context (e.g widgets, or Mobile Web in a webview that the mobile app opens)
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/T_9BjbxjBB}
 */
export function entityApplicationStepCompleted(properties: EntityApplicationStepCompletedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.entityType !== undefined && properties.entityType !== null
    ? eventPropertiesArray.push({ id: 'GkSn8pyuK0N_', name: 'entity_type', value: properties.entityType })
    : eventPropertiesArray.push({ id: 'GkSn8pyuK0N_', name: 'entity_type', value: null });
  eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId });
  properties.platform !== undefined && properties.platform !== null
    ? eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: properties.platform })
    : eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'T_9BjbxjBB',
        '9ff8657341fe22765ee60048b60f52d90777ad884f98a04cb576a9d8a42ca05a',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Entity Application Step Completed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'T_9BjbxjBB',
        'Entity Application Step Completed',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Entity Application Step Completed',
        eventProperties,
        'T_9BjbxjBB',
        '9ff8657341fe22765ee60048b60f52d90777ad884f98a04cb576a9d8a42ca05a',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Entity Application Step Completed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserSkippedStepProperties {
  verificationStep: VerificationStepValueType[] | null | undefined;
}
/**
 * User Skipped Step: When a user chooses to skip an optional step during a funnel.
 *
 * @param properties the properties associatied with this event
 * @param properties.verificationStep: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/-fz-tETkb}
 */
export function userSkippedStep(properties: UserSkippedStepProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.verificationStep !== undefined && properties.verificationStep !== null
    ? eventPropertiesArray.push({ id: 'OQNU9Iw1lU', name: 'verification_step', value: properties.verificationStep })
    : eventPropertiesArray.push({ id: 'OQNU9Iw1lU', name: 'verification_step', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '-fz-tETkb',
        'c1c574c1691a538291ee3bb79eca6976657be42fcf0a882a8f01eda7625ae665',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('User Skipped Step', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('-fz-tETkb', 'User Skipped Step', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'User Skipped Step',
        eventProperties,
        '-fz-tETkb',
        'c1c574c1691a538291ee3bb79eca6976657be42fcf0a882a8f01eda7625ae665',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('User Skipped Step', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface EntityApplicationCancelledProperties {
  stepId: string;
  platform: string | null | undefined;
}
/**
 * Entity Application Cancelled: The user cancelled their entity application
 * 
 * When to trigger this event:
 * 1. User clicked 'Yes, cancel application' on the Cancel Application two-step confirmation modal.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/gDdXbXRee3/trigger/hETQs5CwZ
 * 
 * @param properties the properties associatied with this event
 * @param properties.stepId: no description
 * @param properties.platform: Platform being used - web, mobile, or (not set) for API usage eg integrations, Widgets, etc

A property used for injection of information where there isn't context (e.g widgets, or Mobile Web in a webview that the mobile app opens)
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/gDdXbXRee3}
 */
export function entityApplicationCancelled(properties: EntityApplicationCancelledProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId });
  properties.platform !== undefined && properties.platform !== null
    ? eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: properties.platform })
    : eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'gDdXbXRee3',
        'd784233b87494bc689942eebefeeafc994ff974e7370455e6a1844fff88abbbe',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Entity Application Cancelled', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'gDdXbXRee3',
        'Entity Application Cancelled',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Entity Application Cancelled',
        eventProperties,
        'gDdXbXRee3',
        'd784233b87494bc689942eebefeeafc994ff974e7370455e6a1844fff88abbbe',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Entity Application Cancelled', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface EntityCTAClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  callToActionName: CallToActionNameValueType;
  platform: string | null | undefined;
}
/**
 * Entity CTA Clicked: When a user clicks a prompt or call to action to create an entity account.
 * 
 * When to trigger this event:
 * 1. User clicks 'create entity account' on web, when their account allows them to do so.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/DVVKJ9LPa/trigger/R336sgnDn
 * 2. User clicks 'create entity account' on web, but cannot continue as their restrictions block them.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/DVVKJ9LPa/trigger/lKRxkSFuC
 * 3. User clicks 'resume entity account' on web.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/DVVKJ9LPa/trigger/wQDXLVvD0
 * 4. User clicks 'Start entity application' button from the Create Entity Header button.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/DVVKJ9LPa/trigger/S1TGguNzU
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.callToActionName: This is the name of the button label itself, prefixed by the page or screen name.
 * @param properties.platform: Platform being used - web, mobile, or (not set) for API usage eg integrations, Widgets, etc

A property used for injection of information where there isn't context (e.g widgets, or Mobile Web in a webview that the mobile app opens)
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/DVVKJ9LPa}
 */
export function entityCtaClicked(properties: EntityCTAClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'DX1UtughE', name: 'call_to_action_name', value: properties.callToActionName });
  properties.platform !== undefined && properties.platform !== null
    ? eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: properties.platform })
    : eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'DVVKJ9LPa',
        'f998de11d711e122d75dd4a903b0e04ae6bfeedfe71405a1a6da60ef46163dc6',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Entity CTA Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('DVVKJ9LPa', 'Entity CTA Clicked', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Entity CTA Clicked',
        eventProperties,
        'DVVKJ9LPa',
        'f998de11d711e122d75dd4a903b0e04ae6bfeedfe71405a1a6da60ef46163dc6',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Entity CTA Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TooltipClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  tooltipName: string;
  tooltipType: TooltipTypeValueType;
}
/**
 * Tooltip Clicked: When a user clicks on a tooltip.
 *
 * When to trigger this event:
 * 1. User clicks on 'Don't see your entity type?' tooltip text or button on Entity Application form.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/FftSYHpjI/trigger/kWLhCbAJL
 * 2. User clicks on the 'preview' icon during Upload Document step of the Entity Application form.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/FftSYHpjI/trigger/3vxD7ik1t
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.tooltipName: The name of the tooltip
 * @param properties.tooltipType: Determines if the tooltip is text only or image.
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/FftSYHpjI}
 */
export function tooltipClicked(properties: TooltipClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'RL_p-k7KP', name: 'tooltip_name', value: properties.tooltipName });
  eventPropertiesArray.push({ id: 'pjOwbNUv9', name: 'tooltip_type', value: properties.tooltipType });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'FftSYHpjI',
        '4c5ca4cd7cf3f5556c5035b546e9db8b014f12a72e3c254624f2b0cf80762f6a',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Tooltip Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('FftSYHpjI', 'Tooltip Clicked', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Tooltip Clicked',
        eventProperties,
        'FftSYHpjI',
        '4c5ca4cd7cf3f5556c5035b546e9db8b014f12a72e3c254624f2b0cf80762f6a',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Tooltip Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SupportLinkClickedProperties {
  supportLinkLabel: string;
  supportLinkUrl: string;
}
/**
 * Support Link Clicked: When a user clicks on a support link, navigating to our knowledgebase articles.
 *
 * When to trigger this event:
 * 1. When a user clicks on the 'learn more' during document upload step of entity application form.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/emMxZA_Ke/trigger/0NGtDcfsu
 *
 * @param properties the properties associatied with this event
 * @param properties.supportLinkLabel: The label of the support link that was clicked
 * @param properties.supportLinkUrl: The URL of the support link that was clicked
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/emMxZA_Ke}
 */
export function supportLinkClicked(properties: SupportLinkClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'KUUPWzCFC', name: 'support_link_label', value: properties.supportLinkLabel });
  eventPropertiesArray.push({ id: 'RgsZPgL-L', name: 'support_link_url', value: properties.supportLinkUrl });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'emMxZA_Ke',
        '196bc4586b690e3c4d9da1147d60b45624a0f2f0f327b170eabb2b98904ac55c',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Support Link Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('emMxZA_Ke', 'Support Link Clicked', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Support Link Clicked',
        eventProperties,
        'emMxZA_Ke',
        '196bc4586b690e3c4d9da1147d60b45624a0f2f0f327b170eabb2b98904ac55c',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Support Link Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface EntityMemberAddedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  stepId: string;
  memberType: MemberTypeValueType;
  entityType: EntityTypeValueType;
  platform: string | null | undefined;
}
/**
 * Entity Member Added: When a user adds a member during the Entity Application form.
 * 
 * When to trigger this event:
 * 1. When a user adds a single member.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/oRoDYbMCnC/trigger/mZYd71KV6
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.stepId: no description
 * @param properties.memberType: This defines the member type. These are generic so they can be used across all Entity types (eg. Company, Trust, SMSF).
 * @param properties.entityType: This event is to track and identify the number and the type of of entity investor.
 * @param properties.platform: Platform being used - web, mobile, or (not set) for API usage eg integrations, Widgets, etc

A property used for injection of information where there isn't context (e.g widgets, or Mobile Web in a webview that the mobile app opens)
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/oRoDYbMCnC}
 */
export function entityMemberAdded(properties: EntityMemberAddedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId });
  eventPropertiesArray.push({ id: 'iPRR5_X01', name: 'member_type', value: properties.memberType });
  eventPropertiesArray.push({ id: 'GkSn8pyuK0N_', name: 'entity_type', value: properties.entityType });
  properties.platform !== undefined && properties.platform !== null
    ? eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: properties.platform })
    : eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'oRoDYbMCnC',
        '51f52088457dfafa0f8117363159b9b3720494da9530a31c9f93b1e44fabc7b5',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Entity Member Added', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('oRoDYbMCnC', 'Entity Member Added', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Entity Member Added',
        eventProperties,
        'oRoDYbMCnC',
        '51f52088457dfafa0f8117363159b9b3720494da9530a31c9f93b1e44fabc7b5',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Entity Member Added', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface EntityMemberEditedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  entityType: EntityTypeValueType;
  memberType: MemberTypeValueType;
  stepId: string;
  platform: string | null | undefined;
}
/**
 * Entity Member Edited: When a user edits the member information during Entity Application form, and saves it.
 * 
 * When to trigger this event:
 * 1. When a user clicks 'Save Changes' on the member information section.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/cZbwyddkLT/trigger/6Z4Ksx87I
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.entityType: This event is to track and identify the number and the type of of entity investor.
 * @param properties.memberType: This defines the member type. These are generic so they can be used across all Entity types (eg. Company, Trust, SMSF).
 * @param properties.stepId: no description
 * @param properties.platform: Platform being used - web, mobile, or (not set) for API usage eg integrations, Widgets, etc

A property used for injection of information where there isn't context (e.g widgets, or Mobile Web in a webview that the mobile app opens)
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/cZbwyddkLT}
 */
export function entityMemberEdited(properties: EntityMemberEditedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'GkSn8pyuK0N_', name: 'entity_type', value: properties.entityType });
  eventPropertiesArray.push({ id: 'iPRR5_X01', name: 'member_type', value: properties.memberType });
  eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId });
  properties.platform !== undefined && properties.platform !== null
    ? eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: properties.platform })
    : eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'cZbwyddkLT',
        'f116ef442d258b96c269e29c2b852920a8b793c258bc83fd7767fc0cedaceea0',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Entity Member Edited', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('cZbwyddkLT', 'Entity Member Edited', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Entity Member Edited',
        eventProperties,
        'cZbwyddkLT',
        'f116ef442d258b96c269e29c2b852920a8b793c258bc83fd7767fc0cedaceea0',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Entity Member Edited', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface EntityMemberRemovedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  memberType: MemberTypeValueType;
  entityType: EntityTypeValueType;
  stepId: string;
  platform: string | null | undefined;
}
/**
 * Entity Member Removed: When a user removes a member during the Entity Application > Add Members step.
 * 
 * When to trigger this event:
 * 1. When a user clicks the confirmation 'Yes, remover member' button on the two-step remove member modal.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/CUqgM7ZLVk/trigger/in5IG9sT0
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.memberType: This defines the member type. These are generic so they can be used across all Entity types (eg. Company, Trust, SMSF).
 * @param properties.entityType: This event is to track and identify the number and the type of of entity investor.
 * @param properties.stepId: no description
 * @param properties.platform: Platform being used - web, mobile, or (not set) for API usage eg integrations, Widgets, etc

A property used for injection of information where there isn't context (e.g widgets, or Mobile Web in a webview that the mobile app opens)
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/CUqgM7ZLVk}
 */
export function entityMemberRemoved(properties: EntityMemberRemovedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'iPRR5_X01', name: 'member_type', value: properties.memberType });
  eventPropertiesArray.push({ id: 'GkSn8pyuK0N_', name: 'entity_type', value: properties.entityType });
  eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId });
  properties.platform !== undefined && properties.platform !== null
    ? eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: properties.platform })
    : eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'CUqgM7ZLVk',
        '5155f5f3d21e8f6ee38d6fd57bbd91f34f73d7950b0158371494f04320c83dee',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Entity Member Removed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('CUqgM7ZLVk', 'Entity Member Removed', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Entity Member Removed',
        eventProperties,
        'CUqgM7ZLVk',
        '5155f5f3d21e8f6ee38d6fd57bbd91f34f73d7950b0158371494f04320c83dee',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Entity Member Removed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface EntityTypeChangedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  entityType: EntityTypeValueType;
  platform: string | null | undefined;
}
/**
 * Entity Type Changed: When a user changes their entity type
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.entityType: This event is to track and identify the number and the type of of entity investor.
 * @param properties.platform: Platform being used - web, mobile, or (not set) for API usage eg integrations, Widgets, etc

A property used for injection of information where there isn't context (e.g widgets, or Mobile Web in a webview that the mobile app opens)
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/5BkQQvt7P5}
 */
export function entityTypeChanged(properties: EntityTypeChangedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'GkSn8pyuK0N_', name: 'entity_type', value: properties.entityType });
  properties.platform !== undefined && properties.platform !== null
    ? eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: properties.platform })
    : eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '5BkQQvt7P5',
        '1d9fe75ef7284d4fc8959053e68faeaad083adac28ea3df8307e445511fee490',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Entity Type Changed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('5BkQQvt7P5', 'Entity Type Changed', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Entity Type Changed',
        eventProperties,
        '5BkQQvt7P5',
        '1d9fe75ef7284d4fc8959053e68faeaad083adac28ea3df8307e445511fee490',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Entity Type Changed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface EntityPhoneConsultationCTAClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  entityType: EntityTypeValueType | null | undefined;
  applyForEntityAccount: boolean;
  stepId: string | null | undefined;
  callToActionLocation: CallToActionLocationValueType;
}
/**
 * Entity Phone Consultation CTA Clicked: When a user clicks any call to action to book a phone consult (for entity applications). Website platform only.
 *
 * When to trigger this event:
 * 1. User clicks 'Book a phone consult' from the Entity Header Nav button.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Wbstp5ZlQU/trigger/XfJhbDoLf
 * 2. User clicks on the inline 'Book a phone consult' on step 1 of the entity application form.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Wbstp5ZlQU/trigger/PZUqspo4A
 * 3. User clicks on the inline 'Book a phone consult' on step 2 of the entity application form.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Wbstp5ZlQU/trigger/vkGmVfoDe
 * 4. User clicks on the inline 'Book a call' on any step past step 2 (select entity type) of the entity application form.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Wbstp5ZlQU/trigger/WjOiMw1XO
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.entityType: This event is to track and identify the number and the type of of entity investor.
 * @param properties.applyForEntityAccount: Whether the user signed up to apply for an entity account
 * @param properties.stepId: no description
 * @param properties.callToActionLocation: The location of which they have pressed the phone consult CTA button / link
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Wbstp5ZlQU}
 */
export function entityPhoneConsultationCtaClicked(properties: EntityPhoneConsultationCTAClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.entityType !== undefined && properties.entityType !== null
    ? eventPropertiesArray.push({ id: 'GkSn8pyuK0N_', name: 'entity_type', value: properties.entityType })
    : eventPropertiesArray.push({ id: 'GkSn8pyuK0N_', name: 'entity_type', value: null });
  eventPropertiesArray.push({
    id: 'pEMP3U05v',
    name: 'apply_for_entity_account',
    value: properties.applyForEntityAccount,
  });
  properties.stepId !== undefined && properties.stepId !== null
    ? eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId })
    : eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: null });
  eventPropertiesArray.push({
    id: 'Ez0vIS-Mc',
    name: 'call_to_action_location',
    value: properties.callToActionLocation,
  });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Wbstp5ZlQU',
        '41d388349b67a8d45a44109eeeba4e07465bf84b4432cd9a801d52e619f50644',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Entity Phone Consultation CTA Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Wbstp5ZlQU',
        'Entity Phone Consultation CTA Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Entity Phone Consultation CTA Clicked',
        eventProperties,
        'Wbstp5ZlQU',
        '41d388349b67a8d45a44109eeeba4e07465bf84b4432cd9a801d52e619f50644',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Entity Phone Consultation CTA Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HideCreateEntityAccountButtonProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  applyForEntityAccount: boolean | null | undefined;
}
/**
 * Hide Create Entity Account Button: When a user chooses to hide the 'Create Entity Account' button in the header nav. Desktop website only.
 *
 * When to trigger this event:
 * 1. User clicks 'Hide this button' button on the Create Entity header nav button dropdown.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/hU6yJc78Rb/trigger/Ou8Z7Qd3B
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.applyForEntityAccount: Whether the user signed up to apply for an entity account
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/hU6yJc78Rb}
 */
export function hideCreateEntityAccountButton(properties: HideCreateEntityAccountButtonProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.applyForEntityAccount !== undefined && properties.applyForEntityAccount !== null
    ? eventPropertiesArray.push({
        id: 'pEMP3U05v',
        name: 'apply_for_entity_account',
        value: properties.applyForEntityAccount,
      })
    : eventPropertiesArray.push({ id: 'pEMP3U05v', name: 'apply_for_entity_account', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'hU6yJc78Rb',
        'fed938bd938e887b876e29769624d58d0b7114613ce8d1093f2af4599e4a4f4f',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Hide Create Entity Account Button', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'hU6yJc78Rb',
        'Hide Create Entity Account Button',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Hide Create Entity Account Button',
        eventProperties,
        'hU6yJc78Rb',
        'fed938bd938e887b876e29769624d58d0b7114613ce8d1093f2af4599e4a4f4f',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Hide Create Entity Account Button', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProfileDropdownClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Profile Dropdown Clicked: Clicking the profile dropdown icon
 *
 * When to trigger this event:
 * 1. Clicking on the profile icon dropdown on web
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/gCgKdQQC8p/trigger/d7tZbgtVo
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/gCgKdQQC8p}
 */
export function profileDropdownClicked(properties: ProfileDropdownClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'gCgKdQQC8p',
        '1955e370f11ddb329c78133f54276714970832f8efabf9ffdbc7bb47e3c80637',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Profile Dropdown Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'gCgKdQQC8p',
        'Profile Dropdown Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Profile Dropdown Clicked',
        eventProperties,
        'gCgKdQQC8p',
        '1955e370f11ddb329c78133f54276714970832f8efabf9ffdbc7bb47e3c80637',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Profile Dropdown Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SwitchPlatformButtonClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  buttonName: string;
}
/**
 * Switch Platform Button Clicked: Switch platform button clicked
 *
 * When to trigger this event:
 * 1. Clicking one of the buttons under 'Switch Platform' section in profile dropdown
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/wJoKWUhtwN/trigger/ldpXA57Xx
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.buttonName: The label text used directly in/on the button (eg. Buy, Sell, Quick Buy, Deposit)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/wJoKWUhtwN}
 */
export function switchPlatformButtonClicked(properties: SwitchPlatformButtonClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'nixKBhAtEi', name: 'button_name', value: properties.buttonName });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'wJoKWUhtwN',
        'caf0115efe082dcc0f6e6166c936fbef51bd898a2517e252d9153088a093eca5',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Switch Platform Button Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'wJoKWUhtwN',
        'Switch Platform Button Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Switch Platform Button Clicked',
        eventProperties,
        'wJoKWUhtwN',
        'caf0115efe082dcc0f6e6166c936fbef51bd898a2517e252d9153088a093eca5',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Switch Platform Button Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SettingsCogActionProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  swyftxPro: string;
  buttonName: string;
  buttonState: string | null | undefined;
}
/**
 * Settings Cog Action: When users interact with one of the toggles/buttons on the Settings Cog dropdown
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/EN_jmtDGmU/trigger/KS5U1YElc
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.swyftxPro: Differentiator for actions happening within Swyftx Pro UI
 * @param properties.buttonName: The label text used directly in/on the button (eg. Buy, Sell, Quick Buy, Deposit)
 * @param properties.buttonState: The state of the button eg. default, disabled
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/EN_jmtDGmU}
 */
export function settingsCogAction(properties: SettingsCogActionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'DVYn9DJjX', name: 'swyftx_pro', value: properties.swyftxPro });
  eventPropertiesArray.push({ id: 'nixKBhAtEi', name: 'button_name', value: properties.buttonName });
  properties.buttonState !== undefined && properties.buttonState !== null
    ? eventPropertiesArray.push({ id: 'fCMLOCC7l', name: 'button_state', value: properties.buttonState })
    : eventPropertiesArray.push({ id: 'fCMLOCC7l', name: 'button_state', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'EN_jmtDGmU',
        '19aab9aac0c3ee9a632deffb57d5a4cf445f70e7e1d142397cf761f4befb5ae5',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Settings Cog Action', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('EN_jmtDGmU', 'Settings Cog Action', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Settings Cog Action',
        eventProperties,
        'EN_jmtDGmU',
        '19aab9aac0c3ee9a632deffb57d5a4cf445f70e7e1d142397cf761f4befb5ae5',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Settings Cog Action', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HideWidgetActionProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  buttonName: string;
  swyftxPro: string;
}
/**
 * Hide Widget Action: Users hide a UI widget
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/QElGaV3mKx/trigger/Fgi1PeyV8
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.buttonName: The label text used directly in/on the button (eg. Buy, Sell, Quick Buy, Deposit)
 * @param properties.swyftxPro: Differentiator for actions happening within Swyftx Pro UI
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/QElGaV3mKx}
 */
export function hideWidgetAction(properties: HideWidgetActionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'nixKBhAtEi', name: 'button_name', value: properties.buttonName });
  eventPropertiesArray.push({ id: 'DVYn9DJjX', name: 'swyftx_pro', value: properties.swyftxPro });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'QElGaV3mKx',
        '631b9217eebb8f3b54d7750034e555a1801ff245b3f12063b8bbda9901471cbb',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Hide Widget Action', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('QElGaV3mKx', 'Hide Widget Action', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Hide Widget Action',
        eventProperties,
        'QElGaV3mKx',
        '631b9217eebb8f3b54d7750034e555a1801ff245b3f12063b8bbda9901471cbb',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Hide Widget Action', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ChartOverlaysActionProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  swyftxPro: string;
  buttonName: string;
  buttonState: string;
}
/**
 * Chart Overlays Action: When a user interacts with any of the options in the Overlays dropdown for charts
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/h7W7N4ZKWd/trigger/1vTcwlbVj
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.swyftxPro: Differentiator for actions happening within Swyftx Pro UI
 * @param properties.buttonName: The label text used directly in/on the button (eg. Buy, Sell, Quick Buy, Deposit)
 * @param properties.buttonState: The state of the button eg. default, disabled
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/h7W7N4ZKWd}
 */
export function chartOverlaysAction(properties: ChartOverlaysActionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'DVYn9DJjX', name: 'swyftx_pro', value: properties.swyftxPro });
  eventPropertiesArray.push({ id: 'nixKBhAtEi', name: 'button_name', value: properties.buttonName });
  eventPropertiesArray.push({ id: 'fCMLOCC7l', name: 'button_state', value: properties.buttonState });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'h7W7N4ZKWd',
        '7b8b9363f597b4d438f657d821e6aff280cab8dcd95347b00a306b4ca20a8a23',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Chart Overlays Action', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('h7W7N4ZKWd', 'Chart Overlays Action', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Chart Overlays Action',
        eventProperties,
        'h7W7N4ZKWd',
        '7b8b9363f597b4d438f657d821e6aff280cab8dcd95347b00a306b4ca20a8a23',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Chart Overlays Action', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OrderBookClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  swyftxPro: string;
}
/**
 * Order Book Clicked: when a user interacts with the order book to fill price field for a limit order
 *
 * When to trigger this event:
 * 1. Clicking on an order book row when Trigger order type selected to populate the Price field
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/UNo2mcAV0W/trigger/0tOLWmxYX
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.swyftxPro: Differentiator for actions happening within Swyftx Pro UI
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/UNo2mcAV0W}
 */
export function orderBookClicked(properties: OrderBookClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'DVYn9DJjX', name: 'swyftx_pro', value: properties.swyftxPro });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'UNo2mcAV0W',
        '062d6ba70c9481d9b74693491c0902a6a1433482b3b2808ca837910ae097e3a7',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Order Book Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('UNo2mcAV0W', 'Order Book Clicked', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Order Book Clicked',
        eventProperties,
        'UNo2mcAV0W',
        '062d6ba70c9481d9b74693491c0902a6a1433482b3b2808ca837910ae097e3a7',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Order Book Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AlertsUIClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Alerts UI Clicked: When a user accesses the Alert Home / single alert page

either from single asset page or dashboard
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/UdNz8CGd5s/trigger/iWSTWT8hu
 * 2. 
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/UdNz8CGd5s/trigger/paJaZRWXs
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/UdNz8CGd5s}
 */
export function alertsUiClicked(properties: AlertsUIClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'UdNz8CGd5s',
        '125dad25fd2897a0311db3d05b231401c9af019018432e74dc1b5f5f217e2dab',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Alerts UI Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('UdNz8CGd5s', 'Alerts UI Clicked', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Alerts UI Clicked',
        eventProperties,
        'UdNz8CGd5s',
        '125dad25fd2897a0311db3d05b231401c9af019018432e74dc1b5f5f217e2dab',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Alerts UI Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PriceAlertMultiMinusAssetCreatedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  alertType: string;
  assetIds: number[];
}
/**
 * Price Alert Multi-Asset Created: Capturing the FE flow when a user selects multiple assets when creating a volatility alert
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Obxk7xZRne/trigger/cJMOP1aee
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.alertType: type of price alert - volatility vs. price alert
 * @param properties.assetIds: The list of asset ID's
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Obxk7xZRne}
 */
export function priceAlertMultiAssetCreated(properties: PriceAlertMultiMinusAssetCreatedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0tSho_u9b', name: 'alert_type', value: properties.alertType });
  eventPropertiesArray.push({ id: 'j2g-Engvkm', name: 'asset_ids', value: properties.assetIds });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Obxk7xZRne',
        '9105a3ca20045111dfb8cb1a2b340f678c1c74ebc980a5c746868a93bd9a1e0c',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Price Alert Multi-Asset Created', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Obxk7xZRne',
        'Price Alert Multi-Asset Created',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Price Alert Multi-Asset Created',
        eventProperties,
        'Obxk7xZRne',
        '9105a3ca20045111dfb8cb1a2b340f678c1c74ebc980a5c746868a93bd9a1e0c',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Price Alert Multi-Asset Created', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AssetSwitcherClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  fromAssetsAfter: FromAssetsAfter[];
  toAssetsAfter: ToAssetsAfter[];
  fromAssetsBefore: FromAssetsBefore[];
  toAssetsBefore: ToAssetsBefore[];
}
/**
 * Asset Switcher Clicked: Triggered when the asset switcher button is pressed on the Trade page.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/tocZ5y3AS7/trigger/XUWfTRSRT
 * 2.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/tocZ5y3AS7/trigger/MvEjrYJLV
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.fromAssetsAfter: state of the from field in the trade panel after action executed
 * @param properties.toAssetsAfter: state of the to field in the trade panel after action executed
 * @param properties.fromAssetsBefore: state of the from field in the trade panel before action executed
 * @param properties.toAssetsBefore: state of the to field in the trade panel before action executed
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/tocZ5y3AS7}
 */
export function assetSwitcherClicked(properties: AssetSwitcherClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({
    id: 'llem1u6Fj',
    name: 'fromAssetsAfter',
    value: properties.fromAssetsAfter.map(function (value) {
      return {
        asset_code: value.assetCode,
        asset_id: value.assetId,
      };
    }),
  });
  eventPropertiesArray.push({
    id: '_O9HojtY9',
    name: 'toAssetsAfter',
    value: properties.toAssetsAfter.map(function (value) {
      return {
        asset_id: value.assetId,
        asset_code: value.assetCode,
      };
    }),
  });
  eventPropertiesArray.push({
    id: '3fTNXgRcp',
    name: 'fromAssetsBefore',
    value: properties.fromAssetsBefore.map(function (value) {
      return {
        asset_id: value.assetId,
        asset_code: value.assetCode,
      };
    }),
  });
  eventPropertiesArray.push({
    id: 'vpkPVgq6_',
    name: 'toAssetsBefore',
    value: properties.toAssetsBefore.map(function (value) {
      return {
        asset_id: value.assetId,
        asset_code: value.assetCode,
      };
    }),
  });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertFromAssetsAfter(properties.fromAssetsAfter));
    messages = messages.concat(assertToAssetsAfter(properties.toAssetsAfter));
    messages = messages.concat(assertFromAssetsBefore(properties.fromAssetsBefore));
    messages = messages.concat(assertToAssetsBefore(properties.toAssetsBefore));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'tocZ5y3AS7',
        '5eac244474d549422aa674d8abe36c74acf3dd235607a3d95cf0641aa5a4e606',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Asset Switcher Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'tocZ5y3AS7',
        'Asset Switcher Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Asset Switcher Clicked': " + messages[0]!.message);
      }
    } else {
      messages.forEach(function (m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Asset Switcher Clicked',
        eventProperties,
        'tocZ5y3AS7',
        '5eac244474d549422aa674d8abe36c74acf3dd235607a3d95cf0641aa5a4e606',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Asset Switcher Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface FeeBreakdownModalClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Fee Breakdown Modal Clicked: Fee breakdown ' i ' button pressed
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/RgyzemgIad/trigger/j0quSPQZW
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/RgyzemgIad}
 */
export function feeBreakdownModalClicked(properties: FeeBreakdownModalClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'RgyzemgIad',
        '7d9c8256d0bd08dbe76586365d93cfd01d39258106fcf41dcd370aa6e0d9448c',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Fee Breakdown Modal Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'RgyzemgIad',
        'Fee Breakdown Modal Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Fee Breakdown Modal Clicked',
        eventProperties,
        'RgyzemgIad',
        '7d9c8256d0bd08dbe76586365d93cfd01d39258106fcf41dcd370aa6e0d9448c',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Fee Breakdown Modal Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AssetSwitcherErrorTriggeredProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  fromAssets: FromAssets[];
  toAssets: ToAssets[];
  error: ErrorValueType[];
}
/**
 * Asset Switcher Error Triggered: Triggered when the asset switcher button is pressed on the Trade page and results in an error state.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/mPIKIMSmH/trigger/teErHZAqyb
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.fromAssets: no description
 * @param properties.toAssets: no description
 * @param properties.error: The error state that was triggered by swapping the to and from assets.
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/mPIKIMSmH}
 */
export function assetSwitcherErrorTriggered(properties: AssetSwitcherErrorTriggeredProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({
    id: '0EFQhKJ5ZM',
    name: 'fromAssets',
    value: properties.fromAssets.map(function (value) {
      return {
        asset_id: value.assetId,
        asset_code: value.assetCode,
      };
    }),
  });
  eventPropertiesArray.push({
    id: 'k_B9pQ8fRP',
    name: 'toAssets',
    value: properties.toAssets.map(function (value) {
      return {
        asset_id: value.assetId,
        asset_code: value.assetCode,
      };
    }),
  });
  eventPropertiesArray.push({ id: 'VdlYWGcEc', name: 'error', value: properties.error });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertFromAssets(properties.fromAssets));
    messages = messages.concat(assertToAssets(properties.toAssets));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'mPIKIMSmH',
        '570ccbe56e39bc5cef96298e13f040c7f3bacf979b19c984ccdc214b9a787b85',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Asset Switcher Error Triggered', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'mPIKIMSmH',
        'Asset Switcher Error Triggered',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Asset Switcher Error Triggered': " + messages[0]!.message);
      }
    } else {
      messages.forEach(function (m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Asset Switcher Error Triggered',
        eventProperties,
        'mPIKIMSmH',
        '570ccbe56e39bc5cef96298e13f040c7f3bacf979b19c984ccdc214b9a787b85',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Asset Switcher Error Triggered', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AssetDiscoveryABTestInteractionProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  buttonName: string;
  modalName: ModalNameValueType | null | undefined;
}
/**
 * Asset Discovery A/B Test Interaction: CTA / button clicks on the Asset Discovery (v4) A/B test modals across web and mobile. modal_name is used to differenciate between test A and test B
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.buttonName: The label text used directly in/on the button (eg. Buy, Sell, Quick Buy, Deposit)
 * @param properties.modalName: Name of the modal in question (optional)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/yA21_jUx78}
 */
export function assetDiscoveryAbTestInteraction(properties: AssetDiscoveryABTestInteractionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'nixKBhAtEi', name: 'button_name', value: properties.buttonName });
  properties.modalName !== undefined && properties.modalName !== null
    ? eventPropertiesArray.push({ id: 'NO9CObS3y', name: 'modal_name', value: properties.modalName })
    : eventPropertiesArray.push({ id: 'NO9CObS3y', name: 'modal_name', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'yA21_jUx78',
        '88cb9b5d091892e2d5166c5e3b17c3281baf924e7abec906260db0e600cae660',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Asset Discovery A/B Test Interaction', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'yA21_jUx78',
        'Asset Discovery A/B Test Interaction',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Asset Discovery A/B Test Interaction',
        eventProperties,
        'yA21_jUx78',
        '88cb9b5d091892e2d5166c5e3b17c3281baf924e7abec906260db0e600cae660',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Asset Discovery A/B Test Interaction', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AssetDiscoveryABTestImpressionProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  modalName: ModalNameValueType;
}
/**
 * Asset Discovery A/B Test Impression: The impression/view/open event when the ADv4 A/B Test modal appears for a user
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.modalName: Name of the modal in question (optional)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/XJ5oq1m0s-}
 */
export function assetDiscoveryAbTestImpression(properties: AssetDiscoveryABTestImpressionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'NO9CObS3y', name: 'modal_name', value: properties.modalName });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'XJ5oq1m0s-',
        '085250e820366a68a9caeec3f8225360f5a89f153aa7d78cc20fbc2d6684fd6d',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Asset Discovery A/B Test Impression', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'XJ5oq1m0s-',
        'Asset Discovery A/B Test Impression',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Asset Discovery A/B Test Impression',
        eventProperties,
        'XJ5oq1m0s-',
        '085250e820366a68a9caeec3f8225360f5a89f153aa7d78cc20fbc2d6684fd6d',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Asset Discovery A/B Test Impression', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface QuickBuyErrorTextTappedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  errorLinkType: ErrorLinkTypeValueType;
}
/**
 * Quick Buy Error Text Tapped: Triggered when the error text link of quick buy is tapped.
 *
 * When to trigger this event:
 * 1. The link text in the error description is tapped.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/FjdqN8l1oe/trigger/NBSWDF1iim
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.errorLinkType: The sub-type of error link that was pressed in Quick Buy interface.
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/FjdqN8l1oe}
 */
export function quickBuyErrorTextTapped(properties: QuickBuyErrorTextTappedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: '0YOK2bBoX', name: 'error_link_type', value: properties.errorLinkType });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'FjdqN8l1oe',
        'b3e7921a7ed0cf1635075588a8b0698c61df7e8694ffbbfd048b05ffe037583a',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Quick Buy Error Text Tapped', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'FjdqN8l1oe',
        'Quick Buy Error Text Tapped',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Quick Buy Error Text Tapped',
        eventProperties,
        'FjdqN8l1oe',
        'b3e7921a7ed0cf1635075588a8b0698c61df7e8694ffbbfd048b05ffe037583a',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Quick Buy Error Text Tapped', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ModalOpenedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  modalName: ModalNameValueType;
}
/**
 * Modal Opened: When a modal (modal, dialog, popup, bottom sheet or drawer) appears in the UI.
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.modalName: Name of the modal in question (optional)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/HeKdbxwT39I}
 */
export function modalOpened(properties: ModalOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'NO9CObS3y', name: 'modal_name', value: properties.modalName });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'HeKdbxwT39I',
        'd4731d78d1a751c450425793d7638cfadb6cede4e561b8bf98ecfc242c64751f',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Modal Opened', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('HeKdbxwT39I', 'Modal Opened', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Modal Opened',
        eventProperties,
        'HeKdbxwT39I',
        'd4731d78d1a751c450425793d7638cfadb6cede4e561b8bf98ecfc242c64751f',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Modal Opened', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LoanApplicationSubmittedFEProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  loanTypeFe: LoanTypeFeValueType;
  purposeOfLoan: PurposeOfLoanValueType;
  purposeOfLoanOther: string | null | undefined;
  loanTermFe: string | null | undefined;
  loanCollateralAmount: string;
  loanBorrowAmount: string;
  loanExceedsCurrentBalance: boolean;
}
/**
 * Loan Application Submitted FE: When a user submits a loan application on the Crypto Backed Loans landing page.
 *
 * When to trigger this event:
 * 1. User fills in the EOI form and clicks 'Submit' button.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/LJo1G-nB3cP/trigger/ZMCKiKrV0WS
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.loanTypeFe: Describes the type of loan eg. Credit or Fixed Term
 * @param properties.purposeOfLoan: The purpose of loan the user has selected for a loan application.
 * @param properties.purposeOfLoanOther: The reason a user has input into the text field when they select 'Other' as the Purpose of Loan reason.
 * @param properties.loanTermFe: The loan term the user has selected on a loan application. Only captured if user applies for a Fixed Term loan.
 * @param properties.loanCollateralAmount: The amount of collateral a user has input on a loan application.
 * @param properties.loanBorrowAmount: The borrow amount the user has input on a loan application.
 * @param properties.loanExceedsCurrentBalance: Determines the collateral amount the user requested for a Loan is higher than their current account balance.
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/LJo1G-nB3cP}
 */
export function loanApplicationSubmittedFe(properties: LoanApplicationSubmittedFEProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'g0s-Ntwc9', name: 'loan_type_fe', value: properties.loanTypeFe });
  eventPropertiesArray.push({ id: '-Z-Kzgc3r', name: 'purpose_of_loan', value: properties.purposeOfLoan });
  properties.purposeOfLoanOther !== undefined && properties.purposeOfLoanOther !== null
    ? eventPropertiesArray.push({
        id: '3BO1U9ZvC',
        name: 'purpose_of_loan_other',
        value: properties.purposeOfLoanOther,
      })
    : eventPropertiesArray.push({ id: '3BO1U9ZvC', name: 'purpose_of_loan_other', value: null });
  properties.loanTermFe !== undefined && properties.loanTermFe !== null
    ? eventPropertiesArray.push({ id: 'QHAjO2ian', name: 'loan_term_fe', value: properties.loanTermFe })
    : eventPropertiesArray.push({ id: 'QHAjO2ian', name: 'loan_term_fe', value: null });
  eventPropertiesArray.push({
    id: 'rXvh-L5iQ',
    name: 'loan_collateral_amount',
    value: properties.loanCollateralAmount,
  });
  eventPropertiesArray.push({ id: 'NX72xujjt', name: 'loan_borrow_amount', value: properties.loanBorrowAmount });
  eventPropertiesArray.push({
    id: 'PxGKMuVmD',
    name: 'loan_exceeds_current_balance',
    value: properties.loanExceedsCurrentBalance,
  });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'LJo1G-nB3cP',
        '59d62e3c60c2aa14f29ac5235ba099605cd2ab1d29474099031010bd1d298c00',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Loan Application Submitted FE', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'LJo1G-nB3cP',
        'Loan Application Submitted FE',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Loan Application Submitted FE',
        eventProperties,
        'LJo1G-nB3cP',
        '59d62e3c60c2aa14f29ac5235ba099605cd2ab1d29474099031010bd1d298c00',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Loan Application Submitted FE', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ViewedLoansPageProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
}
/**
 * Viewed Loans Page: When a user visits the Loans page.
 *
 * When to trigger this event:
 * 1. User visits the /loans page on Web.
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/RNK8X--ZSgiv/trigger/iF4SzCR9sFI
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/RNK8X--ZSgiv}
 */
export function viewedLoansPage(properties: ViewedLoansPageProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'RNK8X--ZSgiv',
        'e99dfe17add303902e1025362a4d49dd7d39bf02425ad8d99402f5f25cdfab36',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Viewed Loans Page', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('RNK8X--ZSgiv', 'Viewed Loans Page', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Viewed Loans Page',
        eventProperties,
        'RNK8X--ZSgiv',
        'e99dfe17add303902e1025362a4d49dd7d39bf02425ad8d99402f5f25cdfab36',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Viewed Loans Page', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CTAClickReverificationProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  requiredBy: string;
  country: string | null | undefined;
  reveriDvsStatus: ReveriDvsStatusValueType;
}
/**
 * CTA Click Reverification: Customer clicks on the reverification dashboard card or profile banner to begin the confirm details flow
 *
 * When to trigger this event:
 * 1. App Dashboard CTA
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/4cd81c46-0c16-45b1-a593-e45117cc3416/trigger/FFhCWgRrSGORcnCUHlyeQ
 * 2. App Profile CTA
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/4cd81c46-0c16-45b1-a593-e45117cc3416/trigger/6dZIl1AKCuaQtYPa9R2Mc
 * 3. Web Dashboard CTA
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/4cd81c46-0c16-45b1-a593-e45117cc3416/trigger/cVj35FXOpyYS4-WT8Nols
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.requiredBy: The datetime the process must be completed by
 * @param properties.country: Two-letter country code representing what country the user has selected. (Note: This is used for signup which is residency, and verification which is citizenship and/or current residency)
 * @param properties.reveriDvsStatus: Describes the DVS status of a user during reverification
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/4cd81c46-0c16-45b1-a593-e45117cc3416}
 */
export function ctaClickReverification(properties: CTAClickReverificationProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'CV4rBVvQIshaulMo92tBS', name: 'required_by', value: properties.requiredBy });
  properties.country !== undefined && properties.country !== null
    ? eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: properties.country })
    : eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: null });
  eventPropertiesArray.push({
    id: 'ejzT19oGWPbY1-LWmNnXA',
    name: 'reveri_dvs_status',
    value: properties.reveriDvsStatus,
  });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '4cd81c46-0c16-45b1-a593-e45117cc3416',
        '574a91aa20a3d75169aab1b99f57c91a70d654f3381ce6334e0c6e9257e1eeb9',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('CTA Click Reverification', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '4cd81c46-0c16-45b1-a593-e45117cc3416',
        'CTA Click Reverification',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'CTA Click Reverification',
        eventProperties,
        '4cd81c46-0c16-45b1-a593-e45117cc3416',
        '574a91aa20a3d75169aab1b99f57c91a70d654f3381ce6334e0c6e9257e1eeb9',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('CTA Click Reverification', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CTAClickReveriDVSProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  requiredBy: string;
  country: string | null | undefined;
  reveriDvsStatus: ReveriDvsStatusValueType;
}
/**
 * CTA Click Reveri DVS: Customer clicks on the reverification dashboard card or profile banner to begin the DVS flow
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.requiredBy: The datetime the process must be completed by
 * @param properties.country: Two-letter country code representing what country the user has selected. (Note: This is used for signup which is residency, and verification which is citizenship and/or current residency)
 * @param properties.reveriDvsStatus: Describes the DVS status of a user during reverification
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/rKtTraoOK-62rhlgNhYMo}
 */
export function ctaClickReveriDvs(properties: CTAClickReveriDVSProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'CV4rBVvQIshaulMo92tBS', name: 'required_by', value: properties.requiredBy });
  properties.country !== undefined && properties.country !== null
    ? eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: properties.country })
    : eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: null });
  eventPropertiesArray.push({
    id: 'ejzT19oGWPbY1-LWmNnXA',
    name: 'reveri_dvs_status',
    value: properties.reveriDvsStatus,
  });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'rKtTraoOK-62rhlgNhYMo',
        '21b31a7f892aad3b032b64ca4430cafd5c31cbff948404642e2b565d63b5716e',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('CTA Click Reveri DVS', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'rKtTraoOK-62rhlgNhYMo',
        'CTA Click Reveri DVS',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'CTA Click Reveri DVS',
        eventProperties,
        'rKtTraoOK-62rhlgNhYMo',
        '21b31a7f892aad3b032b64ca4430cafd5c31cbff948404642e2b565d63b5716e',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('CTA Click Reveri DVS', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ConfirmDetailsStepStartedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  stepId: string;
  requiredBy: string;
  country: string | null | undefined;
}
/**
 * Confirm Details Step Started: Tracks the steps of the confirm details flow; confirming DOB, reviewing details, editing name, editing address, and OTP authentication before submitting. Editing name and address are not mandatory steps.
 *
 * When to trigger this event:
 * 1. DOB Started
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/qZVEhqwBF4mVSsDOyGjPT/trigger/kGUCiX0lBH7kWInyj2ctn
 * 2. Review Details Started
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/qZVEhqwBF4mVSsDOyGjPT/trigger/gqw3ioKV4LWZTrpTxUx69
 * 3. OTP Started
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/qZVEhqwBF4mVSsDOyGjPT/trigger/FOZAtC8gF9_8C16xB5b8-
 * 4. Update Address Started
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/qZVEhqwBF4mVSsDOyGjPT/trigger/whlCKhquYYeFxtPK0EugL
 * 5. Update Name Started
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/qZVEhqwBF4mVSsDOyGjPT/trigger/n4nTC3ZSr7T-jeHxgxz2S
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.stepId: no description
 * @param properties.requiredBy: The datetime the process must be completed by
 * @param properties.country: Two-letter country code representing what country the user has selected. (Note: This is used for signup which is residency, and verification which is citizenship and/or current residency)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/qZVEhqwBF4mVSsDOyGjPT}
 */
export function confirmDetailsStepStarted(properties: ConfirmDetailsStepStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId });
  eventPropertiesArray.push({ id: 'CV4rBVvQIshaulMo92tBS', name: 'required_by', value: properties.requiredBy });
  properties.country !== undefined && properties.country !== null
    ? eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: properties.country })
    : eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'qZVEhqwBF4mVSsDOyGjPT',
        'd40bf2255e4b5662559cc64a208be8956492b071a4dd97eb8daaddb5df2b8032',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Confirm Details Step Started', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'qZVEhqwBF4mVSsDOyGjPT',
        'Confirm Details Step Started',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Confirm Details Step Started',
        eventProperties,
        'qZVEhqwBF4mVSsDOyGjPT',
        'd40bf2255e4b5662559cc64a208be8956492b071a4dd97eb8daaddb5df2b8032',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Confirm Details Step Started', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ConfirmDetailsStepCompletedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  stepId: string;
  requiredBy: string;
  country: string | null | undefined;
}
/**
 * Confirm Details Step Completed: Tracks when each step of the confirm details flow is completed; confirming DOB, reviewing details, editing name, editing address, and OTP authentication before submitting. Editing name and address are not mandatory steps.
 *
 * When to trigger this event:
 * 1. DOB Completed
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/yHutXcwPPA3mh-mxxIVLe/trigger/lDSOPct21lxqOP_eSB6KK
 * 2. Review Details Completed
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/yHutXcwPPA3mh-mxxIVLe/trigger/BaThXLp0V6o7x7nKp9Agi
 * 3. OTP Completed
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/yHutXcwPPA3mh-mxxIVLe/trigger/wRWugq2UtfKDQPLGHglAd
 * 4. Update Address Completed
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/yHutXcwPPA3mh-mxxIVLe/trigger/DByptmbB1Q-pBhYmi-B91
 * 5. Update Name Completed
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/yHutXcwPPA3mh-mxxIVLe/trigger/TN_yvm8dvsrqLDcQctNep
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.stepId: no description
 * @param properties.requiredBy: The datetime the process must be completed by
 * @param properties.country: Two-letter country code representing what country the user has selected. (Note: This is used for signup which is residency, and verification which is citizenship and/or current residency)
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/yHutXcwPPA3mh-mxxIVLe}
 */
export function confirmDetailsStepCompleted(properties: ConfirmDetailsStepCompletedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId });
  eventPropertiesArray.push({ id: 'CV4rBVvQIshaulMo92tBS', name: 'required_by', value: properties.requiredBy });
  properties.country !== undefined && properties.country !== null
    ? eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: properties.country })
    : eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'yHutXcwPPA3mh-mxxIVLe',
        '1a05eaaab5da81ce464006183c18bf3bb731dbeb7b30b8e4a71487d419e65ca0',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Confirm Details Step Completed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'yHutXcwPPA3mh-mxxIVLe',
        'Confirm Details Step Completed',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Confirm Details Step Completed',
        eventProperties,
        'yHutXcwPPA3mh-mxxIVLe',
        '1a05eaaab5da81ce464006183c18bf3bb731dbeb7b30b8e4a71487d419e65ca0',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Confirm Details Step Completed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ReveriDVSStartedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  country: string | null | undefined;
  requiredBy: string;
}
/**
 * Reveri DVS Started: Triggered when the customer sees the reverification DVS/GreenID flow
 *
 * When to trigger this event:
 * 1. Green ID
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/q4BOz-9u32vD85TaL8PlE/trigger/Abol0jitC10RHNSTR9iJi
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.country: Two-letter country code representing what country the user has selected. (Note: This is used for signup which is residency, and verification which is citizenship and/or current residency)
 * @param properties.requiredBy: The datetime the process must be completed by
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/q4BOz-9u32vD85TaL8PlE}
 */
export function reveriDvsStarted(properties: ReveriDVSStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.country !== undefined && properties.country !== null
    ? eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: properties.country })
    : eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: null });
  eventPropertiesArray.push({ id: 'CV4rBVvQIshaulMo92tBS', name: 'required_by', value: properties.requiredBy });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'q4BOz-9u32vD85TaL8PlE',
        'd625b2d53407b8d484b9a082eede14aa9a00ae98c3fc568ff8eb3cba2733ebf2',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Reveri DVS Started', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'q4BOz-9u32vD85TaL8PlE',
        'Reveri DVS Started',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Reveri DVS Started',
        eventProperties,
        'q4BOz-9u32vD85TaL8PlE',
        'd625b2d53407b8d484b9a082eede14aa9a00ae98c3fc568ff8eb3cba2733ebf2',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Reveri DVS Started', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ReveriDVSSuccessProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  country: string | null | undefined;
  requiredBy: string;
}
/**
 * Reveri DVS Success: Triggered when the customer submits the DVS check and a successful response is received from the BE, triggering a FE toast
 *
 * When to trigger this event:
 * 1. Success toast post GreenID
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/En70Y1EiTS_5P77OXqlGf/trigger/55Y-O5CIK22FWoFpH9-c9
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.country: Two-letter country code representing what country the user has selected. (Note: This is used for signup which is residency, and verification which is citizenship and/or current residency)
 * @param properties.requiredBy: The datetime the process must be completed by
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/En70Y1EiTS_5P77OXqlGf}
 */
export function reveriDvsSuccess(properties: ReveriDVSSuccessProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.country !== undefined && properties.country !== null
    ? eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: properties.country })
    : eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: null });
  eventPropertiesArray.push({ id: 'CV4rBVvQIshaulMo92tBS', name: 'required_by', value: properties.requiredBy });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'En70Y1EiTS_5P77OXqlGf',
        '3ef42d985bf39885514cee0c08f2ea0b25eaf01ebd6f21913a1064b26ec692a2',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Reveri DVS Success', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'En70Y1EiTS_5P77OXqlGf',
        'Reveri DVS Success',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Reveri DVS Success',
        eventProperties,
        'En70Y1EiTS_5P77OXqlGf',
        '3ef42d985bf39885514cee0c08f2ea0b25eaf01ebd6f21913a1064b26ec692a2',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Reveri DVS Success', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ReveriDVSFailProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  country: string | null | undefined;
  requiredBy: string;
}
/**
 * Reveri DVS Fail : Triggered when the customer's reverification status is failed and they are shown a dashboard banner saying their account is closed, for the first time only
 *
 * When to trigger this event:
 * 1. Dashboard modal for account suspended
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/99c2f226-a95d-4f5a-b32b-2c8a542f0ae0/trigger/t0wTfXRTgexGlykQj51DQ
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.country: Two-letter country code representing what country the user has selected. (Note: This is used for signup which is residency, and verification which is citizenship and/or current residency)
 * @param properties.requiredBy: The datetime the process must be completed by
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/99c2f226-a95d-4f5a-b32b-2c8a542f0ae0}
 */
export function reveriDvsFail(properties: ReveriDVSFailProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.country !== undefined && properties.country !== null
    ? eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: properties.country })
    : eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: null });
  eventPropertiesArray.push({ id: 'CV4rBVvQIshaulMo92tBS', name: 'required_by', value: properties.requiredBy });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '99c2f226-a95d-4f5a-b32b-2c8a542f0ae0',
        '2e20eb97d42722d119c2d5cc09c2ea46af981890843c9db6009c11800cf7f20c',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Reveri DVS Fail ', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '99c2f226-a95d-4f5a-b32b-2c8a542f0ae0',
        'Reveri DVS Fail ',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Reveri DVS Fail ',
        eventProperties,
        '99c2f226-a95d-4f5a-b32b-2c8a542f0ae0',
        '2e20eb97d42722d119c2d5cc09c2ea46af981890843c9db6009c11800cf7f20c',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Reveri DVS Fail ', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ReveriDVSPendingProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  country: string | null | undefined;
  requiredBy: string;
}
/**
 * Reveri DVS Pending: Triggered when the customer's reverification status is in progress and they are shown a dashboard banner saying we have received their ID docs, for the first time only
 *
 * When to trigger this event:
 * 1. Dashboard modal GreenID verification pending
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/15fCz1AaxrHO-HLeiSATk/trigger/CiFYsug5IvsDbVlN4k1c5
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.country: Two-letter country code representing what country the user has selected. (Note: This is used for signup which is residency, and verification which is citizenship and/or current residency)
 * @param properties.requiredBy: The datetime the process must be completed by
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/15fCz1AaxrHO-HLeiSATk}
 */
export function reveriDvsPending(properties: ReveriDVSPendingProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  properties.country !== undefined && properties.country !== null
    ? eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: properties.country })
    : eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: null });
  eventPropertiesArray.push({ id: 'CV4rBVvQIshaulMo92tBS', name: 'required_by', value: properties.requiredBy });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '15fCz1AaxrHO-HLeiSATk',
        '99b1a9b89eaaeb0da1bdff286a59ef7d614aaeed300c978cb5778e1bc2dcb413',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Reveri DVS Pending', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '15fCz1AaxrHO-HLeiSATk',
        'Reveri DVS Pending',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Reveri DVS Pending',
        eventProperties,
        '15fCz1AaxrHO-HLeiSATk',
        '99b1a9b89eaaeb0da1bdff286a59ef7d614aaeed300c978cb5778e1bc2dcb413',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Reveri DVS Pending', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CTAClickReverificationLapsedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  requiredBy: string;
  country: string | null | undefined;
  reveriDvsStatus: ReveriDvsStatusValueType;
}
/**
 * CTA Click Reverification Lapsed : Customer who has lapsed their reverification clicks on the reverification dashboard card or profile banner to begin the confirm details flow
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.requiredBy: The datetime the process must be completed by
 * @param properties.country: Two-letter country code representing what country the user has selected. (Note: This is used for signup which is residency, and verification which is citizenship and/or current residency)
 * @param properties.reveriDvsStatus: Describes the DVS status of a user during reverification
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/1a5d7f78-0853-4761-84ff-296a6844cb5a}
 */
export function ctaClickReverificationLapsed(properties: CTAClickReverificationLapsedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'CV4rBVvQIshaulMo92tBS', name: 'required_by', value: properties.requiredBy });
  properties.country !== undefined && properties.country !== null
    ? eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: properties.country })
    : eventPropertiesArray.push({ id: '1NhAJ1z9tGS8', name: 'country', value: null });
  eventPropertiesArray.push({
    id: 'ejzT19oGWPbY1-LWmNnXA',
    name: 'reveri_dvs_status',
    value: properties.reveriDvsStatus,
  });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '1a5d7f78-0853-4761-84ff-296a6844cb5a',
        '18719664ee04e4fd1fe1319e9f417bb91a8781991d7941f0e7ccc606e0de1eca',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('CTA Click Reverification Lapsed ', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '1a5d7f78-0853-4761-84ff-296a6844cb5a',
        'CTA Click Reverification Lapsed ',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'CTA Click Reverification Lapsed ',
        eventProperties,
        '1a5d7f78-0853-4761-84ff-296a6844cb5a',
        '18719664ee04e4fd1fe1319e9f417bb91a8781991d7941f0e7ccc606e0de1eca',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('CTA Click Reverification Lapsed ', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface EntityApplicationExitedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  stepId: string;
  platform: string | null | undefined;
}
/**
 * Entity Application Exited: User exited the entity application form.

Recreation of accidentally deleted event https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/QLWw7Ivdd/events/e/WE0FEj76L 
 * 
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.stepId: no description
 * @param properties.platform: Platform being used - web, mobile, or (not set) for API usage eg integrations, Widgets, etc

A property used for injection of information where there isn't context (e.g widgets, or Mobile Web in a webview that the mobile app opens)
 * 
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/c229353d-60f9-4164-8f01-e4639ed490fc}
 */
export function entityApplicationExited(properties: EntityApplicationExitedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId });
  properties.platform !== undefined && properties.platform !== null
    ? eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: properties.platform })
    : eventPropertiesArray.push({ id: 'jgdNUMjlhGBD', name: 'platform', value: null });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'c229353d-60f9-4164-8f01-e4639ed490fc',
        '615c2d502452286b0ef7b1c0cd21f574e8937a5303d3d8036c5a0b9f6f1be424',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Entity Application Exited', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'c229353d-60f9-4164-8f01-e4639ed490fc',
        'Entity Application Exited',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Entity Application Exited',
        eventProperties,
        'c229353d-60f9-4164-8f01-e4639ed490fc',
        '615c2d502452286b0ef7b1c0cd21f574e8937a5303d3d8036c5a0b9f6f1be424',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Entity Application Exited', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NavigationItemClickedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  menuLabel: MenuLabelValueType;
  navigationComponent: NavigationComponentValueType;
}
/**
 * Navigation Item Clicked: A user clicked on any menu/navigation item across any navigation (side menu, mobile menu, header bar on web, top nav on app, tab bar on app, quick actions on app).
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.menuLabel: The label shown on the menu item
 * @param properties.navigationComponent: no description
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/9_-zsEbaBpu3xDiykMpue}
 */
export function navigationItemClicked(properties: NavigationItemClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'zObtXbkq7Nun4Ycy4J19N', name: 'menu_label', value: properties.menuLabel });
  eventPropertiesArray.push({
    id: '14zUM7m4K3ysyJZ_Qd10v',
    name: 'navigation_component',
    value: properties.navigationComponent,
  });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '9_-zsEbaBpu3xDiykMpue',
        '5ab9a205316fe074113220ac3f67a61b86591aa38cf0da1fd1e09b0dbcf08828',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Navigation Item Clicked', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '9_-zsEbaBpu3xDiykMpue',
        'Navigation Item Clicked',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Navigation Item Clicked',
        eventProperties,
        '9_-zsEbaBpu3xDiykMpue',
        '5ab9a205316fe074113220ac3f67a61b86591aa38cf0da1fd1e09b0dbcf08828',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Navigation Item Clicked', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LoanApplicationStepStartedProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  stepId: string;
  loanId: string;
  loanType: LoanTypeValueType;
  loanSecurityAsset: string;
  loanTerm: string;
}
/**
 * Loan Application Step Started: {"ops":[{"insert":"When a user starts a step in Loan Application form.\n"}]}
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.stepId: no description
 * @param properties.loanId: {'ops':[{'insert':'The ID of the loan\n'}]}
 * @param properties.loanType: The type of the loan - FIXED_TERM or LINE_OF_CREDIT
 * @param properties.loanSecurityAsset: Crypto asset being used as the security for the loan
 * @param properties.loanTerm: {'ops':[{'insert':'The term (length) of the loan\n'}]}
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/Xxa-ssrtfOrBR2rT8J6-Z}
 */
export function loanApplicationStepStarted(properties: LoanApplicationStepStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'RE0AMGZo4g', name: 'stepId', value: properties.stepId });
  eventPropertiesArray.push({ id: 'zrHkiIZDYbTc9eqfjMU9d', name: 'loan_id', value: properties.loanId });
  eventPropertiesArray.push({ id: 'AmaQ37Lzr1ZjsvpAR_LH2', name: 'loan_type', value: properties.loanType });
  eventPropertiesArray.push({
    id: '_5KiKxjE4qRayMTr8-JHV',
    name: 'loan_security_asset',
    value: properties.loanSecurityAsset,
  });
  eventPropertiesArray.push({ id: 'QeF0ercl5plZiMOYWIqEm', name: 'loan_term', value: properties.loanTerm });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Xxa-ssrtfOrBR2rT8J6-Z',
        '87f249cedb68bef1ac93682a5728de1a940008be8c16ba4393bf3dd9ef6675e1',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Loan Application Step Started', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Xxa-ssrtfOrBR2rT8J6-Z',
        'Loan Application Step Started',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Loan Application Step Started',
        eventProperties,
        'Xxa-ssrtfOrBR2rT8J6-Z',
        '87f249cedb68bef1ac93682a5728de1a940008be8c16ba4393bf3dd9ef6675e1',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Loan Application Step Started', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PretotypeBannerCTAClickProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  pretotypeId: string;
}
/**
 * Pretotype Banner CTA Click: {"ops":[{"insert":"Customer clicks on a pretotype banner on the dashboard \n"}]}
 *
 * When to trigger this event:
 * 1. Pretotype banner on the dashboard
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/e474e79f-448b-43d6-a2d8-1a5c67cee674/trigger/BNw3fDwtY2xz7iAq8bKbx
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.pretotypeId: {'ops':[{'insert':'The label/name of the pretotype\n'}]}
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/e474e79f-448b-43d6-a2d8-1a5c67cee674}
 */
export function pretotypeBannerCtaClick(properties: PretotypeBannerCTAClickProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'OQCD6NTS_qO7Qe6m27Fma', name: 'pretotype_id', value: properties.pretotypeId });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'e474e79f-448b-43d6-a2d8-1a5c67cee674',
        '5eecdac710e8f19ec5eea26d370e1f19741a6da59f946bac0399792ccc0969c9',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Pretotype Banner CTA Click', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'e474e79f-448b-43d6-a2d8-1a5c67cee674',
        'Pretotype Banner CTA Click',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Pretotype Banner CTA Click',
        eventProperties,
        'e474e79f-448b-43d6-a2d8-1a5c67cee674',
        '5eecdac710e8f19ec5eea26d370e1f19741a6da59f946bac0399792ccc0969c9',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Pretotype Banner CTA Click', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PretotypeModalCTAClickProperties {
  isDemoMode: boolean;
  screen: string;
  baseCurrencyId: number;
  baseCurrencyCode: string;
  pretotypeId: string;
}
/**
 * Pretotype Modal CTA Click: {"ops":[{"insert":"Customer accepts the pretotype offer by clicking on the modal CTA \n"}]}
 *
 * When to trigger this event:
 * 1. Customer clicks the blue CTA button
 * View in Avo: https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/BitAwPKquNDboSwQ9H8H5/trigger/8ByivOPX-fe5P8lN5fF2R
 *
 * @param properties the properties associatied with this event
 * @param properties.isDemoMode: Whether the user was in demo mode when this action was performed
 * @param properties.screen: The screen this event fired from
 * @param properties.baseCurrencyId: The DB ID of the user's base currency asset eg 1, 36, 190
 * @param properties.baseCurrencyCode: The asset code of the user's base currency eg AUD, NZD, USD etc
 * @param properties.pretotypeId: {'ops':[{'insert':'The label/name of the pretotype\n'}]}
 *
 * @see {@link https://www.avo.app/schemas/6POyHovCvydDkrmCrKkd/branches/9Qo95R7tg/events/BitAwPKquNDboSwQ9H8H5}
 */
export function pretotypeModalCtaClick(properties: PretotypeModalCTAClickProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8OuNX-Xpw-', name: 'is_demo_mode', value: properties.isDemoMode });
  eventPropertiesArray.push({ id: 'SQcQIAEc2F', name: 'screen', value: properties.screen });
  eventPropertiesArray.push({ id: 'nzXhG6DInF', name: 'base_currency_id', value: properties.baseCurrencyId });
  eventPropertiesArray.push({ id: 'fIEF0R8x8t', name: 'base_currency_code', value: properties.baseCurrencyCode });
  eventPropertiesArray.push({ id: 'OQCD6NTS_qO7Qe6m27Fma', name: 'pretotype_id', value: properties.pretotypeId });
  eventPropertiesArray.push({ id: 'C7pAg5dgWT', name: 'service_name', value: sysServiceName });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'BitAwPKquNDboSwQ9H8H5',
        'bb041f6dd98f47e3a0176f08c73daf4e1ddf736417db80827883ae3dbf12c2ce',
        messages.map((m) =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('Pretotype Modal CTA Click', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'BitAwPKquNDboSwQ9H8H5',
        'Pretotype Modal CTA Click',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'Pretotype Modal CTA Click',
        eventProperties,
        'BitAwPKquNDboSwQ9H8H5',
        'bb041f6dd98f47e3a0176f08c73daf4e1ddf736417db80827883ae3dbf12c2ce',
      );
    }
    // destination RudderStack
    RudderStack.logEvent('Pretotype Modal CTA Click', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  PurposeOfLoan,
  ErrorLinkType,
  NavigationComponent,
  MarketTickerSort,
  LoanType,
  RegistrationAccountTypeSelected,
  CallToActionName,
  CallToActionLocation,
  TileName,
  EntityType,
  TableName,
  TemplateSource,
  ModalName,
  VerificationStep,
  GlobalSearchOpenMethod,
  Error,
  MarketTickerVisibleAssets,
  TableSortDirection,
  MarketTickerVariant,
  ReveriDvsStatus,
  LoanTypeFe,
  QuickFilterUsed,
  MemberType,
  AssetType,
  ChartType,
  TradeType,
  QuickBuyPresetAmount,
  TooltipType,
  MenuLabel,
  singleCategoryAssetFromAssetsTableOpened,
  singleCategoryPageOpened,
  tourExited,
  tourCompleted,
  tourStarted,
  tradeTypeSelected,
  untrackedItemClicked,
  viewedLatestNews,
  viewedLatestNewsOnAssetPage,
  viewedReferAFriendPage,
  whatsNewActionClicked,
  whatsNewModalClosed,
  withdrawSendNavClicked,
  whatsNewModalOpened,
  viewedSingleAssetPage,
  registerStarted,
  proceededWithCardDeposit,
  priceSideSelected,
  orderPlaced,
  orderDetailsReviewed,
  openedProfitAndStopLossModal,
  openedCategoryFilterDropdown,
  onboardingWizardStepComplete,
  uxFlowExited,
  noNewsReturned,
  onboardingWizardStepStarted,
  onboardingWizardBackClicked,
  onboardingWizardStarted,
  noNewsFilterAvailable,
  marketTickerToggled,
  migrateInitiated,
  marketTickerAssetClicked,
  koinlySsoSessionStarted,
  koinlyConnectAccountButtonClicked,
  highSlippageTrade,
  intervalSelected,
  indicatorSelected,
  fullscreenChartOpened,
  filteredCategoryFromTradePage,
  depositFundsTapped,
  demoModeToggled,
  dashboardLayoutSelectorModalOpened,
  dashboardLayoutChanged,
  createdTakeProfit,
  createdStopLoss,
  copiedReferAFriendLink,
  confirmedCardDetails,
  clickedShowMoreLatestNews,
  clickedPromotedCategoryFromAssetListPage,
  clickedNewsArticle,
  clickedAssetOnMoversDashboardTile,
  chartOpened,
  clickedPromotedCategoryFromTradePage,
  chartClosed,
  chartAreaClicked,
  clickedCardDeposit,
  categoryListOpened,
  changedTabOnMoversDashboardTile,
  cardDepositFailed,
  cardDepositSuccessful,
  bundleOpened,
  bundlesNavClicked,
  baseCurrencySelected,
  redirectToAffiliatePage,
  searchedLatestNews,
  viewedReferAFriendDashboardTile,
  sowStarted,
  sowStepCompleted,
  sowExited,
  sowSubmitted,
  sowAdditionalInformationSubmitted,
  closedProfitAndStopLossModal,
  clickedReferAFriendDashboardBanner,
  recurringOrderOpened,
  deepLinkCaptured,
  categoryListBuyButtonClicked,
  deepLinkHandled,
  filteredCategoryFromAssetListPage,
  clickedCategoryFromAssetPage,
  withdrawFundsTapped,
  migrateCheckboxAccepted,
  switchedNewsTab,
  recurringOrderCreated,
  recurringOrderUpsellClicked,
  refreshedLatestNews,
  categoryListSorted,
  learnArticleOpened,
  singleCategoryAssetFromMoversCardOpened,
  singleCategoryNewsArticleOpened,
  singleCategoryPageBuyBundleClicked,
  switchedLatestNewsView,
  migrateConfirmed,
  chartTypeSelected,
  singleCategoryPageTradeButtonClicked,
  sowStepStarted,
  sowBackClicked,
  updatedTradeAmount,
  switchedLimitAsset,
  clickedReviewTrade,
  clickedPreSelectedAmount,
  selectedTradeAsset,
  updatedPaymentOption,
  switchedTradeDirection,
  quickBuyTradeExecuted,
  quickBuyTradeCompleted,
  webIdentify,
  pageViewed,
  globalSearchBarOpened,
  globalSearchBarInputFieldCompleted,
  globalSearchBarResultClicked,
  viewedRegisterPage,
  gettingStartedTileOpened,
  assetSelected,
  recurringOrderCreationAmountSelected,
  followUpActionPromptClicked,
  clipboardCopyButtonClicked,
  checkboxTicked,
  viewedUniversalTradePage,
  openedAssetListDropdown,
  searchedInAssetDropdown,
  changedAssetViewed,
  openedAssetInfoModal,
  clickedLearnMoreOnAssetInfoModal,
  clickedOnTableRow,
  clickedButton,
  changedTableSort,
  changedTableFilter,
  marketTickerVariantChanged,
  marketTickerSortChanged,
  marketTickerVisibleAssetsChanged,
  assetAllocationLock,
  changedChartType,
  changedCandlestickTimeframe,
  changedCandleType,
  changedChartTimeframe,
  entityApplicationStarted,
  entityApplicationSubmitted,
  entityApplicationStepStarted,
  entityApplicationStepCompleted,
  userSkippedStep,
  entityApplicationCancelled,
  entityCtaClicked,
  tooltipClicked,
  supportLinkClicked,
  entityMemberAdded,
  entityMemberEdited,
  entityMemberRemoved,
  entityTypeChanged,
  entityPhoneConsultationCtaClicked,
  hideCreateEntityAccountButton,
  profileDropdownClicked,
  switchPlatformButtonClicked,
  settingsCogAction,
  hideWidgetAction,
  chartOverlaysAction,
  orderBookClicked,
  alertsUiClicked,
  priceAlertMultiAssetCreated,
  assetSwitcherClicked,
  feeBreakdownModalClicked,
  assetSwitcherErrorTriggered,
  assetDiscoveryAbTestInteraction,
  assetDiscoveryAbTestImpression,
  quickBuyErrorTextTapped,
  modalOpened,
  loanApplicationSubmittedFe,
  viewedLoansPage,
  ctaClickReverification,
  ctaClickReveriDvs,
  confirmDetailsStepStarted,
  confirmDetailsStepCompleted,
  reveriDvsStarted,
  reveriDvsSuccess,
  reveriDvsFail,
  reveriDvsPending,
  ctaClickReverificationLapsed,
  entityApplicationExited,
  navigationItemClicked,
  loanApplicationStepStarted,
  pretotypeBannerCtaClick,
  pretotypeModalCtaClick,
};

// AVOMODULEMAP:"GeneratedAvo"
// AVOEVENTMAP:["singleCategoryAssetFromAssetsTableOpened","singleCategoryPageOpened","tourExited","tourCompleted","tourStarted","tradeTypeSelected","untrackedItemClicked","viewedLatestNews","viewedLatestNewsOnAssetPage","viewedReferAFriendPage","whatsNewActionClicked","whatsNewModalClosed","withdrawSendNavClicked","whatsNewModalOpened","viewedSingleAssetPage","registerStarted","proceededWithCardDeposit","priceSideSelected","orderPlaced","orderDetailsReviewed","openedProfitAndStopLossModal","openedCategoryFilterDropdown","onboardingWizardStepComplete","uxFlowExited","noNewsReturned","onboardingWizardStepStarted","onboardingWizardBackClicked","onboardingWizardStarted","noNewsFilterAvailable","marketTickerToggled","migrateInitiated","marketTickerAssetClicked","koinlySsoSessionStarted","koinlyConnectAccountButtonClicked","highSlippageTrade","intervalSelected","indicatorSelected","fullscreenChartOpened","filteredCategoryFromTradePage","depositFundsTapped","demoModeToggled","dashboardLayoutSelectorModalOpened","dashboardLayoutChanged","createdTakeProfit","createdStopLoss","copiedReferAFriendLink","confirmedCardDetails","clickedShowMoreLatestNews","clickedPromotedCategoryFromAssetListPage","clickedNewsArticle","clickedAssetOnMoversDashboardTile","chartOpened","clickedPromotedCategoryFromTradePage","chartClosed","chartAreaClicked","clickedCardDeposit","categoryListOpened","changedTabOnMoversDashboardTile","cardDepositFailed","cardDepositSuccessful","bundleOpened","bundlesNavClicked","baseCurrencySelected","redirectToAffiliatePage","searchedLatestNews","viewedReferAFriendDashboardTile","sowStarted","sowStepCompleted","sowExited","sowSubmitted","sowAdditionalInformationSubmitted","closedProfitAndStopLossModal","clickedReferAFriendDashboardBanner","recurringOrderOpened","deepLinkCaptured","categoryListBuyButtonClicked","deepLinkHandled","filteredCategoryFromAssetListPage","clickedCategoryFromAssetPage","withdrawFundsTapped","migrateCheckboxAccepted","switchedNewsTab","recurringOrderCreated","recurringOrderUpsellClicked","refreshedLatestNews","categoryListSorted","learnArticleOpened","singleCategoryAssetFromMoversCardOpened","singleCategoryNewsArticleOpened","singleCategoryPageBuyBundleClicked","switchedLatestNewsView","migrateConfirmed","chartTypeSelected","singleCategoryPageTradeButtonClicked","sowStepStarted","sowBackClicked","updatedTradeAmount","switchedLimitAsset","clickedReviewTrade","clickedPreSelectedAmount","selectedTradeAsset","updatedPaymentOption","switchedTradeDirection","quickBuyTradeExecuted","quickBuyTradeCompleted","webIdentify","pageViewed","globalSearchBarOpened","globalSearchBarInputFieldCompleted","globalSearchBarResultClicked","viewedRegisterPage","gettingStartedTileOpened","assetSelected","recurringOrderCreationAmountSelected","followUpActionPromptClicked","clipboardCopyButtonClicked","checkboxTicked","viewedUniversalTradePage","openedAssetListDropdown","searchedInAssetDropdown","changedAssetViewed","openedAssetInfoModal","clickedLearnMoreOnAssetInfoModal","clickedOnTableRow","clickedButton","changedTableSort","changedTableFilter","marketTickerVariantChanged","marketTickerSortChanged","marketTickerVisibleAssetsChanged","assetAllocationLock","changedChartType","changedCandlestickTimeframe","changedCandleType","changedChartTimeframe","entityApplicationStarted","entityApplicationSubmitted","entityApplicationStepStarted","entityApplicationStepCompleted","userSkippedStep","entityApplicationCancelled","entityCtaClicked","tooltipClicked","supportLinkClicked","entityMemberAdded","entityMemberEdited","entityMemberRemoved","entityTypeChanged","entityPhoneConsultationCtaClicked","hideCreateEntityAccountButton","profileDropdownClicked","switchPlatformButtonClicked","settingsCogAction","hideWidgetAction","chartOverlaysAction","orderBookClicked","alertsUiClicked","priceAlertMultiAssetCreated","assetSwitcherClicked","feeBreakdownModalClicked","assetSwitcherErrorTriggered","assetDiscoveryAbTestInteraction","assetDiscoveryAbTestImpression","quickBuyErrorTextTapped","modalOpened","loanApplicationSubmittedFe","viewedLoansPage","ctaClickReverification","ctaClickReveriDvs","confirmDetailsStepStarted","confirmDetailsStepCompleted","reveriDvsStarted","reveriDvsSuccess","reveriDvsFail","reveriDvsPending","ctaClickReverificationLapsed","entityApplicationExited","navigationItemClicked","loanApplicationStepStarted","pretotypeBannerCtaClick","pretotypeModalCtaClick"]
